[
  {
    "id": 1,
    "zipcode": 1000,
    "city": "Brussel"
  },
  {
    "id": 2,
    "zipcode": 1020,
    "city": "Laken"
  },
  {
    "id": 3,
    "zipcode": 1030,
    "city": "Schaarbeek"
  },
  {
    "id": 4,
    "zipcode": 1040,
    "city": "Etterbeek"
  },
  {
    "id": 5,
    "zipcode": 1050,
    "city": "Elsene"
  },
  {
    "id": 6,
    "zipcode": 1060,
    "city": "Sint-Gillis"
  },
  {
    "id": 7,
    "zipcode": 1070,
    "city": "Anderlecht"
  },
  {
    "id": 8,
    "zipcode": 1080,
    "city": "Sint-Jans-Molenbeek"
  },
  {
    "id": 9,
    "zipcode": 1081,
    "city": "Koekelberg"
  },
  {
    "id": 10,
    "zipcode": 1082,
    "city": "Sint-Agatha-Berchem"
  },
  {
    "id": 11,
    "zipcode": 1083,
    "city": "Ganshoren"
  },
  {
    "id": 12,
    "zipcode": 1090,
    "city": "Jette"
  },
  {
    "id": 13,
    "zipcode": 1120,
    "city": "Neder-Over-Heembeek"
  },
  {
    "id": 14,
    "zipcode": 1130,
    "city": "Haren"
  },
  {
    "id": 15,
    "zipcode": 1140,
    "city": "Evere"
  },
  {
    "id": 16,
    "zipcode": 1150,
    "city": "Sint-Pieters-Woluwe"
  },
  {
    "id": 17,
    "zipcode": 1160,
    "city": "Oudergem"
  },
  {
    "id": 18,
    "zipcode": 1170,
    "city": "Watermaal-Bosvoorde"
  },
  {
    "id": 19,
    "zipcode": 1180,
    "city": "Ukkel"
  },
  {
    "id": 20,
    "zipcode": 1190,
    "city": "Vorst"
  },
  {
    "id": 21,
    "zipcode": 1200,
    "city": "Sint-Lambrechts-Woluwe"
  },
  {
    "id": 22,
    "zipcode": 1210,
    "city": "Sint-Joost-ten-Node"
  },
  {
    "id": 23,
    "zipcode": 1300,
    "city": "Limal"
  },
  {
    "id": 24,
    "zipcode": 1300,
    "city": "Wavre"
  },
  {
    "id": 25,
    "zipcode": 1301,
    "city": "Bierges"
  },
  {
    "id": 26,
    "zipcode": 1310,
    "city": "La Hulpe"
  },
  {
    "id": 27,
    "zipcode": 1315,
    "city": "Glimes"
  },
  {
    "id": 28,
    "zipcode": 1315,
    "city": "Opprebais"
  },
  {
    "id": 29,
    "zipcode": 1315,
    "city": "Piétrebais"
  },
  {
    "id": 30,
    "zipcode": 1315,
    "city": "Roux-Miroir"
  },
  {
    "id": 31,
    "zipcode": 1315,
    "city": "Incourt"
  },
  {
    "id": 32,
    "zipcode": 1320,
    "city": "Hamme-Mille"
  },
  {
    "id": 33,
    "zipcode": 1320,
    "city": "l'Écluse"
  },
  {
    "id": 34,
    "zipcode": 1320,
    "city": "Nodebais"
  },
  {
    "id": 35,
    "zipcode": 1320,
    "city": "Tourinnes-la-Grosse"
  },
  {
    "id": 36,
    "zipcode": 1320,
    "city": "Beauvechain"
  },
  {
    "id": 37,
    "zipcode": 1325,
    "city": "Bonlez"
  },
  {
    "id": 38,
    "zipcode": 1325,
    "city": "Corroy-le-Grand"
  },
  {
    "id": 39,
    "zipcode": 1325,
    "city": "Dion-Valmont"
  },
  {
    "id": 40,
    "zipcode": 1325,
    "city": "Longueville"
  },
  {
    "id": 41,
    "zipcode": 1325,
    "city": "Chaumont-Gistoux"
  },
  {
    "id": 42,
    "zipcode": 1330,
    "city": "Rixensart"
  },
  {
    "id": 43,
    "zipcode": 1331,
    "city": "Rosières"
  },
  {
    "id": 44,
    "zipcode": 1332,
    "city": "Genval"
  },
  {
    "id": 45,
    "zipcode": 1340,
    "city": "Ottignies"
  },
  {
    "id": 46,
    "zipcode": 1341,
    "city": "Céroux-Mousty"
  },
  {
    "id": 47,
    "zipcode": 1342,
    "city": "Limelette"
  },
  {
    "id": 48,
    "zipcode": 1348,
    "city": "Louvain-la-Neuve"
  },
  {
    "id": 49,
    "zipcode": 1350,
    "city": "Enines"
  },
  {
    "id": 50,
    "zipcode": 1350,
    "city": "Folx-les-Caves"
  },
  {
    "id": 51,
    "zipcode": 1350,
    "city": "Jandrain-Jandrenouille"
  },
  {
    "id": 52,
    "zipcode": 1350,
    "city": "Jauche"
  },
  {
    "id": 53,
    "zipcode": 1350,
    "city": "Marilles"
  },
  {
    "id": 54,
    "zipcode": 1350,
    "city": "Noduwez"
  },
  {
    "id": 55,
    "zipcode": 1350,
    "city": "Orp-le-Grand"
  },
  {
    "id": 56,
    "zipcode": 1357,
    "city": "Linsmeau"
  },
  {
    "id": 57,
    "zipcode": 1357,
    "city": "Neerheylissem"
  },
  {
    "id": 58,
    "zipcode": 1357,
    "city": "Opheylissem"
  },
  {
    "id": 59,
    "zipcode": 1360,
    "city": "Malèves-Sainte-Marie-Wastinnes"
  },
  {
    "id": 60,
    "zipcode": 1360,
    "city": "Orbais"
  },
  {
    "id": 61,
    "zipcode": 1360,
    "city": "Thorembais-les-Béguines"
  },
  {
    "id": 62,
    "zipcode": 1360,
    "city": "Thorembais-Saint-Trond"
  },
  {
    "id": 63,
    "zipcode": 1360,
    "city": "Perwez"
  },
  {
    "id": 64,
    "zipcode": 1367,
    "city": "Autre-Eglise"
  },
  {
    "id": 65,
    "zipcode": 1367,
    "city": "Bomal"
  },
  {
    "id": 66,
    "zipcode": 1367,
    "city": "Geest-Gérompont-Petit-Rosière"
  },
  {
    "id": 67,
    "zipcode": 1367,
    "city": "Gérompont"
  },
  {
    "id": 68,
    "zipcode": 1367,
    "city": "Grand-Rosière-Hottomont"
  },
  {
    "id": 69,
    "zipcode": 1367,
    "city": "Huppaye"
  },
  {
    "id": 70,
    "zipcode": 1367,
    "city": "Mont-Saint-André"
  },
  {
    "id": 71,
    "zipcode": 1367,
    "city": "Ramillies"
  },
  {
    "id": 72,
    "zipcode": 1370,
    "city": "Dongelberg"
  },
  {
    "id": 73,
    "zipcode": 1370,
    "city": "Jauchelette"
  },
  {
    "id": 74,
    "zipcode": 1370,
    "city": "Jodoigne-Souveraine"
  },
  {
    "id": 75,
    "zipcode": 1370,
    "city": "Lathuy"
  },
  {
    "id": 76,
    "zipcode": 1370,
    "city": "Mélin"
  },
  {
    "id": 77,
    "zipcode": 1370,
    "city": "Piétrain"
  },
  {
    "id": 78,
    "zipcode": 1370,
    "city": "Saint-Jean-Geest"
  },
  {
    "id": 79,
    "zipcode": 1370,
    "city": "Saint-Remy-Geest"
  },
  {
    "id": 80,
    "zipcode": 1370,
    "city": "Zétrud-Lumay"
  },
  {
    "id": 81,
    "zipcode": 1370,
    "city": "Jodoigne"
  },
  {
    "id": 82,
    "zipcode": 1380,
    "city": "Couture-Saint-Germain"
  },
  {
    "id": 83,
    "zipcode": 1380,
    "city": "Lasne-Chapelle-Saint-Lambert"
  },
  {
    "id": 84,
    "zipcode": 1380,
    "city": "Maransart"
  },
  {
    "id": 85,
    "zipcode": 1380,
    "city": "Ohain"
  },
  {
    "id": 86,
    "zipcode": 1380,
    "city": "Plancenoit"
  },
  {
    "id": 87,
    "zipcode": 1390,
    "city": "Archennes"
  },
  {
    "id": 88,
    "zipcode": 1390,
    "city": "Biez"
  },
  {
    "id": 89,
    "zipcode": 1390,
    "city": "Bossut-Gottechain"
  },
  {
    "id": 90,
    "zipcode": 1390,
    "city": "Nethen"
  },
  {
    "id": 91,
    "zipcode": 1390,
    "city": "Grez-Doiceau"
  },
  {
    "id": 92,
    "zipcode": 1400,
    "city": "Monstreux"
  },
  {
    "id": 93,
    "zipcode": 1400,
    "city": "Nivelles"
  },
  {
    "id": 94,
    "zipcode": 1401,
    "city": "Baulers"
  },
  {
    "id": 95,
    "zipcode": 1402,
    "city": "Thines"
  },
  {
    "id": 96,
    "zipcode": 1404,
    "city": "Bornival"
  },
  {
    "id": 97,
    "zipcode": 1410,
    "city": "Waterloo"
  },
  {
    "id": 98,
    "zipcode": 1420,
    "city": "Braine-l'Alleud"
  },
  {
    "id": 99,
    "zipcode": 1421,
    "city": "Ophain-Bois-Seigneur-Isaac"
  },
  {
    "id": 100,
    "zipcode": 1428,
    "city": "Lillois-Witterzée"
  },
  {
    "id": 101,
    "zipcode": 1430,
    "city": "Bierghes"
  },
  {
    "id": 102,
    "zipcode": 1430,
    "city": "Quenast"
  },
  {
    "id": 103,
    "zipcode": 1430,
    "city": "Rebecq-Rognon"
  },
  {
    "id": 104,
    "zipcode": 1435,
    "city": "Corbais"
  },
  {
    "id": 105,
    "zipcode": 1435,
    "city": "Hévillers"
  },
  {
    "id": 106,
    "zipcode": 1435,
    "city": "Mont-Saint-Guibert"
  },
  {
    "id": 107,
    "zipcode": 1440,
    "city": "Wauthier-Braine"
  },
  {
    "id": 108,
    "zipcode": 1440,
    "city": "Braine-le-Château"
  },
  {
    "id": 109,
    "zipcode": 1450,
    "city": "Chastre-Villeroux-Blanmont"
  },
  {
    "id": 110,
    "zipcode": 1450,
    "city": "Cortil-Noirmont"
  },
  {
    "id": 111,
    "zipcode": 1450,
    "city": "Gentinnes"
  },
  {
    "id": 112,
    "zipcode": 1450,
    "city": "Saint-Géry"
  },
  {
    "id": 113,
    "zipcode": 1457,
    "city": "Nil-Saint-Vincent-Saint-Martin"
  },
  {
    "id": 114,
    "zipcode": 1457,
    "city": "Tourinnes-Saint-Lambert"
  },
  {
    "id": 115,
    "zipcode": 1457,
    "city": "Walhain-Saint-Paul"
  },
  {
    "id": 116,
    "zipcode": 1460,
    "city": "Virginal-Samme"
  },
  {
    "id": 117,
    "zipcode": 1460,
    "city": "Ittre"
  },
  {
    "id": 118,
    "zipcode": 1461,
    "city": "Haut-Ittre"
  },
  {
    "id": 119,
    "zipcode": 1470,
    "city": "Baisy-Thy"
  },
  {
    "id": 120,
    "zipcode": 1470,
    "city": "Bousval"
  },
  {
    "id": 121,
    "zipcode": 1470,
    "city": "Genappe"
  },
  {
    "id": 122,
    "zipcode": 1471,
    "city": "Loupoigne"
  },
  {
    "id": 123,
    "zipcode": 1472,
    "city": "Vieux-Genappe"
  },
  {
    "id": 124,
    "zipcode": 1473,
    "city": "Glabais"
  },
  {
    "id": 125,
    "zipcode": 1474,
    "city": "Ways"
  },
  {
    "id": 126,
    "zipcode": 1476,
    "city": "Houtain-le-Val"
  },
  {
    "id": 127,
    "zipcode": 1480,
    "city": "Clabecq"
  },
  {
    "id": 128,
    "zipcode": 1480,
    "city": "Oisquercq"
  },
  {
    "id": 129,
    "zipcode": 1480,
    "city": "Saintes"
  },
  {
    "id": 130,
    "zipcode": 1480,
    "city": "Tubize"
  },
  {
    "id": 131,
    "zipcode": 1490,
    "city": "Court-Saint-Etienne"
  },
  {
    "id": 132,
    "zipcode": 1495,
    "city": "Marbais"
  },
  {
    "id": 133,
    "zipcode": 1495,
    "city": "Mellery"
  },
  {
    "id": 134,
    "zipcode": 1495,
    "city": "Sart-Dames-Avelines"
  },
  {
    "id": 135,
    "zipcode": 1495,
    "city": "Tilly"
  },
  {
    "id": 136,
    "zipcode": 1495,
    "city": "Villers-la-Ville"
  },
  {
    "id": 137,
    "zipcode": 1500,
    "city": "Halle"
  },
  {
    "id": 138,
    "zipcode": 1501,
    "city": "Buizingen"
  },
  {
    "id": 139,
    "zipcode": 1502,
    "city": "Lembeek"
  },
  {
    "id": 140,
    "zipcode": 1540,
    "city": "Herfelingen"
  },
  {
    "id": 141,
    "zipcode": 1540,
    "city": "Herne"
  },
  {
    "id": 142,
    "zipcode": 1541,
    "city": "Sint-Pieters-Kapelle"
  },
  {
    "id": 143,
    "zipcode": 1547,
    "city": "Bever"
  },
  {
    "id": 144,
    "zipcode": 1560,
    "city": "Hoeilaart"
  },
  {
    "id": 145,
    "zipcode": 1570,
    "city": "Galmaarden"
  },
  {
    "id": 146,
    "zipcode": 1570,
    "city": "Tollembeek"
  },
  {
    "id": 147,
    "zipcode": 1570,
    "city": "Vollezele"
  },
  {
    "id": 148,
    "zipcode": 1600,
    "city": "Oudenaken"
  },
  {
    "id": 149,
    "zipcode": 1600,
    "city": "Sint-Laureins-Berchem"
  },
  {
    "id": 150,
    "zipcode": 1600,
    "city": "Sint-Pieters-Leeuw"
  },
  {
    "id": 151,
    "zipcode": 1601,
    "city": "Ruisbroek"
  },
  {
    "id": 152,
    "zipcode": 1602,
    "city": "Vlezenbeek"
  },
  {
    "id": 153,
    "zipcode": 1620,
    "city": "Drogenbos"
  },
  {
    "id": 154,
    "zipcode": 1630,
    "city": "Linkebeek"
  },
  {
    "id": 155,
    "zipcode": 1640,
    "city": "Sint-Genesius-Rode"
  },
  {
    "id": 156,
    "zipcode": 1650,
    "city": "Beersel"
  },
  {
    "id": 157,
    "zipcode": 1651,
    "city": "Lot"
  },
  {
    "id": 158,
    "zipcode": 1652,
    "city": "Alsemberg"
  },
  {
    "id": 159,
    "zipcode": 1653,
    "city": "Dworp"
  },
  {
    "id": 160,
    "zipcode": 1654,
    "city": "Huizingen"
  },
  {
    "id": 161,
    "zipcode": 1670,
    "city": "Bogaarden"
  },
  {
    "id": 162,
    "zipcode": 1670,
    "city": "Heikruis"
  },
  {
    "id": 163,
    "zipcode": 1670,
    "city": "Pepingen"
  },
  {
    "id": 164,
    "zipcode": 1671,
    "city": "Elingen"
  },
  {
    "id": 165,
    "zipcode": 1673,
    "city": "Beert"
  },
  {
    "id": 166,
    "zipcode": 1674,
    "city": "Bellingen"
  },
  {
    "id": 167,
    "zipcode": 1700,
    "city": "Sint-Martens-Bodegem"
  },
  {
    "id": 168,
    "zipcode": 1700,
    "city": "Sint-Ulriks-Kapelle"
  },
  {
    "id": 169,
    "zipcode": 1700,
    "city": "Dilbeek"
  },
  {
    "id": 170,
    "zipcode": 1701,
    "city": "Itterbeek"
  },
  {
    "id": 171,
    "zipcode": 1702,
    "city": "Groot-Bijgaarden"
  },
  {
    "id": 172,
    "zipcode": 1703,
    "city": "Schepdaal"
  },
  {
    "id": 173,
    "zipcode": 1730,
    "city": "Bekkerzeel"
  },
  {
    "id": 174,
    "zipcode": 1730,
    "city": "Kobbegem"
  },
  {
    "id": 175,
    "zipcode": 1730,
    "city": "Mollem"
  },
  {
    "id": 176,
    "zipcode": 1730,
    "city": "Asse"
  },
  {
    "id": 177,
    "zipcode": 1731,
    "city": "Relegem"
  },
  {
    "id": 178,
    "zipcode": 1731,
    "city": "Zellik"
  },
  {
    "id": 179,
    "zipcode": 1740,
    "city": "Ternat"
  },
  {
    "id": 180,
    "zipcode": 1741,
    "city": "Wambeek"
  },
  {
    "id": 181,
    "zipcode": 1742,
    "city": "Sint-Katherina-Lombeek"
  },
  {
    "id": 182,
    "zipcode": 1745,
    "city": "Mazenzele"
  },
  {
    "id": 183,
    "zipcode": 1745,
    "city": "Opwijk"
  },
  {
    "id": 184,
    "zipcode": 1750,
    "city": "Gaasbeek"
  },
  {
    "id": 185,
    "zipcode": 1750,
    "city": "Sint-Kwintens-Lennik"
  },
  {
    "id": 186,
    "zipcode": 1750,
    "city": "Sint-Martens-Lennik"
  },
  {
    "id": 187,
    "zipcode": 1755,
    "city": "Gooik"
  },
  {
    "id": 188,
    "zipcode": 1755,
    "city": "Kester"
  },
  {
    "id": 189,
    "zipcode": 1755,
    "city": "Leerbeek"
  },
  {
    "id": 190,
    "zipcode": 1755,
    "city": "Oetingen"
  },
  {
    "id": 191,
    "zipcode": 1760,
    "city": "Onze-Lieve-Vrouw-Lombeek"
  },
  {
    "id": 192,
    "zipcode": 1760,
    "city": "Pamel"
  },
  {
    "id": 193,
    "zipcode": 1760,
    "city": "Strijtem"
  },
  {
    "id": 194,
    "zipcode": 1760,
    "city": "Roosdaal"
  },
  {
    "id": 195,
    "zipcode": 1761,
    "city": "Borchtlombeek"
  },
  {
    "id": 196,
    "zipcode": 1770,
    "city": "Liedekerke"
  },
  {
    "id": 197,
    "zipcode": 1780,
    "city": "Wemmel"
  },
  {
    "id": 198,
    "zipcode": 1785,
    "city": "Brussegem"
  },
  {
    "id": 199,
    "zipcode": 1785,
    "city": "Hamme"
  },
  {
    "id": 200,
    "zipcode": 1785,
    "city": "Merchtem"
  },
  {
    "id": 201,
    "zipcode": 1790,
    "city": "Essene"
  },
  {
    "id": 202,
    "zipcode": 1790,
    "city": "Hekelgem"
  },
  {
    "id": 203,
    "zipcode": 1790,
    "city": "Teralfene"
  },
  {
    "id": 204,
    "zipcode": 1790,
    "city": "Affligem"
  },
  {
    "id": 205,
    "zipcode": 1800,
    "city": "Peutie"
  },
  {
    "id": 206,
    "zipcode": 1800,
    "city": "Vilvoorde"
  },
  {
    "id": 207,
    "zipcode": 1820,
    "city": "Melsbroek"
  },
  {
    "id": 208,
    "zipcode": 1820,
    "city": "Perk"
  },
  {
    "id": 209,
    "zipcode": 1820,
    "city": "Steenokkerzeel"
  },
  {
    "id": 210,
    "zipcode": 1830,
    "city": "Machelen"
  },
  {
    "id": 211,
    "zipcode": 1831,
    "city": "Diegem"
  },
  {
    "id": 212,
    "zipcode": 1840,
    "city": "Malderen"
  },
  {
    "id": 213,
    "zipcode": 1840,
    "city": "Steenhuffel"
  },
  {
    "id": 214,
    "zipcode": 1840,
    "city": "Londerzeel"
  },
  {
    "id": 215,
    "zipcode": 1850,
    "city": "Grimbergen"
  },
  {
    "id": 216,
    "zipcode": 1851,
    "city": "Humbeek"
  },
  {
    "id": 217,
    "zipcode": 1852,
    "city": "Beigem"
  },
  {
    "id": 218,
    "zipcode": 1853,
    "city": "Strombeek-Bever"
  },
  {
    "id": 219,
    "zipcode": 1860,
    "city": "Meise"
  },
  {
    "id": 220,
    "zipcode": 1861,
    "city": "Wolvertem"
  },
  {
    "id": 221,
    "zipcode": 1880,
    "city": "Nieuwenrode"
  },
  {
    "id": 222,
    "zipcode": 1880,
    "city": "Ramsdonk"
  },
  {
    "id": 223,
    "zipcode": 1880,
    "city": "Kapelle-op-den-Bos"
  },
  {
    "id": 224,
    "zipcode": 1910,
    "city": "Berg"
  },
  {
    "id": 225,
    "zipcode": 1910,
    "city": "Buken"
  },
  {
    "id": 226,
    "zipcode": 1910,
    "city": "Nederokkerzeel"
  },
  {
    "id": 227,
    "zipcode": 1910,
    "city": "Kampenhout"
  },
  {
    "id": 228,
    "zipcode": 1930,
    "city": "Nossegem"
  },
  {
    "id": 229,
    "zipcode": 1930,
    "city": "Zaventem"
  },
  {
    "id": 230,
    "zipcode": 1932,
    "city": "Sint-Stevens-Woluwe"
  },
  {
    "id": 231,
    "zipcode": 1933,
    "city": "Sterrebeek"
  },
  {
    "id": 232,
    "zipcode": 1950,
    "city": "Kraainem"
  },
  {
    "id": 233,
    "zipcode": 1970,
    "city": "Wezembeek-Oppem"
  },
  {
    "id": 234,
    "zipcode": 1980,
    "city": "Eppegem"
  },
  {
    "id": 235,
    "zipcode": 1980,
    "city": "Zemst"
  },
  {
    "id": 236,
    "zipcode": 1981,
    "city": "Hofstade"
  },
  {
    "id": 237,
    "zipcode": 1982,
    "city": "Elewijt"
  },
  {
    "id": 238,
    "zipcode": 1982,
    "city": "Weerde"
  },
  {
    "id": 239,
    "zipcode": 2000,
    "city": "Antwerpen"
  },
  {
    "id": 240,
    "zipcode": 2018,
    "city": "Antwerpen"
  },
  {
    "id": 241,
    "zipcode": 2020,
    "city": "Antwerpen"
  },
  {
    "id": 242,
    "zipcode": 2030,
    "city": "Antwerpen"
  },
  {
    "id": 243,
    "zipcode": 2040,
    "city": "Berendrecht"
  },
  {
    "id": 244,
    "zipcode": 2040,
    "city": "Lillo"
  },
  {
    "id": 245,
    "zipcode": 2040,
    "city": "Zandvliet"
  },
  {
    "id": 246,
    "zipcode": 2040,
    "city": "Antwerpen"
  },
  {
    "id": 247,
    "zipcode": 2050,
    "city": "Antwerpen"
  },
  {
    "id": 248,
    "zipcode": 2060,
    "city": "Antwerpen"
  },
  {
    "id": 249,
    "zipcode": 2070,
    "city": "Burcht"
  },
  {
    "id": 250,
    "zipcode": 2070,
    "city": "Zwijndrecht"
  },
  {
    "id": 251,
    "zipcode": 2100,
    "city": "Deurne"
  },
  {
    "id": 252,
    "zipcode": 2110,
    "city": "Wijnegem"
  },
  {
    "id": 253,
    "zipcode": 2140,
    "city": "Borgerhout"
  },
  {
    "id": 254,
    "zipcode": 2150,
    "city": "Borsbeek"
  },
  {
    "id": 255,
    "zipcode": 2160,
    "city": "Wommelgem"
  },
  {
    "id": 256,
    "zipcode": 2170,
    "city": "Merksem"
  },
  {
    "id": 257,
    "zipcode": 2180,
    "city": "Ekeren"
  },
  {
    "id": 258,
    "zipcode": 2200,
    "city": "Morkhoven"
  },
  {
    "id": 259,
    "zipcode": 2200,
    "city": "Noorderwijk"
  },
  {
    "id": 260,
    "zipcode": 2200,
    "city": "Herentals"
  },
  {
    "id": 261,
    "zipcode": 2220,
    "city": "Hallaar"
  },
  {
    "id": 262,
    "zipcode": 2220,
    "city": "Heist-op-den-Berg"
  },
  {
    "id": 263,
    "zipcode": 2221,
    "city": "Booischot"
  },
  {
    "id": 264,
    "zipcode": 2222,
    "city": "Itegem"
  },
  {
    "id": 265,
    "zipcode": 2222,
    "city": "Wiekevorst"
  },
  {
    "id": 266,
    "zipcode": 2223,
    "city": "Schriek"
  },
  {
    "id": 267,
    "zipcode": 2230,
    "city": "Ramsel"
  },
  {
    "id": 268,
    "zipcode": 2230,
    "city": "Herselt"
  },
  {
    "id": 269,
    "zipcode": 2235,
    "city": "Houtvenne"
  },
  {
    "id": 270,
    "zipcode": 2235,
    "city": "Westmeerbeek"
  },
  {
    "id": 271,
    "zipcode": 2235,
    "city": "Hulshout"
  },
  {
    "id": 272,
    "zipcode": 2240,
    "city": "Massenhoven"
  },
  {
    "id": 273,
    "zipcode": 2240,
    "city": "Viersel"
  },
  {
    "id": 274,
    "zipcode": 2240,
    "city": "Zandhoven"
  },
  {
    "id": 275,
    "zipcode": 2242,
    "city": "Pulderbos"
  },
  {
    "id": 276,
    "zipcode": 2243,
    "city": "Pulle"
  },
  {
    "id": 277,
    "zipcode": 2250,
    "city": "Olen"
  },
  {
    "id": 278,
    "zipcode": 2260,
    "city": "Oevel"
  },
  {
    "id": 279,
    "zipcode": 2260,
    "city": "Tongerlo"
  },
  {
    "id": 280,
    "zipcode": 2260,
    "city": "Zoerle-Parwijs"
  },
  {
    "id": 281,
    "zipcode": 2260,
    "city": "Westerlo"
  },
  {
    "id": 282,
    "zipcode": 2270,
    "city": "Herenthout"
  },
  {
    "id": 283,
    "zipcode": 2275,
    "city": "Gierle"
  },
  {
    "id": 284,
    "zipcode": 2275,
    "city": "Poederlee"
  },
  {
    "id": 285,
    "zipcode": 2275,
    "city": "Wechelderzande"
  },
  {
    "id": 286,
    "zipcode": 2275,
    "city": "Lille"
  },
  {
    "id": 287,
    "zipcode": 2280,
    "city": "Grobbendonk"
  },
  {
    "id": 288,
    "zipcode": 2288,
    "city": "Bouwel"
  },
  {
    "id": 289,
    "zipcode": 2290,
    "city": "Vorselaar"
  },
  {
    "id": 290,
    "zipcode": 2300,
    "city": "Turnhout"
  },
  {
    "id": 291,
    "zipcode": 2310,
    "city": "Rijkevorsel"
  },
  {
    "id": 292,
    "zipcode": 2320,
    "city": "Hoogstraten"
  },
  {
    "id": 293,
    "zipcode": 2321,
    "city": "Meer"
  },
  {
    "id": 294,
    "zipcode": 2322,
    "city": "Minderhout"
  },
  {
    "id": 295,
    "zipcode": 2323,
    "city": "Wortel"
  },
  {
    "id": 296,
    "zipcode": 2328,
    "city": "Meerle"
  },
  {
    "id": 297,
    "zipcode": 2330,
    "city": "Merksplas"
  },
  {
    "id": 298,
    "zipcode": 2340,
    "city": "Vlimmeren"
  },
  {
    "id": 299,
    "zipcode": 2340,
    "city": "Beerse"
  },
  {
    "id": 300,
    "zipcode": 2350,
    "city": "Vosselaar"
  },
  {
    "id": 301,
    "zipcode": 2360,
    "city": "Oud-Turnhout"
  },
  {
    "id": 302,
    "zipcode": 2370,
    "city": "Arendonk"
  },
  {
    "id": 303,
    "zipcode": 2380,
    "city": "Ravels"
  },
  {
    "id": 304,
    "zipcode": 2381,
    "city": "Weelde"
  },
  {
    "id": 305,
    "zipcode": 2382,
    "city": "Poppel"
  },
  {
    "id": 306,
    "zipcode": 2387,
    "city": "Baarle-Hertog"
  },
  {
    "id": 307,
    "zipcode": 2390,
    "city": "Oostmalle"
  },
  {
    "id": 308,
    "zipcode": 2390,
    "city": "Westmalle"
  },
  {
    "id": 309,
    "zipcode": 2390,
    "city": "Malle"
  },
  {
    "id": 310,
    "zipcode": 2400,
    "city": "Mol"
  },
  {
    "id": 311,
    "zipcode": 2430,
    "city": "Eindhout"
  },
  {
    "id": 312,
    "zipcode": 2430,
    "city": "Vorst"
  },
  {
    "id": 313,
    "zipcode": 2431,
    "city": "Varendonk"
  },
  {
    "id": 314,
    "zipcode": 2431,
    "city": "Veerle"
  },
  {
    "id": 315,
    "zipcode": 2440,
    "city": "Geel"
  },
  {
    "id": 316,
    "zipcode": 2450,
    "city": "Meerhout"
  },
  {
    "id": 317,
    "zipcode": 2460,
    "city": "Lichtaart"
  },
  {
    "id": 318,
    "zipcode": 2460,
    "city": "Tielen"
  },
  {
    "id": 319,
    "zipcode": 2460,
    "city": "Kasterlee"
  },
  {
    "id": 320,
    "zipcode": 2470,
    "city": "Retie"
  },
  {
    "id": 321,
    "zipcode": 2480,
    "city": "Dessel"
  },
  {
    "id": 322,
    "zipcode": 2490,
    "city": "Balen"
  },
  {
    "id": 323,
    "zipcode": 2491,
    "city": "Olmen"
  },
  {
    "id": 324,
    "zipcode": 2500,
    "city": "Koningshooikt"
  },
  {
    "id": 325,
    "zipcode": 2500,
    "city": "Lier"
  },
  {
    "id": 326,
    "zipcode": 2520,
    "city": "Broechem"
  },
  {
    "id": 327,
    "zipcode": 2520,
    "city": "Emblem"
  },
  {
    "id": 328,
    "zipcode": 2520,
    "city": "Oelegem"
  },
  {
    "id": 329,
    "zipcode": 2520,
    "city": "Ranst"
  },
  {
    "id": 330,
    "zipcode": 2530,
    "city": "Boechout"
  },
  {
    "id": 331,
    "zipcode": 2531,
    "city": "Vremde"
  },
  {
    "id": 332,
    "zipcode": 2540,
    "city": "Hove"
  },
  {
    "id": 333,
    "zipcode": 2547,
    "city": "Lint"
  },
  {
    "id": 334,
    "zipcode": 2550,
    "city": "Waarloos"
  },
  {
    "id": 335,
    "zipcode": 2550,
    "city": "Kontich"
  },
  {
    "id": 336,
    "zipcode": 2560,
    "city": "Bevel"
  },
  {
    "id": 337,
    "zipcode": 2560,
    "city": "Kessel"
  },
  {
    "id": 338,
    "zipcode": 2560,
    "city": "Nijlen"
  },
  {
    "id": 339,
    "zipcode": 2570,
    "city": "Duffel"
  },
  {
    "id": 340,
    "zipcode": 2580,
    "city": "Beerzel"
  },
  {
    "id": 341,
    "zipcode": 2580,
    "city": "Putte"
  },
  {
    "id": 342,
    "zipcode": 2590,
    "city": "Gestel"
  },
  {
    "id": 343,
    "zipcode": 2590,
    "city": "Berlaar"
  },
  {
    "id": 344,
    "zipcode": 2600,
    "city": "Berchem"
  },
  {
    "id": 345,
    "zipcode": 2610,
    "city": "Wilrijk"
  },
  {
    "id": 346,
    "zipcode": 2620,
    "city": "Hemiksem"
  },
  {
    "id": 347,
    "zipcode": 2627,
    "city": "Schelle"
  },
  {
    "id": 348,
    "zipcode": 2630,
    "city": "Aartselaar"
  },
  {
    "id": 349,
    "zipcode": 2640,
    "city": "Mortsel"
  },
  {
    "id": 350,
    "zipcode": 2650,
    "city": "Edegem"
  },
  {
    "id": 351,
    "zipcode": 2660,
    "city": "Hoboken"
  },
  {
    "id": 352,
    "zipcode": 2800,
    "city": "Walem"
  },
  {
    "id": 353,
    "zipcode": 2800,
    "city": "Mechelen"
  },
  {
    "id": 354,
    "zipcode": 2801,
    "city": "Heffen"
  },
  {
    "id": 355,
    "zipcode": 2811,
    "city": "Hombeek"
  },
  {
    "id": 356,
    "zipcode": 2811,
    "city": "Leest"
  },
  {
    "id": 357,
    "zipcode": 2812,
    "city": "Muizen"
  },
  {
    "id": 358,
    "zipcode": 2820,
    "city": "Rijmenam"
  },
  {
    "id": 359,
    "zipcode": 2820,
    "city": "Bonheiden"
  },
  {
    "id": 360,
    "zipcode": 2830,
    "city": "Blaasveld"
  },
  {
    "id": 361,
    "zipcode": 2830,
    "city": "Heindonk"
  },
  {
    "id": 362,
    "zipcode": 2830,
    "city": "Tisselt"
  },
  {
    "id": 363,
    "zipcode": 2830,
    "city": "Willebroek"
  },
  {
    "id": 364,
    "zipcode": 2840,
    "city": "Reet"
  },
  {
    "id": 365,
    "zipcode": 2840,
    "city": "Terhagen"
  },
  {
    "id": 366,
    "zipcode": 2840,
    "city": "Rumst"
  },
  {
    "id": 367,
    "zipcode": 2845,
    "city": "Niel"
  },
  {
    "id": 368,
    "zipcode": 2850,
    "city": "Boom"
  },
  {
    "id": 369,
    "zipcode": 2860,
    "city": "Sint-Katelijne-Waver"
  },
  {
    "id": 370,
    "zipcode": 2861,
    "city": "Onze-Lieve-Vrouw-Waver"
  },
  {
    "id": 371,
    "zipcode": 2870,
    "city": "Breendonk"
  },
  {
    "id": 372,
    "zipcode": 2870,
    "city": "Liezele"
  },
  {
    "id": 373,
    "zipcode": 2870,
    "city": "Puurs"
  },
  {
    "id": 374,
    "zipcode": 2870,
    "city": "Ruisbroek"
  },
  {
    "id": 375,
    "zipcode": 2880,
    "city": "Hingene"
  },
  {
    "id": 376,
    "zipcode": 2880,
    "city": "Mariekerke"
  },
  {
    "id": 377,
    "zipcode": 2880,
    "city": "Weert"
  },
  {
    "id": 378,
    "zipcode": 2880,
    "city": "Bornem"
  },
  {
    "id": 379,
    "zipcode": 2890,
    "city": "Lippelo"
  },
  {
    "id": 380,
    "zipcode": 2890,
    "city": "Oppuurs"
  },
  {
    "id": 381,
    "zipcode": 2890,
    "city": "Sint-Amands"
  },
  {
    "id": 382,
    "zipcode": 2900,
    "city": "Schoten"
  },
  {
    "id": 383,
    "zipcode": 2910,
    "city": "Essen"
  },
  {
    "id": 384,
    "zipcode": 2920,
    "city": "Kalmthout"
  },
  {
    "id": 385,
    "zipcode": 2930,
    "city": "Brasschaat"
  },
  {
    "id": 386,
    "zipcode": 2940,
    "city": "Hoevenen"
  },
  {
    "id": 387,
    "zipcode": 2940,
    "city": "Stabroek"
  },
  {
    "id": 388,
    "zipcode": 2950,
    "city": "Kapellen"
  },
  {
    "id": 389,
    "zipcode": 2960,
    "city": "Sint-Job-in-'t-Goor"
  },
  {
    "id": 390,
    "zipcode": 2960,
    "city": "Sint-Lenaarts"
  },
  {
    "id": 391,
    "zipcode": 2960,
    "city": "Brecht"
  },
  {
    "id": 392,
    "zipcode": 2970,
    "city": "'s Gravenwezel"
  },
  {
    "id": 393,
    "zipcode": 2970,
    "city": "Schilde"
  },
  {
    "id": 394,
    "zipcode": 2980,
    "city": "Halle"
  },
  {
    "id": 395,
    "zipcode": 2980,
    "city": "Zoersel"
  },
  {
    "id": 396,
    "zipcode": 2990,
    "city": "Loenhout"
  },
  {
    "id": 397,
    "zipcode": 2990,
    "city": "Wuustwezel"
  },
  {
    "id": 398,
    "zipcode": 3000,
    "city": "Leuven"
  },
  {
    "id": 399,
    "zipcode": 3001,
    "city": "Heverlee"
  },
  {
    "id": 400,
    "zipcode": 3010,
    "city": "Kessel Lo"
  },
  {
    "id": 401,
    "zipcode": 3012,
    "city": "Wilsele"
  },
  {
    "id": 402,
    "zipcode": 3018,
    "city": "Wijgmaal"
  },
  {
    "id": 403,
    "zipcode": 3020,
    "city": "Veltem-Beisem"
  },
  {
    "id": 404,
    "zipcode": 3020,
    "city": "Winksele"
  },
  {
    "id": 405,
    "zipcode": 3020,
    "city": "Herent"
  },
  {
    "id": 406,
    "zipcode": 3040,
    "city": "Loonbeek"
  },
  {
    "id": 407,
    "zipcode": 3040,
    "city": "Neerijse"
  },
  {
    "id": 408,
    "zipcode": 3040,
    "city": "Ottenburg"
  },
  {
    "id": 409,
    "zipcode": 3040,
    "city": "Sint-Agatha-Rode"
  },
  {
    "id": 410,
    "zipcode": 3040,
    "city": "Huldenberg"
  },
  {
    "id": 411,
    "zipcode": 3050,
    "city": "Oud-Heverlee"
  },
  {
    "id": 412,
    "zipcode": 3051,
    "city": "Sint-Joris-Weert"
  },
  {
    "id": 413,
    "zipcode": 3052,
    "city": "Blanden"
  },
  {
    "id": 414,
    "zipcode": 3053,
    "city": "Haasrode"
  },
  {
    "id": 415,
    "zipcode": 3054,
    "city": "Vaalbeek"
  },
  {
    "id": 416,
    "zipcode": 3060,
    "city": "Korbeek-Dijle"
  },
  {
    "id": 417,
    "zipcode": 3060,
    "city": "Bertem"
  },
  {
    "id": 418,
    "zipcode": 3061,
    "city": "Leefdaal"
  },
  {
    "id": 419,
    "zipcode": 3070,
    "city": "Kortenberg"
  },
  {
    "id": 420,
    "zipcode": 3071,
    "city": "Erps-Kwerps"
  },
  {
    "id": 421,
    "zipcode": 3078,
    "city": "Everberg"
  },
  {
    "id": 422,
    "zipcode": 3078,
    "city": "Meerbeek"
  },
  {
    "id": 423,
    "zipcode": 3080,
    "city": "Duisburg"
  },
  {
    "id": 424,
    "zipcode": 3080,
    "city": "Vossem"
  },
  {
    "id": 425,
    "zipcode": 3080,
    "city": "Tervuren"
  },
  {
    "id": 426,
    "zipcode": 3090,
    "city": "Overijse"
  },
  {
    "id": 427,
    "zipcode": 3110,
    "city": "Rotselaar"
  },
  {
    "id": 428,
    "zipcode": 3111,
    "city": "Wezemaal"
  },
  {
    "id": 429,
    "zipcode": 3118,
    "city": "Werchter"
  },
  {
    "id": 430,
    "zipcode": 3120,
    "city": "Tremelo"
  },
  {
    "id": 431,
    "zipcode": 3128,
    "city": "Baal"
  },
  {
    "id": 432,
    "zipcode": 3130,
    "city": "Betekom"
  },
  {
    "id": 433,
    "zipcode": 3130,
    "city": "Begijnendijk"
  },
  {
    "id": 434,
    "zipcode": 3140,
    "city": "Keerbergen"
  },
  {
    "id": 435,
    "zipcode": 3150,
    "city": "Tildonk"
  },
  {
    "id": 436,
    "zipcode": 3150,
    "city": "Wespelaar"
  },
  {
    "id": 437,
    "zipcode": 3150,
    "city": "Haacht"
  },
  {
    "id": 438,
    "zipcode": 3190,
    "city": "Boortmeerbeek"
  },
  {
    "id": 439,
    "zipcode": 3191,
    "city": "Hever"
  },
  {
    "id": 440,
    "zipcode": 3200,
    "city": "Gelrode"
  },
  {
    "id": 441,
    "zipcode": 3200,
    "city": "Aarschot"
  },
  {
    "id": 442,
    "zipcode": 3201,
    "city": "Langdorp"
  },
  {
    "id": 443,
    "zipcode": 3202,
    "city": "Rillaar"
  },
  {
    "id": 444,
    "zipcode": 3210,
    "city": "Linden"
  },
  {
    "id": 445,
    "zipcode": 3210,
    "city": "Lubbeek"
  },
  {
    "id": 446,
    "zipcode": 3211,
    "city": "Binkom"
  },
  {
    "id": 447,
    "zipcode": 3212,
    "city": "Pellenberg"
  },
  {
    "id": 448,
    "zipcode": 3220,
    "city": "Kortrijk-Dutsel"
  },
  {
    "id": 449,
    "zipcode": 3220,
    "city": "Sint-Pieters-Rode"
  },
  {
    "id": 450,
    "zipcode": 3220,
    "city": "Holsbeek"
  },
  {
    "id": 451,
    "zipcode": 3221,
    "city": "Nieuwrode"
  },
  {
    "id": 452,
    "zipcode": 3270,
    "city": "Scherpenheuvel"
  },
  {
    "id": 453,
    "zipcode": 3271,
    "city": "Averbode"
  },
  {
    "id": 454,
    "zipcode": 3271,
    "city": "Zichem"
  },
  {
    "id": 455,
    "zipcode": 3272,
    "city": "Messelbroek"
  },
  {
    "id": 456,
    "zipcode": 3272,
    "city": "Testelt"
  },
  {
    "id": 457,
    "zipcode": 3290,
    "city": "Deurne"
  },
  {
    "id": 458,
    "zipcode": 3290,
    "city": "Schaffen"
  },
  {
    "id": 459,
    "zipcode": 3290,
    "city": "Webbekom"
  },
  {
    "id": 460,
    "zipcode": 3290,
    "city": "Diest"
  },
  {
    "id": 461,
    "zipcode": 3293,
    "city": "Kaggevinne"
  },
  {
    "id": 462,
    "zipcode": 3294,
    "city": "Molenstede"
  },
  {
    "id": 463,
    "zipcode": 3300,
    "city": "Bost"
  },
  {
    "id": 464,
    "zipcode": 3300,
    "city": "Goetsenhoven"
  },
  {
    "id": 465,
    "zipcode": 3300,
    "city": "Hakendover"
  },
  {
    "id": 466,
    "zipcode": 3300,
    "city": "Kumtich"
  },
  {
    "id": 467,
    "zipcode": 3300,
    "city": "Oorbeek"
  },
  {
    "id": 468,
    "zipcode": 3300,
    "city": "Oplinter"
  },
  {
    "id": 469,
    "zipcode": 3300,
    "city": "Sint-Margriete-Houtem"
  },
  {
    "id": 470,
    "zipcode": 3300,
    "city": "Vissenaken"
  },
  {
    "id": 471,
    "zipcode": 3300,
    "city": "Tienen"
  },
  {
    "id": 472,
    "zipcode": 3320,
    "city": "Meldert"
  },
  {
    "id": 473,
    "zipcode": 3320,
    "city": "Hoegaarden"
  },
  {
    "id": 474,
    "zipcode": 3321,
    "city": "Outgaarden"
  },
  {
    "id": 475,
    "zipcode": 3350,
    "city": "Drieslinter"
  },
  {
    "id": 476,
    "zipcode": 3350,
    "city": "Melkwezer"
  },
  {
    "id": 477,
    "zipcode": 3350,
    "city": "Neerhespen"
  },
  {
    "id": 478,
    "zipcode": 3350,
    "city": "Neerlinter"
  },
  {
    "id": 479,
    "zipcode": 3350,
    "city": "Orsmaal-Gussenhoven"
  },
  {
    "id": 480,
    "zipcode": 3350,
    "city": "Overhespen"
  },
  {
    "id": 481,
    "zipcode": 3350,
    "city": "Wommersom"
  },
  {
    "id": 482,
    "zipcode": 3350,
    "city": "Linter"
  },
  {
    "id": 483,
    "zipcode": 3360,
    "city": "Korbeek-Lo"
  },
  {
    "id": 484,
    "zipcode": 3360,
    "city": "Lovenjoel"
  },
  {
    "id": 485,
    "zipcode": 3360,
    "city": "Opvelp"
  },
  {
    "id": 486,
    "zipcode": 3360,
    "city": "Bierbeek"
  },
  {
    "id": 487,
    "zipcode": 3370,
    "city": "Kerkom"
  },
  {
    "id": 488,
    "zipcode": 3370,
    "city": "Neervelp"
  },
  {
    "id": 489,
    "zipcode": 3370,
    "city": "Roosbeek"
  },
  {
    "id": 490,
    "zipcode": 3370,
    "city": "Vertrijk"
  },
  {
    "id": 491,
    "zipcode": 3370,
    "city": "Willebringen"
  },
  {
    "id": 492,
    "zipcode": 3370,
    "city": "Boutersem"
  },
  {
    "id": 493,
    "zipcode": 3380,
    "city": "Bunsbeek"
  },
  {
    "id": 494,
    "zipcode": 3380,
    "city": "Glabbeek"
  },
  {
    "id": 495,
    "zipcode": 3381,
    "city": "Kapellen"
  },
  {
    "id": 496,
    "zipcode": 3384,
    "city": "Attenrode"
  },
  {
    "id": 497,
    "zipcode": 3390,
    "city": "Houwaart"
  },
  {
    "id": 498,
    "zipcode": 3390,
    "city": "Sint-Joris-Winge"
  },
  {
    "id": 499,
    "zipcode": 3390,
    "city": "Tielt"
  },
  {
    "id": 500,
    "zipcode": 3391,
    "city": "Meensel-Kiezegem"
  },
  {
    "id": 501,
    "zipcode": 3400,
    "city": "Eliksem"
  },
  {
    "id": 502,
    "zipcode": 3400,
    "city": "Ezemaal"
  },
  {
    "id": 503,
    "zipcode": 3400,
    "city": "Laar"
  },
  {
    "id": 504,
    "zipcode": 3400,
    "city": "Neerwinden"
  },
  {
    "id": 505,
    "zipcode": 3400,
    "city": "Overwinden"
  },
  {
    "id": 506,
    "zipcode": 3400,
    "city": "Rumsdorp"
  },
  {
    "id": 507,
    "zipcode": 3400,
    "city": "Wange"
  },
  {
    "id": 508,
    "zipcode": 3400,
    "city": "Landen"
  },
  {
    "id": 509,
    "zipcode": 3401,
    "city": "Waasmont"
  },
  {
    "id": 510,
    "zipcode": 3401,
    "city": "Walsbets"
  },
  {
    "id": 511,
    "zipcode": 3401,
    "city": "Walshoutem"
  },
  {
    "id": 512,
    "zipcode": 3401,
    "city": "Wezeren"
  },
  {
    "id": 513,
    "zipcode": 3404,
    "city": "Attenhoven"
  },
  {
    "id": 514,
    "zipcode": 3404,
    "city": "Neerlanden"
  },
  {
    "id": 515,
    "zipcode": 3440,
    "city": "Budingen"
  },
  {
    "id": 516,
    "zipcode": 3440,
    "city": "Dormaal"
  },
  {
    "id": 517,
    "zipcode": 3440,
    "city": "Halle-Booienhoven"
  },
  {
    "id": 518,
    "zipcode": 3440,
    "city": "Helen-Bos"
  },
  {
    "id": 519,
    "zipcode": 3440,
    "city": "Zoutleeuw"
  },
  {
    "id": 520,
    "zipcode": 3450,
    "city": "Grazen"
  },
  {
    "id": 521,
    "zipcode": 3450,
    "city": "Geetbets"
  },
  {
    "id": 522,
    "zipcode": 3454,
    "city": "Rummen"
  },
  {
    "id": 523,
    "zipcode": 3460,
    "city": "Assent"
  },
  {
    "id": 524,
    "zipcode": 3460,
    "city": "Bekkevoort"
  },
  {
    "id": 525,
    "zipcode": 3461,
    "city": "Molenbeek-Wersbeek"
  },
  {
    "id": 526,
    "zipcode": 3470,
    "city": "Ransberg"
  },
  {
    "id": 527,
    "zipcode": 3470,
    "city": "Sint-Margriete-Houtem"
  },
  {
    "id": 528,
    "zipcode": 3470,
    "city": "Kortenaken"
  },
  {
    "id": 529,
    "zipcode": 3471,
    "city": "Hoeleden"
  },
  {
    "id": 530,
    "zipcode": 3472,
    "city": "Kersbeek-Miskom"
  },
  {
    "id": 531,
    "zipcode": 3473,
    "city": "Waanrode"
  },
  {
    "id": 532,
    "zipcode": 3500,
    "city": "Sint-Lambrechts-Herk"
  },
  {
    "id": 533,
    "zipcode": 3500,
    "city": "Hasselt"
  },
  {
    "id": 534,
    "zipcode": 3501,
    "city": "Wimmertingen"
  },
  {
    "id": 535,
    "zipcode": 3510,
    "city": "Kermt"
  },
  {
    "id": 536,
    "zipcode": 3510,
    "city": "Spalbeek"
  },
  {
    "id": 537,
    "zipcode": 3511,
    "city": "Kuringen"
  },
  {
    "id": 538,
    "zipcode": 3511,
    "city": "Stokrooie"
  },
  {
    "id": 539,
    "zipcode": 3512,
    "city": "Stevoort"
  },
  {
    "id": 540,
    "zipcode": 3520,
    "city": "Zonhoven"
  },
  {
    "id": 541,
    "zipcode": 3530,
    "city": "Helchteren"
  },
  {
    "id": 542,
    "zipcode": 3530,
    "city": "Houthalen"
  },
  {
    "id": 543,
    "zipcode": 3540,
    "city": "Berbroek"
  },
  {
    "id": 544,
    "zipcode": 3540,
    "city": "Donk"
  },
  {
    "id": 545,
    "zipcode": 3540,
    "city": "Schulen"
  },
  {
    "id": 546,
    "zipcode": 3540,
    "city": "Herk-de-Stad"
  },
  {
    "id": 547,
    "zipcode": 3545,
    "city": "Loksbergen"
  },
  {
    "id": 548,
    "zipcode": 3545,
    "city": "Zelem"
  },
  {
    "id": 549,
    "zipcode": 3545,
    "city": "Halen"
  },
  {
    "id": 550,
    "zipcode": 3550,
    "city": "Heusden"
  },
  {
    "id": 551,
    "zipcode": 3550,
    "city": "Zolder"
  },
  {
    "id": 552,
    "zipcode": 3550,
    "city": "Heusden-Zolder"
  },
  {
    "id": 553,
    "zipcode": 3560,
    "city": "Linkhout"
  },
  {
    "id": 554,
    "zipcode": 3560,
    "city": "Meldert"
  },
  {
    "id": 555,
    "zipcode": 3560,
    "city": "Lummen"
  },
  {
    "id": 556,
    "zipcode": 3570,
    "city": "Alken"
  },
  {
    "id": 557,
    "zipcode": 3580,
    "city": "Beringen"
  },
  {
    "id": 558,
    "zipcode": 3581,
    "city": "Beverlo"
  },
  {
    "id": 559,
    "zipcode": 3582,
    "city": "Koersel"
  },
  {
    "id": 560,
    "zipcode": 3583,
    "city": "Paal"
  },
  {
    "id": 561,
    "zipcode": 3590,
    "city": "Diepenbeek"
  },
  {
    "id": 562,
    "zipcode": 3600,
    "city": "Genk"
  },
  {
    "id": 563,
    "zipcode": 3620,
    "city": "Gellik"
  },
  {
    "id": 564,
    "zipcode": 3620,
    "city": "Neerharen"
  },
  {
    "id": 565,
    "zipcode": 3620,
    "city": "Veldwezelt"
  },
  {
    "id": 566,
    "zipcode": 3620,
    "city": "Lanaken"
  },
  {
    "id": 567,
    "zipcode": 3621,
    "city": "Rekem"
  },
  {
    "id": 568,
    "zipcode": 3630,
    "city": "Eisden"
  },
  {
    "id": 569,
    "zipcode": 3630,
    "city": "Leut"
  },
  {
    "id": 570,
    "zipcode": 3630,
    "city": "Mechelen-aan-de-Maas"
  },
  {
    "id": 571,
    "zipcode": 3630,
    "city": "Meeswijk"
  },
  {
    "id": 572,
    "zipcode": 3630,
    "city": "Opgrimbie"
  },
  {
    "id": 573,
    "zipcode": 3630,
    "city": "Vucht"
  },
  {
    "id": 574,
    "zipcode": 3630,
    "city": "Maasmechelen"
  },
  {
    "id": 575,
    "zipcode": 3631,
    "city": "Boorsem"
  },
  {
    "id": 576,
    "zipcode": 3631,
    "city": "Uikhoven"
  },
  {
    "id": 577,
    "zipcode": 3640,
    "city": "Kessenich"
  },
  {
    "id": 578,
    "zipcode": 3640,
    "city": "Molenbeersel"
  },
  {
    "id": 579,
    "zipcode": 3640,
    "city": "Ophoven"
  },
  {
    "id": 580,
    "zipcode": 3640,
    "city": "Kinrooi"
  },
  {
    "id": 581,
    "zipcode": 3650,
    "city": "Dilsen"
  },
  {
    "id": 582,
    "zipcode": 3650,
    "city": "Elen"
  },
  {
    "id": 583,
    "zipcode": 3650,
    "city": "Lanklaar"
  },
  {
    "id": 584,
    "zipcode": 3650,
    "city": "Rotem"
  },
  {
    "id": 585,
    "zipcode": 3650,
    "city": "Stokkem"
  },
  {
    "id": 586,
    "zipcode": 3660,
    "city": "Opglabbeek"
  },
  {
    "id": 587,
    "zipcode": 3665,
    "city": "As"
  },
  {
    "id": 588,
    "zipcode": 3668,
    "city": "Niel-bij-As"
  },
  {
    "id": 589,
    "zipcode": 3670,
    "city": "Ellikom"
  },
  {
    "id": 590,
    "zipcode": 3670,
    "city": "Gruitrode"
  },
  {
    "id": 591,
    "zipcode": 3670,
    "city": "Meeuwen"
  },
  {
    "id": 592,
    "zipcode": 3670,
    "city": "Neerglabbeek"
  },
  {
    "id": 593,
    "zipcode": 3670,
    "city": "Wijshagen"
  },
  {
    "id": 594,
    "zipcode": 3680,
    "city": "Neeroeteren"
  },
  {
    "id": 595,
    "zipcode": 3680,
    "city": "Opoeteren"
  },
  {
    "id": 596,
    "zipcode": 3680,
    "city": "Maaseik"
  },
  {
    "id": 597,
    "zipcode": 3690,
    "city": "Zutendaal"
  },
  {
    "id": 598,
    "zipcode": 3700,
    "city": "Berg"
  },
  {
    "id": 599,
    "zipcode": 3700,
    "city": "Diets-Heur"
  },
  {
    "id": 600,
    "zipcode": 3700,
    "city": "Haren"
  },
  {
    "id": 601,
    "zipcode": 3700,
    "city": "Henis"
  },
  {
    "id": 602,
    "zipcode": 3700,
    "city": "Kolmont"
  },
  {
    "id": 603,
    "zipcode": 3700,
    "city": "Koninksem"
  },
  {
    "id": 604,
    "zipcode": 3700,
    "city": "Lauw"
  },
  {
    "id": 605,
    "zipcode": 3700,
    "city": "Mal"
  },
  {
    "id": 606,
    "zipcode": 3700,
    "city": "Neerrepen"
  },
  {
    "id": 607,
    "zipcode": 3700,
    "city": "Nerem"
  },
  {
    "id": 608,
    "zipcode": 3700,
    "city": "Overrepen"
  },
  {
    "id": 609,
    "zipcode": 3700,
    "city": "Piringen"
  },
  {
    "id": 610,
    "zipcode": 3700,
    "city": "Riksingen"
  },
  {
    "id": 611,
    "zipcode": 3700,
    "city": "Rutten"
  },
  {
    "id": 612,
    "zipcode": 3700,
    "city": "'s Herenelderen"
  },
  {
    "id": 613,
    "zipcode": 3700,
    "city": "Sluizen"
  },
  {
    "id": 614,
    "zipcode": 3700,
    "city": "Tongeren"
  },
  {
    "id": 615,
    "zipcode": 3700,
    "city": "Vreren"
  },
  {
    "id": 616,
    "zipcode": 3700,
    "city": "Widooie"
  },
  {
    "id": 617,
    "zipcode": 3717,
    "city": "Herstappe"
  },
  {
    "id": 618,
    "zipcode": 3720,
    "city": "Kortessem"
  },
  {
    "id": 619,
    "zipcode": 3721,
    "city": "Vliermaalroot"
  },
  {
    "id": 620,
    "zipcode": 3722,
    "city": "Wintershoven"
  },
  {
    "id": 621,
    "zipcode": 3723,
    "city": "Guigoven"
  },
  {
    "id": 622,
    "zipcode": 3724,
    "city": "Vliermaal"
  },
  {
    "id": 623,
    "zipcode": 3730,
    "city": "Hoeselt"
  },
  {
    "id": 624,
    "zipcode": 3730,
    "city": "Romershoven"
  },
  {
    "id": 625,
    "zipcode": 3730,
    "city": "Sint-Huibrechts-Hern"
  },
  {
    "id": 626,
    "zipcode": 3730,
    "city": "Werm"
  },
  {
    "id": 627,
    "zipcode": 3732,
    "city": "Schalkhoven"
  },
  {
    "id": 628,
    "zipcode": 3740,
    "city": "Beverst"
  },
  {
    "id": 629,
    "zipcode": 3740,
    "city": "Bilzen"
  },
  {
    "id": 630,
    "zipcode": 3740,
    "city": "Eigenbilzen"
  },
  {
    "id": 631,
    "zipcode": 3740,
    "city": "Grote-Spouwen"
  },
  {
    "id": 632,
    "zipcode": 3740,
    "city": "Hees"
  },
  {
    "id": 633,
    "zipcode": 3740,
    "city": "Kleine-Spouwen"
  },
  {
    "id": 634,
    "zipcode": 3740,
    "city": "Mopertingen"
  },
  {
    "id": 635,
    "zipcode": 3740,
    "city": "Munsterbilzen"
  },
  {
    "id": 636,
    "zipcode": 3740,
    "city": "Rijkhoven"
  },
  {
    "id": 637,
    "zipcode": 3740,
    "city": "Rosmeer"
  },
  {
    "id": 638,
    "zipcode": 3740,
    "city": "Waltwilder"
  },
  {
    "id": 639,
    "zipcode": 3742,
    "city": "Martenslinde"
  },
  {
    "id": 640,
    "zipcode": 3746,
    "city": "Hoelbeek"
  },
  {
    "id": 641,
    "zipcode": 3770,
    "city": "Genoelselderen"
  },
  {
    "id": 642,
    "zipcode": 3770,
    "city": "Herderen"
  },
  {
    "id": 643,
    "zipcode": 3770,
    "city": "Kanne"
  },
  {
    "id": 644,
    "zipcode": 3770,
    "city": "Membruggen"
  },
  {
    "id": 645,
    "zipcode": 3770,
    "city": "Millen"
  },
  {
    "id": 646,
    "zipcode": 3770,
    "city": "Val-Meer"
  },
  {
    "id": 647,
    "zipcode": 3770,
    "city": "Vlijtingen"
  },
  {
    "id": 648,
    "zipcode": 3770,
    "city": "Vroenhoven"
  },
  {
    "id": 649,
    "zipcode": 3770,
    "city": "Zichen-Zussen-Bolder"
  },
  {
    "id": 650,
    "zipcode": 3770,
    "city": "Riemst"
  },
  {
    "id": 651,
    "zipcode": 3790,
    "city": "Moelingen"
  },
  {
    "id": 652,
    "zipcode": 3790,
    "city": "Sint-Martens-Voeren"
  },
  {
    "id": 653,
    "zipcode": 3791,
    "city": "Remersdaal"
  },
  {
    "id": 654,
    "zipcode": 3792,
    "city": "Sint-Pieters-Voeren"
  },
  {
    "id": 655,
    "zipcode": 3793,
    "city": "Teuven"
  },
  {
    "id": 656,
    "zipcode": 3798,
    "city": "'s-Gravenvoeren"
  },
  {
    "id": 657,
    "zipcode": 3800,
    "city": "Aalst"
  },
  {
    "id": 658,
    "zipcode": 3800,
    "city": "Brustem"
  },
  {
    "id": 659,
    "zipcode": 3800,
    "city": "Engelmanshoven"
  },
  {
    "id": 660,
    "zipcode": 3800,
    "city": "Gelinden"
  },
  {
    "id": 661,
    "zipcode": 3800,
    "city": "Groot-Gelmen"
  },
  {
    "id": 662,
    "zipcode": 3800,
    "city": "Halmaal"
  },
  {
    "id": 663,
    "zipcode": 3800,
    "city": "Kerkom-bij-Sint-Truiden"
  },
  {
    "id": 664,
    "zipcode": 3800,
    "city": "Ordingen"
  },
  {
    "id": 665,
    "zipcode": 3800,
    "city": "Zepperen"
  },
  {
    "id": 666,
    "zipcode": 3800,
    "city": "Sint-Truiden"
  },
  {
    "id": 667,
    "zipcode": 3803,
    "city": "Duras"
  },
  {
    "id": 668,
    "zipcode": 3803,
    "city": "Gorsem"
  },
  {
    "id": 669,
    "zipcode": 3803,
    "city": "Runkelen"
  },
  {
    "id": 670,
    "zipcode": 3803,
    "city": "Wilderen"
  },
  {
    "id": 671,
    "zipcode": 3806,
    "city": "Velm"
  },
  {
    "id": 672,
    "zipcode": 3830,
    "city": "Berlingen"
  },
  {
    "id": 673,
    "zipcode": 3830,
    "city": "Wellen"
  },
  {
    "id": 674,
    "zipcode": 3831,
    "city": "Herten"
  },
  {
    "id": 675,
    "zipcode": 3832,
    "city": "Ulbeek"
  },
  {
    "id": 676,
    "zipcode": 3840,
    "city": "Bommershoven"
  },
  {
    "id": 677,
    "zipcode": 3840,
    "city": "Borgloon"
  },
  {
    "id": 678,
    "zipcode": 3840,
    "city": "Broekom"
  },
  {
    "id": 679,
    "zipcode": 3840,
    "city": "Gors-Opleeuw"
  },
  {
    "id": 680,
    "zipcode": 3840,
    "city": "Gotem"
  },
  {
    "id": 681,
    "zipcode": 3840,
    "city": "Groot-Loon"
  },
  {
    "id": 682,
    "zipcode": 3840,
    "city": "Haren"
  },
  {
    "id": 683,
    "zipcode": 3840,
    "city": "Hendrieken"
  },
  {
    "id": 684,
    "zipcode": 3840,
    "city": "Hoepertingen"
  },
  {
    "id": 685,
    "zipcode": 3840,
    "city": "Jesseren"
  },
  {
    "id": 686,
    "zipcode": 3840,
    "city": "Kerniel"
  },
  {
    "id": 687,
    "zipcode": 3840,
    "city": "Kolmont"
  },
  {
    "id": 688,
    "zipcode": 3840,
    "city": "Kuttekoven"
  },
  {
    "id": 689,
    "zipcode": 3840,
    "city": "Rijkel"
  },
  {
    "id": 690,
    "zipcode": 3840,
    "city": "Voort"
  },
  {
    "id": 691,
    "zipcode": 3850,
    "city": "Binderveld"
  },
  {
    "id": 692,
    "zipcode": 3850,
    "city": "Kozen"
  },
  {
    "id": 693,
    "zipcode": 3850,
    "city": "Wijer"
  },
  {
    "id": 694,
    "zipcode": 3850,
    "city": "Nieuwerkerken"
  },
  {
    "id": 695,
    "zipcode": 3870,
    "city": "Batsheers"
  },
  {
    "id": 696,
    "zipcode": 3870,
    "city": "Bovelingen"
  },
  {
    "id": 697,
    "zipcode": 3870,
    "city": "Gutshoven"
  },
  {
    "id": 698,
    "zipcode": 3870,
    "city": "Heks"
  },
  {
    "id": 699,
    "zipcode": 3870,
    "city": "Horpmaal"
  },
  {
    "id": 700,
    "zipcode": 3870,
    "city": "Klein-Gelmen"
  },
  {
    "id": 701,
    "zipcode": 3870,
    "city": "Mechelen-Bovelingen"
  },
  {
    "id": 702,
    "zipcode": 3870,
    "city": "Mettekoven"
  },
  {
    "id": 703,
    "zipcode": 3870,
    "city": "Opheers"
  },
  {
    "id": 704,
    "zipcode": 3870,
    "city": "Rukkelingen-Loon"
  },
  {
    "id": 705,
    "zipcode": 3870,
    "city": "Vechmaal"
  },
  {
    "id": 706,
    "zipcode": 3870,
    "city": "Veulen"
  },
  {
    "id": 707,
    "zipcode": 3870,
    "city": "Heers"
  },
  {
    "id": 708,
    "zipcode": 3890,
    "city": "Boekhout"
  },
  {
    "id": 709,
    "zipcode": 3890,
    "city": "Jeuk"
  },
  {
    "id": 710,
    "zipcode": 3890,
    "city": "Kortijs"
  },
  {
    "id": 711,
    "zipcode": 3890,
    "city": "Montenaken"
  },
  {
    "id": 712,
    "zipcode": 3890,
    "city": "Niel-bij-Sint-Truiden"
  },
  {
    "id": 713,
    "zipcode": 3890,
    "city": "Vorsen"
  },
  {
    "id": 714,
    "zipcode": 3890,
    "city": "Gingelom"
  },
  {
    "id": 715,
    "zipcode": 3891,
    "city": "Borlo"
  },
  {
    "id": 716,
    "zipcode": 3891,
    "city": "Buvingen"
  },
  {
    "id": 717,
    "zipcode": 3891,
    "city": "Mielen-boven-Aalst"
  },
  {
    "id": 718,
    "zipcode": 3891,
    "city": "Muizen"
  },
  {
    "id": 719,
    "zipcode": 3900,
    "city": "Overpelt"
  },
  {
    "id": 720,
    "zipcode": 3910,
    "city": "Neerpelt"
  },
  {
    "id": 721,
    "zipcode": 3910,
    "city": "Sint-Huibrechts-Lille"
  },
  {
    "id": 722,
    "zipcode": 3920,
    "city": "Lommel"
  },
  {
    "id": 723,
    "zipcode": 3930,
    "city": "Achel"
  },
  {
    "id": 724,
    "zipcode": 3930,
    "city": "Hamont"
  },
  {
    "id": 725,
    "zipcode": 3940,
    "city": "Hechtel"
  },
  {
    "id": 726,
    "zipcode": 3941,
    "city": "Eksel"
  },
  {
    "id": 727,
    "zipcode": 3945,
    "city": "Kwaadmechelen"
  },
  {
    "id": 728,
    "zipcode": 3945,
    "city": "Oostham"
  },
  {
    "id": 729,
    "zipcode": 3950,
    "city": "Kaulille"
  },
  {
    "id": 730,
    "zipcode": 3950,
    "city": "Reppel"
  },
  {
    "id": 731,
    "zipcode": 3950,
    "city": "Bocholt"
  },
  {
    "id": 732,
    "zipcode": 3960,
    "city": "Beek"
  },
  {
    "id": 733,
    "zipcode": 3960,
    "city": "Gerdingen"
  },
  {
    "id": 734,
    "zipcode": 3960,
    "city": "Opitter"
  },
  {
    "id": 735,
    "zipcode": 3960,
    "city": "Tongerlo"
  },
  {
    "id": 736,
    "zipcode": 3960,
    "city": "Bree"
  },
  {
    "id": 737,
    "zipcode": 3970,
    "city": "Leopoldsburg"
  },
  {
    "id": 738,
    "zipcode": 3971,
    "city": "Heppen"
  },
  {
    "id": 739,
    "zipcode": 3980,
    "city": "Tessenderlo"
  },
  {
    "id": 740,
    "zipcode": 3990,
    "city": "Grote-Brogel"
  },
  {
    "id": 741,
    "zipcode": 3990,
    "city": "Kleine-Brogel"
  },
  {
    "id": 742,
    "zipcode": 3990,
    "city": "Wijchmaal"
  },
  {
    "id": 743,
    "zipcode": 3990,
    "city": "Peer"
  },
  {
    "id": 744,
    "zipcode": 4000,
    "city": "Glain"
  },
  {
    "id": 745,
    "zipcode": 4000,
    "city": "Rocourt"
  },
  {
    "id": 746,
    "zipcode": 4000,
    "city": "Liège"
  },
  {
    "id": 747,
    "zipcode": 4020,
    "city": "Bressoux"
  },
  {
    "id": 748,
    "zipcode": 4020,
    "city": "Jupille-sur-Meuse"
  },
  {
    "id": 749,
    "zipcode": 4020,
    "city": "Wandre"
  },
  {
    "id": 750,
    "zipcode": 4020,
    "city": "Liège"
  },
  {
    "id": 751,
    "zipcode": 4030,
    "city": "Grivegnée"
  },
  {
    "id": 752,
    "zipcode": 4031,
    "city": "Angleur"
  },
  {
    "id": 753,
    "zipcode": 4032,
    "city": "Chênée"
  },
  {
    "id": 754,
    "zipcode": 4040,
    "city": "Herstal"
  },
  {
    "id": 755,
    "zipcode": 4041,
    "city": "Milmort"
  },
  {
    "id": 756,
    "zipcode": 4041,
    "city": "Vottem"
  },
  {
    "id": 757,
    "zipcode": 4042,
    "city": "Liers"
  },
  {
    "id": 758,
    "zipcode": 4050,
    "city": "Chaudfontaine"
  },
  {
    "id": 759,
    "zipcode": 4051,
    "city": "Vaux-sous-Chèvremont"
  },
  {
    "id": 760,
    "zipcode": 4052,
    "city": "Beaufays"
  },
  {
    "id": 761,
    "zipcode": 4053,
    "city": "Embourg"
  },
  {
    "id": 762,
    "zipcode": 4100,
    "city": "Boncelles"
  },
  {
    "id": 763,
    "zipcode": 4100,
    "city": "Seraing"
  },
  {
    "id": 764,
    "zipcode": 4101,
    "city": "Jemeppe-sur-Meuse"
  },
  {
    "id": 765,
    "zipcode": 4102,
    "city": "Ougrée"
  },
  {
    "id": 766,
    "zipcode": 4120,
    "city": "Ehein"
  },
  {
    "id": 767,
    "zipcode": 4120,
    "city": "Rotheux-Rimière"
  },
  {
    "id": 768,
    "zipcode": 4121,
    "city": "Neuville-en-Condroz"
  },
  {
    "id": 769,
    "zipcode": 4122,
    "city": "Plainevaux"
  },
  {
    "id": 770,
    "zipcode": 4130,
    "city": "Tilff"
  },
  {
    "id": 771,
    "zipcode": 4130,
    "city": "Esneux"
  },
  {
    "id": 772,
    "zipcode": 4140,
    "city": "Dolembreux"
  },
  {
    "id": 773,
    "zipcode": 4140,
    "city": "Gomzé-Andoumont"
  },
  {
    "id": 774,
    "zipcode": 4140,
    "city": "Rouvreux"
  },
  {
    "id": 775,
    "zipcode": 4140,
    "city": "Sprimont"
  },
  {
    "id": 776,
    "zipcode": 4141,
    "city": "Louveigné"
  },
  {
    "id": 777,
    "zipcode": 4160,
    "city": "Anthisnes"
  },
  {
    "id": 778,
    "zipcode": 4161,
    "city": "Villers-aux-Tours"
  },
  {
    "id": 779,
    "zipcode": 4162,
    "city": "Hody"
  },
  {
    "id": 780,
    "zipcode": 4163,
    "city": "Tavier"
  },
  {
    "id": 781,
    "zipcode": 4170,
    "city": "Comblain-au-Pont"
  },
  {
    "id": 782,
    "zipcode": 4171,
    "city": "Poulseur"
  },
  {
    "id": 783,
    "zipcode": 4180,
    "city": "Comblain-Fairon"
  },
  {
    "id": 784,
    "zipcode": 4180,
    "city": "Comblain-la-Tour"
  },
  {
    "id": 785,
    "zipcode": 4180,
    "city": "Hamoir"
  },
  {
    "id": 786,
    "zipcode": 4181,
    "city": "Filot"
  },
  {
    "id": 787,
    "zipcode": 4190,
    "city": "My"
  },
  {
    "id": 788,
    "zipcode": 4190,
    "city": "Vieuxville"
  },
  {
    "id": 789,
    "zipcode": 4190,
    "city": "Werbomont"
  },
  {
    "id": 790,
    "zipcode": 4190,
    "city": "Xhoris"
  },
  {
    "id": 791,
    "zipcode": 4190,
    "city": "Ferrières"
  },
  {
    "id": 792,
    "zipcode": 4210,
    "city": "Hannêche"
  },
  {
    "id": 793,
    "zipcode": 4210,
    "city": "Lamontzée"
  },
  {
    "id": 794,
    "zipcode": 4210,
    "city": "Marneffe"
  },
  {
    "id": 795,
    "zipcode": 4210,
    "city": "Oteppe"
  },
  {
    "id": 796,
    "zipcode": 4210,
    "city": "Burdinne"
  },
  {
    "id": 797,
    "zipcode": 4217,
    "city": "Lavoir"
  },
  {
    "id": 798,
    "zipcode": 4217,
    "city": "Waret-l'Évêque"
  },
  {
    "id": 799,
    "zipcode": 4217,
    "city": "Héron"
  },
  {
    "id": 800,
    "zipcode": 4218,
    "city": "Couthuin"
  },
  {
    "id": 801,
    "zipcode": 4219,
    "city": "Acosse"
  },
  {
    "id": 802,
    "zipcode": 4219,
    "city": "Ambresin"
  },
  {
    "id": 803,
    "zipcode": 4219,
    "city": "Meeffe"
  },
  {
    "id": 804,
    "zipcode": 4219,
    "city": "Wasseiges"
  },
  {
    "id": 805,
    "zipcode": 4250,
    "city": "Boëlhe"
  },
  {
    "id": 806,
    "zipcode": 4250,
    "city": "Hollogne-sur-Geer"
  },
  {
    "id": 807,
    "zipcode": 4250,
    "city": "Lens-Saint-Servais"
  },
  {
    "id": 808,
    "zipcode": 4250,
    "city": "Geer"
  },
  {
    "id": 809,
    "zipcode": 4252,
    "city": "Omal"
  },
  {
    "id": 810,
    "zipcode": 4253,
    "city": "Darion"
  },
  {
    "id": 811,
    "zipcode": 4254,
    "city": "Ligney"
  },
  {
    "id": 812,
    "zipcode": 4257,
    "city": "Corswarem"
  },
  {
    "id": 813,
    "zipcode": 4257,
    "city": "Rosoux-Crenwick"
  },
  {
    "id": 814,
    "zipcode": 4257,
    "city": "Berloz"
  },
  {
    "id": 815,
    "zipcode": 4260,
    "city": "Avennes"
  },
  {
    "id": 816,
    "zipcode": 4260,
    "city": "Ciplet"
  },
  {
    "id": 817,
    "zipcode": 4260,
    "city": "Fallais"
  },
  {
    "id": 818,
    "zipcode": 4260,
    "city": "Fumal"
  },
  {
    "id": 819,
    "zipcode": 4260,
    "city": "Ville-en-Hesbaye"
  },
  {
    "id": 820,
    "zipcode": 4260,
    "city": "Braives"
  },
  {
    "id": 821,
    "zipcode": 4261,
    "city": "Latinne"
  },
  {
    "id": 822,
    "zipcode": 4263,
    "city": "Tourinne"
  },
  {
    "id": 823,
    "zipcode": 4280,
    "city": "Abolens"
  },
  {
    "id": 824,
    "zipcode": 4280,
    "city": "Avernas-le-Bauduin"
  },
  {
    "id": 825,
    "zipcode": 4280,
    "city": "Avin"
  },
  {
    "id": 826,
    "zipcode": 4280,
    "city": "Bertrée"
  },
  {
    "id": 827,
    "zipcode": 4280,
    "city": "Blehen"
  },
  {
    "id": 828,
    "zipcode": 4280,
    "city": "Cras-Avernas"
  },
  {
    "id": 829,
    "zipcode": 4280,
    "city": "Crehen"
  },
  {
    "id": 830,
    "zipcode": 4280,
    "city": "Grand-Hallet"
  },
  {
    "id": 831,
    "zipcode": 4280,
    "city": "Lens-Saint-Remy"
  },
  {
    "id": 832,
    "zipcode": 4280,
    "city": "Merdorp"
  },
  {
    "id": 833,
    "zipcode": 4280,
    "city": "Moxhe"
  },
  {
    "id": 834,
    "zipcode": 4280,
    "city": "Petit-Hallet"
  },
  {
    "id": 835,
    "zipcode": 4280,
    "city": "Poucet"
  },
  {
    "id": 836,
    "zipcode": 4280,
    "city": "Thisnes"
  },
  {
    "id": 837,
    "zipcode": 4280,
    "city": "Trognée"
  },
  {
    "id": 838,
    "zipcode": 4280,
    "city": "Villers-le-Peuplier"
  },
  {
    "id": 839,
    "zipcode": 4280,
    "city": "Wansin"
  },
  {
    "id": 840,
    "zipcode": 4280,
    "city": "Hannut"
  },
  {
    "id": 841,
    "zipcode": 4287,
    "city": "Pellaines"
  },
  {
    "id": 842,
    "zipcode": 4287,
    "city": "Racour"
  },
  {
    "id": 843,
    "zipcode": 4287,
    "city": "Lincent"
  },
  {
    "id": 844,
    "zipcode": 4300,
    "city": "Bettincourt"
  },
  {
    "id": 845,
    "zipcode": 4300,
    "city": "Bleret"
  },
  {
    "id": 846,
    "zipcode": 4300,
    "city": "Bovenistier"
  },
  {
    "id": 847,
    "zipcode": 4300,
    "city": "Grand-Axhe"
  },
  {
    "id": 848,
    "zipcode": 4300,
    "city": "Lantremange"
  },
  {
    "id": 849,
    "zipcode": 4300,
    "city": "Oleye"
  },
  {
    "id": 850,
    "zipcode": 4300,
    "city": "Waremme"
  },
  {
    "id": 851,
    "zipcode": 4317,
    "city": "Aineffe"
  },
  {
    "id": 852,
    "zipcode": 4317,
    "city": "Borlez"
  },
  {
    "id": 853,
    "zipcode": 4317,
    "city": "Celles"
  },
  {
    "id": 854,
    "zipcode": 4317,
    "city": "Les Waleffes"
  },
  {
    "id": 855,
    "zipcode": 4317,
    "city": "Viemme"
  },
  {
    "id": 856,
    "zipcode": 4317,
    "city": "Faimes"
  },
  {
    "id": 857,
    "zipcode": 4340,
    "city": "Fooz"
  },
  {
    "id": 858,
    "zipcode": 4340,
    "city": "Othée"
  },
  {
    "id": 859,
    "zipcode": 4340,
    "city": "Villers-l'Evêque"
  },
  {
    "id": 860,
    "zipcode": 4340,
    "city": "Awans"
  },
  {
    "id": 861,
    "zipcode": 4342,
    "city": "Hognoul"
  },
  {
    "id": 862,
    "zipcode": 4347,
    "city": "Freloux"
  },
  {
    "id": 863,
    "zipcode": 4347,
    "city": "Noville"
  },
  {
    "id": 864,
    "zipcode": 4347,
    "city": "Roloux"
  },
  {
    "id": 865,
    "zipcode": 4347,
    "city": "Voroux-Goreux"
  },
  {
    "id": 866,
    "zipcode": 4347,
    "city": "Fexhe-le-Haut-Clocher"
  },
  {
    "id": 867,
    "zipcode": 4350,
    "city": "Lamine"
  },
  {
    "id": 868,
    "zipcode": 4350,
    "city": "Momalle"
  },
  {
    "id": 869,
    "zipcode": 4350,
    "city": "Pousset"
  },
  {
    "id": 870,
    "zipcode": 4350,
    "city": "Remicourt"
  },
  {
    "id": 871,
    "zipcode": 4351,
    "city": "Hodeige"
  },
  {
    "id": 872,
    "zipcode": 4357,
    "city": "Haneffe"
  },
  {
    "id": 873,
    "zipcode": 4357,
    "city": "Jeneffe"
  },
  {
    "id": 874,
    "zipcode": 4357,
    "city": "Limont"
  },
  {
    "id": 875,
    "zipcode": 4357,
    "city": "Donceel"
  },
  {
    "id": 876,
    "zipcode": 4360,
    "city": "Bergilers"
  },
  {
    "id": 877,
    "zipcode": 4360,
    "city": "Grandville"
  },
  {
    "id": 878,
    "zipcode": 4360,
    "city": "Lens-sur-Geer"
  },
  {
    "id": 879,
    "zipcode": 4360,
    "city": "Otrange"
  },
  {
    "id": 880,
    "zipcode": 4360,
    "city": "Oreye"
  },
  {
    "id": 881,
    "zipcode": 4367,
    "city": "Fize-Le-Marsal"
  },
  {
    "id": 882,
    "zipcode": 4367,
    "city": "Kemexhe"
  },
  {
    "id": 883,
    "zipcode": 4367,
    "city": "Odeur"
  },
  {
    "id": 884,
    "zipcode": 4367,
    "city": "Thys"
  },
  {
    "id": 885,
    "zipcode": 4367,
    "city": "Crisnée"
  },
  {
    "id": 886,
    "zipcode": 4400,
    "city": "Awirs"
  },
  {
    "id": 887,
    "zipcode": 4400,
    "city": "Chokier"
  },
  {
    "id": 888,
    "zipcode": 4400,
    "city": "Flémalle-Grande"
  },
  {
    "id": 889,
    "zipcode": 4400,
    "city": "Flémalle-Haute"
  },
  {
    "id": 890,
    "zipcode": 4400,
    "city": "Gleixhe"
  },
  {
    "id": 891,
    "zipcode": 4400,
    "city": "Ivoz-Ramet"
  },
  {
    "id": 892,
    "zipcode": 4400,
    "city": "Mons-lez-Liège"
  },
  {
    "id": 893,
    "zipcode": 4420,
    "city": "Montegnée"
  },
  {
    "id": 894,
    "zipcode": 4420,
    "city": "Tilleur"
  },
  {
    "id": 895,
    "zipcode": 4420,
    "city": "Saint-Nicolas"
  },
  {
    "id": 896,
    "zipcode": 4430,
    "city": "Ans"
  },
  {
    "id": 897,
    "zipcode": 4431,
    "city": "Loncin"
  },
  {
    "id": 898,
    "zipcode": 4432,
    "city": "Alleur"
  },
  {
    "id": 899,
    "zipcode": 4432,
    "city": "Xhendremael"
  },
  {
    "id": 900,
    "zipcode": 4450,
    "city": "Lantin"
  },
  {
    "id": 901,
    "zipcode": 4450,
    "city": "Slins"
  },
  {
    "id": 902,
    "zipcode": 4450,
    "city": "Juprelle"
  },
  {
    "id": 903,
    "zipcode": 4451,
    "city": "Voroux-lez-Liers"
  },
  {
    "id": 904,
    "zipcode": 4452,
    "city": "Paifve"
  },
  {
    "id": 905,
    "zipcode": 4452,
    "city": "Wihogne"
  },
  {
    "id": 906,
    "zipcode": 4453,
    "city": "Villers-Saint-Siméon"
  },
  {
    "id": 907,
    "zipcode": 4458,
    "city": "Fexhe-Slins"
  },
  {
    "id": 908,
    "zipcode": 4460,
    "city": "Bierset"
  },
  {
    "id": 909,
    "zipcode": 4460,
    "city": "Grâce-Berleur"
  },
  {
    "id": 910,
    "zipcode": 4460,
    "city": "Hollogne-aux-Pierres"
  },
  {
    "id": 911,
    "zipcode": 4460,
    "city": "Horion-Hozémont"
  },
  {
    "id": 912,
    "zipcode": 4460,
    "city": "Velroux"
  },
  {
    "id": 913,
    "zipcode": 4460,
    "city": "Grâce-Hollogne"
  },
  {
    "id": 914,
    "zipcode": 4470,
    "city": "Saint-Georges-sur-Meuse"
  },
  {
    "id": 915,
    "zipcode": 4480,
    "city": "Clermont-sous-Huy"
  },
  {
    "id": 916,
    "zipcode": 4480,
    "city": "Ehein"
  },
  {
    "id": 917,
    "zipcode": 4480,
    "city": "Hermalle-sous-Huy"
  },
  {
    "id": 918,
    "zipcode": 4480,
    "city": "Engis"
  },
  {
    "id": 919,
    "zipcode": 4500,
    "city": "Ben-Ahin"
  },
  {
    "id": 920,
    "zipcode": 4500,
    "city": "Tihange"
  },
  {
    "id": 921,
    "zipcode": 4500,
    "city": "Huy"
  },
  {
    "id": 922,
    "zipcode": 4520,
    "city": "Antheit"
  },
  {
    "id": 923,
    "zipcode": 4520,
    "city": "Bas-Oha"
  },
  {
    "id": 924,
    "zipcode": 4520,
    "city": "Huccorgne"
  },
  {
    "id": 925,
    "zipcode": 4520,
    "city": "Moha"
  },
  {
    "id": 926,
    "zipcode": 4520,
    "city": "Vinalmont"
  },
  {
    "id": 927,
    "zipcode": 4520,
    "city": "Wanze"
  },
  {
    "id": 928,
    "zipcode": 4530,
    "city": "Fize-Fontaine"
  },
  {
    "id": 929,
    "zipcode": 4530,
    "city": "Vaux-et-Borset"
  },
  {
    "id": 930,
    "zipcode": 4530,
    "city": "Vieux-Waleffe"
  },
  {
    "id": 931,
    "zipcode": 4530,
    "city": "Warnant-Dreye"
  },
  {
    "id": 932,
    "zipcode": 4530,
    "city": "Villers-le-Bouillet"
  },
  {
    "id": 933,
    "zipcode": 4537,
    "city": "Bodegnée"
  },
  {
    "id": 934,
    "zipcode": 4537,
    "city": "Chapon-Seraing"
  },
  {
    "id": 935,
    "zipcode": 4537,
    "city": "Seraing-le-Château"
  },
  {
    "id": 936,
    "zipcode": 4537,
    "city": "Verlaine"
  },
  {
    "id": 937,
    "zipcode": 4540,
    "city": "Ampsin"
  },
  {
    "id": 938,
    "zipcode": 4540,
    "city": "Flône"
  },
  {
    "id": 939,
    "zipcode": 4540,
    "city": "Jehay"
  },
  {
    "id": 940,
    "zipcode": 4540,
    "city": "Ombret"
  },
  {
    "id": 941,
    "zipcode": 4540,
    "city": "Amay"
  },
  {
    "id": 942,
    "zipcode": 4550,
    "city": "Saint-Séverin"
  },
  {
    "id": 943,
    "zipcode": 4550,
    "city": "Villers-le-Temple"
  },
  {
    "id": 944,
    "zipcode": 4550,
    "city": "Yernée-Fraineux"
  },
  {
    "id": 945,
    "zipcode": 4550,
    "city": "Nandrin"
  },
  {
    "id": 946,
    "zipcode": 4557,
    "city": "Abée"
  },
  {
    "id": 947,
    "zipcode": 4557,
    "city": "Fraiture"
  },
  {
    "id": 948,
    "zipcode": 4557,
    "city": "Ramelot"
  },
  {
    "id": 949,
    "zipcode": 4557,
    "city": "Seny"
  },
  {
    "id": 950,
    "zipcode": 4557,
    "city": "Soheit-Tinlot"
  },
  {
    "id": 951,
    "zipcode": 4557,
    "city": "Tinlot"
  },
  {
    "id": 952,
    "zipcode": 4560,
    "city": "Bois-et-Borsu"
  },
  {
    "id": 953,
    "zipcode": 4560,
    "city": "Les Avins"
  },
  {
    "id": 954,
    "zipcode": 4560,
    "city": "Ocquier"
  },
  {
    "id": 955,
    "zipcode": 4560,
    "city": "Pailhe"
  },
  {
    "id": 956,
    "zipcode": 4560,
    "city": "Terwagne"
  },
  {
    "id": 957,
    "zipcode": 4560,
    "city": "Clavier"
  },
  {
    "id": 958,
    "zipcode": 4570,
    "city": "Vyle-et-Tharoul"
  },
  {
    "id": 959,
    "zipcode": 4570,
    "city": "Marchin"
  },
  {
    "id": 960,
    "zipcode": 4577,
    "city": "Outrelouxhe"
  },
  {
    "id": 961,
    "zipcode": 4577,
    "city": "Strée-lez-Huy"
  },
  {
    "id": 962,
    "zipcode": 4577,
    "city": "Vierset-Barse"
  },
  {
    "id": 963,
    "zipcode": 4577,
    "city": "Modave"
  },
  {
    "id": 964,
    "zipcode": 4590,
    "city": "Ellemelle"
  },
  {
    "id": 965,
    "zipcode": 4590,
    "city": "Warzée"
  },
  {
    "id": 966,
    "zipcode": 4590,
    "city": "Ouffet"
  },
  {
    "id": 967,
    "zipcode": 4600,
    "city": "Lanaye"
  },
  {
    "id": 968,
    "zipcode": 4600,
    "city": "Lixhe"
  },
  {
    "id": 969,
    "zipcode": 4600,
    "city": "Richelle"
  },
  {
    "id": 970,
    "zipcode": 4600,
    "city": "Visé"
  },
  {
    "id": 971,
    "zipcode": 4601,
    "city": "Argenteau"
  },
  {
    "id": 972,
    "zipcode": 4602,
    "city": "Cheratte"
  },
  {
    "id": 973,
    "zipcode": 4606,
    "city": "Saint-André"
  },
  {
    "id": 974,
    "zipcode": 4607,
    "city": "Berneau"
  },
  {
    "id": 975,
    "zipcode": 4607,
    "city": "Bombaye"
  },
  {
    "id": 976,
    "zipcode": 4607,
    "city": "Feneur"
  },
  {
    "id": 977,
    "zipcode": 4607,
    "city": "Mortroux"
  },
  {
    "id": 978,
    "zipcode": 4607,
    "city": "Dalhem"
  },
  {
    "id": 979,
    "zipcode": 4608,
    "city": "Neufchâteau"
  },
  {
    "id": 980,
    "zipcode": 4608,
    "city": "Warsage"
  },
  {
    "id": 981,
    "zipcode": 4610,
    "city": "Bellaire"
  },
  {
    "id": 982,
    "zipcode": 4610,
    "city": "Queue-du-Bois"
  },
  {
    "id": 983,
    "zipcode": 4610,
    "city": "Beyne-Heusay"
  },
  {
    "id": 984,
    "zipcode": 4620,
    "city": "Fléron"
  },
  {
    "id": 985,
    "zipcode": 4621,
    "city": "Retinne"
  },
  {
    "id": 986,
    "zipcode": 4623,
    "city": "Magnée"
  },
  {
    "id": 987,
    "zipcode": 4624,
    "city": "Romsée"
  },
  {
    "id": 988,
    "zipcode": 4630,
    "city": "Ayeneux"
  },
  {
    "id": 989,
    "zipcode": 4630,
    "city": "Micheroux"
  },
  {
    "id": 990,
    "zipcode": 4630,
    "city": "Tignée"
  },
  {
    "id": 991,
    "zipcode": 4630,
    "city": "Soumagne"
  },
  {
    "id": 992,
    "zipcode": 4631,
    "city": "Evegnée"
  },
  {
    "id": 993,
    "zipcode": 4632,
    "city": "Cérexhe-Heuseux"
  },
  {
    "id": 994,
    "zipcode": 4633,
    "city": "Melen"
  },
  {
    "id": 995,
    "zipcode": 4650,
    "city": "Chaineux"
  },
  {
    "id": 996,
    "zipcode": 4650,
    "city": "Grand-Rechain"
  },
  {
    "id": 997,
    "zipcode": 4650,
    "city": "Julémont"
  },
  {
    "id": 998,
    "zipcode": 4650,
    "city": "Herve"
  },
  {
    "id": 999,
    "zipcode": 4651,
    "city": "Battice"
  },
  {
    "id": 1000,
    "zipcode": 4652,
    "city": "Xhendelesse"
  },
  {
    "id": 1001,
    "zipcode": 4653,
    "city": "Bolland"
  },
  {
    "id": 1002,
    "zipcode": 4654,
    "city": "Charneux"
  },
  {
    "id": 1003,
    "zipcode": 4670,
    "city": "Mortier"
  },
  {
    "id": 1004,
    "zipcode": 4670,
    "city": "Trembleur"
  },
  {
    "id": 1005,
    "zipcode": 4670,
    "city": "Blégny"
  },
  {
    "id": 1006,
    "zipcode": 4671,
    "city": "Barchon"
  },
  {
    "id": 1007,
    "zipcode": 4671,
    "city": "Housse"
  },
  {
    "id": 1008,
    "zipcode": 4671,
    "city": "Saive"
  },
  {
    "id": 1009,
    "zipcode": 4672,
    "city": "Saint-Remy"
  },
  {
    "id": 1010,
    "zipcode": 4680,
    "city": "Hermée"
  },
  {
    "id": 1011,
    "zipcode": 4680,
    "city": "Oupeye"
  },
  {
    "id": 1012,
    "zipcode": 4681,
    "city": "Hermalle-sous-Argenteau"
  },
  {
    "id": 1013,
    "zipcode": 4682,
    "city": "Heure-le-Romain"
  },
  {
    "id": 1014,
    "zipcode": 4682,
    "city": "Houtain-Saint-Siméon"
  },
  {
    "id": 1015,
    "zipcode": 4683,
    "city": "Vivegnis"
  },
  {
    "id": 1016,
    "zipcode": 4684,
    "city": "Haccourt"
  },
  {
    "id": 1017,
    "zipcode": 4690,
    "city": "Boirs"
  },
  {
    "id": 1018,
    "zipcode": 4690,
    "city": "Eben-Emael"
  },
  {
    "id": 1019,
    "zipcode": 4690,
    "city": "Glons"
  },
  {
    "id": 1020,
    "zipcode": 4690,
    "city": "Roclenge-sur-Geer"
  },
  {
    "id": 1021,
    "zipcode": 4690,
    "city": "Wonck"
  },
  {
    "id": 1022,
    "zipcode": 4690,
    "city": "Bassenge"
  },
  {
    "id": 1023,
    "zipcode": 4700,
    "city": "Eupen"
  },
  {
    "id": 1024,
    "zipcode": 4701,
    "city": "Kettenis"
  },
  {
    "id": 1025,
    "zipcode": 4710,
    "city": "Lontzen"
  },
  {
    "id": 1026,
    "zipcode": 4711,
    "city": "Walhorn"
  },
  {
    "id": 1027,
    "zipcode": 4720,
    "city": "Kelmis"
  },
  {
    "id": 1028,
    "zipcode": 4721,
    "city": "Neu-Moresnet"
  },
  {
    "id": 1029,
    "zipcode": 4728,
    "city": "Hergenrath"
  },
  {
    "id": 1030,
    "zipcode": 4730,
    "city": "Hauset"
  },
  {
    "id": 1031,
    "zipcode": 4730,
    "city": "Raeren"
  },
  {
    "id": 1032,
    "zipcode": 4731,
    "city": "Eynatten"
  },
  {
    "id": 1033,
    "zipcode": 4750,
    "city": "Elsenborn"
  },
  {
    "id": 1034,
    "zipcode": 4750,
    "city": "Butgenbach"
  },
  {
    "id": 1035,
    "zipcode": 4760,
    "city": "Manderfeld"
  },
  {
    "id": 1036,
    "zipcode": 4760,
    "city": "Büllingen"
  },
  {
    "id": 1037,
    "zipcode": 4761,
    "city": "Rocherath"
  },
  {
    "id": 1038,
    "zipcode": 4770,
    "city": "Meyerode"
  },
  {
    "id": 1039,
    "zipcode": 4770,
    "city": "Amel"
  },
  {
    "id": 1040,
    "zipcode": 4771,
    "city": "Heppenbach"
  },
  {
    "id": 1041,
    "zipcode": 4780,
    "city": "Recht"
  },
  {
    "id": 1042,
    "zipcode": 4780,
    "city": "Sankt-Vith"
  },
  {
    "id": 1043,
    "zipcode": 4782,
    "city": "Schönberg"
  },
  {
    "id": 1044,
    "zipcode": 4783,
    "city": "Lommersweiler"
  },
  {
    "id": 1045,
    "zipcode": 4784,
    "city": "Crombach"
  },
  {
    "id": 1046,
    "zipcode": 4790,
    "city": "Reuland"
  },
  {
    "id": 1047,
    "zipcode": 4791,
    "city": "Thommen"
  },
  {
    "id": 1048,
    "zipcode": 4800,
    "city": "Ensival"
  },
  {
    "id": 1049,
    "zipcode": 4800,
    "city": "Lambermont"
  },
  {
    "id": 1050,
    "zipcode": 4800,
    "city": "Petit-Rechain"
  },
  {
    "id": 1051,
    "zipcode": 4800,
    "city": "Polleur"
  },
  {
    "id": 1052,
    "zipcode": 4800,
    "city": "Verviers"
  },
  {
    "id": 1053,
    "zipcode": 4801,
    "city": "Stembert"
  },
  {
    "id": 1054,
    "zipcode": 4802,
    "city": "Heusy"
  },
  {
    "id": 1055,
    "zipcode": 4820,
    "city": "Dison"
  },
  {
    "id": 1056,
    "zipcode": 4821,
    "city": "Andrimont"
  },
  {
    "id": 1057,
    "zipcode": 4830,
    "city": "Limbourg"
  },
  {
    "id": 1058,
    "zipcode": 4831,
    "city": "Bilstain"
  },
  {
    "id": 1059,
    "zipcode": 4834,
    "city": "Goé"
  },
  {
    "id": 1060,
    "zipcode": 4837,
    "city": "Membach"
  },
  {
    "id": 1061,
    "zipcode": 4837,
    "city": "Baelen"
  },
  {
    "id": 1062,
    "zipcode": 4840,
    "city": "Welkenraedt"
  },
  {
    "id": 1063,
    "zipcode": 4841,
    "city": "Henri-Chapelle"
  },
  {
    "id": 1064,
    "zipcode": 4845,
    "city": "Sart-lez-Spa"
  },
  {
    "id": 1065,
    "zipcode": 4845,
    "city": "Jalhay"
  },
  {
    "id": 1066,
    "zipcode": 4850,
    "city": "Montzen"
  },
  {
    "id": 1067,
    "zipcode": 4850,
    "city": "Moresnet"
  },
  {
    "id": 1068,
    "zipcode": 4851,
    "city": "Gemmenich"
  },
  {
    "id": 1069,
    "zipcode": 4851,
    "city": "Sippenaeken"
  },
  {
    "id": 1070,
    "zipcode": 4852,
    "city": "Hombourg"
  },
  {
    "id": 1071,
    "zipcode": 4860,
    "city": "Cornesse"
  },
  {
    "id": 1072,
    "zipcode": 4860,
    "city": "Wegnez"
  },
  {
    "id": 1073,
    "zipcode": 4860,
    "city": "Pepinster"
  },
  {
    "id": 1074,
    "zipcode": 4861,
    "city": "Soiron"
  },
  {
    "id": 1075,
    "zipcode": 4870,
    "city": "Forêt"
  },
  {
    "id": 1076,
    "zipcode": 4870,
    "city": "Fraipont"
  },
  {
    "id": 1077,
    "zipcode": 4870,
    "city": "Nessonvaux"
  },
  {
    "id": 1078,
    "zipcode": 4877,
    "city": "Olne"
  },
  {
    "id": 1079,
    "zipcode": 4880,
    "city": "Aubel"
  },
  {
    "id": 1080,
    "zipcode": 4890,
    "city": "Clermont"
  },
  {
    "id": 1081,
    "zipcode": 4890,
    "city": "Thimister"
  },
  {
    "id": 1082,
    "zipcode": 4900,
    "city": "Spa"
  },
  {
    "id": 1083,
    "zipcode": 4910,
    "city": "La Reid"
  },
  {
    "id": 1084,
    "zipcode": 4910,
    "city": "Polleur"
  },
  {
    "id": 1085,
    "zipcode": 4910,
    "city": "Theux"
  },
  {
    "id": 1086,
    "zipcode": 4920,
    "city": "Ernonheid"
  },
  {
    "id": 1087,
    "zipcode": 4920,
    "city": "Harzé"
  },
  {
    "id": 1088,
    "zipcode": 4920,
    "city": "Louveigné"
  },
  {
    "id": 1089,
    "zipcode": 4920,
    "city": "Sougné-Remouchamps"
  },
  {
    "id": 1090,
    "zipcode": 4920,
    "city": "Aywaille"
  },
  {
    "id": 1091,
    "zipcode": 4950,
    "city": "Faymonville"
  },
  {
    "id": 1092,
    "zipcode": 4950,
    "city": "Robertville"
  },
  {
    "id": 1093,
    "zipcode": 4950,
    "city": "Sourbrodt"
  },
  {
    "id": 1094,
    "zipcode": 4950,
    "city": "Weismes"
  },
  {
    "id": 1095,
    "zipcode": 4960,
    "city": "Bellevaux-Ligneuville"
  },
  {
    "id": 1096,
    "zipcode": 4960,
    "city": "Bevercé"
  },
  {
    "id": 1097,
    "zipcode": 4960,
    "city": "Malmedy"
  },
  {
    "id": 1098,
    "zipcode": 4970,
    "city": "Francorchamps"
  },
  {
    "id": 1099,
    "zipcode": 4970,
    "city": "Stavelot"
  },
  {
    "id": 1100,
    "zipcode": 4980,
    "city": "Fosse"
  },
  {
    "id": 1101,
    "zipcode": 4980,
    "city": "Wanne"
  },
  {
    "id": 1102,
    "zipcode": 4980,
    "city": "Trois-Ponts"
  },
  {
    "id": 1103,
    "zipcode": 4983,
    "city": "Basse-Bodeux"
  },
  {
    "id": 1104,
    "zipcode": 4987,
    "city": "Chevron"
  },
  {
    "id": 1105,
    "zipcode": 4987,
    "city": "La Gleize"
  },
  {
    "id": 1106,
    "zipcode": 4987,
    "city": "Lorcé"
  },
  {
    "id": 1107,
    "zipcode": 4987,
    "city": "Rahier"
  },
  {
    "id": 1108,
    "zipcode": 4987,
    "city": "Stoumont"
  },
  {
    "id": 1109,
    "zipcode": 4990,
    "city": "Arbrefontaine"
  },
  {
    "id": 1110,
    "zipcode": 4990,
    "city": "Bra"
  },
  {
    "id": 1111,
    "zipcode": 4990,
    "city": "Lierneux"
  },
  {
    "id": 1112,
    "zipcode": 5000,
    "city": "Beez"
  },
  {
    "id": 1113,
    "zipcode": 5000,
    "city": "Namur"
  },
  {
    "id": 1114,
    "zipcode": 5001,
    "city": "Belgrade"
  },
  {
    "id": 1115,
    "zipcode": 5002,
    "city": "Saint-Servais"
  },
  {
    "id": 1116,
    "zipcode": 5003,
    "city": "Saint-Marc"
  },
  {
    "id": 1117,
    "zipcode": 5004,
    "city": "Bouge"
  },
  {
    "id": 1118,
    "zipcode": 5020,
    "city": "Champion"
  },
  {
    "id": 1119,
    "zipcode": 5020,
    "city": "Daussoulx"
  },
  {
    "id": 1120,
    "zipcode": 5020,
    "city": "Flawinne"
  },
  {
    "id": 1121,
    "zipcode": 5020,
    "city": "Malonne"
  },
  {
    "id": 1122,
    "zipcode": 5020,
    "city": "Suarlée"
  },
  {
    "id": 1123,
    "zipcode": 5020,
    "city": "Temploux"
  },
  {
    "id": 1124,
    "zipcode": 5020,
    "city": "Vedrin"
  },
  {
    "id": 1125,
    "zipcode": 5021,
    "city": "Boninne"
  },
  {
    "id": 1126,
    "zipcode": 5022,
    "city": "Cognelée"
  },
  {
    "id": 1127,
    "zipcode": 5024,
    "city": "Gelbressée"
  },
  {
    "id": 1128,
    "zipcode": 5024,
    "city": "Marche-les-Dames"
  },
  {
    "id": 1129,
    "zipcode": 5030,
    "city": "Beuzet"
  },
  {
    "id": 1130,
    "zipcode": 5030,
    "city": "Ernage"
  },
  {
    "id": 1131,
    "zipcode": 5030,
    "city": "Grand-Manil"
  },
  {
    "id": 1132,
    "zipcode": 5030,
    "city": "Lonzée"
  },
  {
    "id": 1133,
    "zipcode": 5030,
    "city": "Sauvenière"
  },
  {
    "id": 1134,
    "zipcode": 5030,
    "city": "Gembloux"
  },
  {
    "id": 1135,
    "zipcode": 5031,
    "city": "Grand-Leez"
  },
  {
    "id": 1136,
    "zipcode": 5032,
    "city": "Bossière"
  },
  {
    "id": 1137,
    "zipcode": 5032,
    "city": "Bothey"
  },
  {
    "id": 1138,
    "zipcode": 5032,
    "city": "Corroy-le-Château"
  },
  {
    "id": 1139,
    "zipcode": 5032,
    "city": "Isnes"
  },
  {
    "id": 1140,
    "zipcode": 5032,
    "city": "Mazy"
  },
  {
    "id": 1141,
    "zipcode": 5060,
    "city": "Arsimont"
  },
  {
    "id": 1142,
    "zipcode": 5060,
    "city": "Auvelais"
  },
  {
    "id": 1143,
    "zipcode": 5060,
    "city": "Falisolle"
  },
  {
    "id": 1144,
    "zipcode": 5060,
    "city": "Keumiée"
  },
  {
    "id": 1145,
    "zipcode": 5060,
    "city": "Moignelée"
  },
  {
    "id": 1146,
    "zipcode": 5060,
    "city": "Tamines"
  },
  {
    "id": 1147,
    "zipcode": 5060,
    "city": "Velaine-sur-Sambre"
  },
  {
    "id": 1148,
    "zipcode": 5070,
    "city": "Aisemont"
  },
  {
    "id": 1149,
    "zipcode": 5070,
    "city": "Le Roux"
  },
  {
    "id": 1150,
    "zipcode": 5070,
    "city": "Sart-Eustache"
  },
  {
    "id": 1151,
    "zipcode": 5070,
    "city": "Sart-Saint-Laurent"
  },
  {
    "id": 1152,
    "zipcode": 5070,
    "city": "Vitrival"
  },
  {
    "id": 1153,
    "zipcode": 5070,
    "city": "Fosses-la-Ville"
  },
  {
    "id": 1154,
    "zipcode": 5080,
    "city": "Emines"
  },
  {
    "id": 1155,
    "zipcode": 5080,
    "city": "Rhisnes"
  },
  {
    "id": 1156,
    "zipcode": 5080,
    "city": "Villers-lez-Heest"
  },
  {
    "id": 1157,
    "zipcode": 5080,
    "city": "Warisoulx"
  },
  {
    "id": 1158,
    "zipcode": 5081,
    "city": "Bovesse"
  },
  {
    "id": 1159,
    "zipcode": 5081,
    "city": "Meux"
  },
  {
    "id": 1160,
    "zipcode": 5081,
    "city": "Saint-Denis-Bovesse"
  },
  {
    "id": 1161,
    "zipcode": 5100,
    "city": "Dave"
  },
  {
    "id": 1162,
    "zipcode": 5100,
    "city": "Jambes"
  },
  {
    "id": 1163,
    "zipcode": 5100,
    "city": "Naninne"
  },
  {
    "id": 1164,
    "zipcode": 5100,
    "city": "Wépion"
  },
  {
    "id": 1165,
    "zipcode": 5100,
    "city": "Wierde"
  },
  {
    "id": 1166,
    "zipcode": 5101,
    "city": "Erpent"
  },
  {
    "id": 1167,
    "zipcode": 5101,
    "city": "Lives-sur-Meuse"
  },
  {
    "id": 1168,
    "zipcode": 5101,
    "city": "Loyers"
  },
  {
    "id": 1169,
    "zipcode": 5140,
    "city": "Boignée"
  },
  {
    "id": 1170,
    "zipcode": 5140,
    "city": "Ligny"
  },
  {
    "id": 1171,
    "zipcode": 5140,
    "city": "Tongrinne"
  },
  {
    "id": 1172,
    "zipcode": 5140,
    "city": "Sombreffe"
  },
  {
    "id": 1173,
    "zipcode": 5150,
    "city": "Floriffoux"
  },
  {
    "id": 1174,
    "zipcode": 5150,
    "city": "Franière"
  },
  {
    "id": 1175,
    "zipcode": 5150,
    "city": "Soye"
  },
  {
    "id": 1176,
    "zipcode": 5150,
    "city": "Floreffe"
  },
  {
    "id": 1177,
    "zipcode": 5170,
    "city": "Arbre"
  },
  {
    "id": 1178,
    "zipcode": 5170,
    "city": "Bois-de-Villers"
  },
  {
    "id": 1179,
    "zipcode": 5170,
    "city": "Lesve"
  },
  {
    "id": 1180,
    "zipcode": 5170,
    "city": "Lustin"
  },
  {
    "id": 1181,
    "zipcode": 5170,
    "city": "Rivière"
  },
  {
    "id": 1182,
    "zipcode": 5170,
    "city": "Profondeville"
  },
  {
    "id": 1183,
    "zipcode": 5190,
    "city": "Balâtre"
  },
  {
    "id": 1184,
    "zipcode": 5190,
    "city": "Ham-sur-Sambre"
  },
  {
    "id": 1185,
    "zipcode": 5190,
    "city": "Mornimont"
  },
  {
    "id": 1186,
    "zipcode": 5190,
    "city": "Moustier-sur-Sambre"
  },
  {
    "id": 1187,
    "zipcode": 5190,
    "city": "Onoz"
  },
  {
    "id": 1188,
    "zipcode": 5190,
    "city": "Saint-Martin"
  },
  {
    "id": 1189,
    "zipcode": 5190,
    "city": "Spy"
  },
  {
    "id": 1190,
    "zipcode": 5190,
    "city": "Jemeppe-sur-Sambre"
  },
  {
    "id": 1191,
    "zipcode": 5300,
    "city": "Bonneville"
  },
  {
    "id": 1192,
    "zipcode": 5300,
    "city": "Coutisse"
  },
  {
    "id": 1193,
    "zipcode": 5300,
    "city": "Landenne"
  },
  {
    "id": 1194,
    "zipcode": 5300,
    "city": "Maizeret"
  },
  {
    "id": 1195,
    "zipcode": 5300,
    "city": "Namêche"
  },
  {
    "id": 1196,
    "zipcode": 5300,
    "city": "Sclayn"
  },
  {
    "id": 1197,
    "zipcode": 5300,
    "city": "Seilles"
  },
  {
    "id": 1198,
    "zipcode": 5300,
    "city": "Thon"
  },
  {
    "id": 1199,
    "zipcode": 5300,
    "city": "Vezin"
  },
  {
    "id": 1200,
    "zipcode": 5300,
    "city": "Andenne"
  },
  {
    "id": 1201,
    "zipcode": 5310,
    "city": "Aische-en-Refail"
  },
  {
    "id": 1202,
    "zipcode": 5310,
    "city": "Bolinne"
  },
  {
    "id": 1203,
    "zipcode": 5310,
    "city": "Boneffe"
  },
  {
    "id": 1204,
    "zipcode": 5310,
    "city": "Branchon"
  },
  {
    "id": 1205,
    "zipcode": 5310,
    "city": "Dhuy"
  },
  {
    "id": 1206,
    "zipcode": 5310,
    "city": "Hanret"
  },
  {
    "id": 1207,
    "zipcode": 5310,
    "city": "Leuze"
  },
  {
    "id": 1208,
    "zipcode": 5310,
    "city": "Liernu"
  },
  {
    "id": 1209,
    "zipcode": 5310,
    "city": "Longchamps"
  },
  {
    "id": 1210,
    "zipcode": 5310,
    "city": "Mehaigne"
  },
  {
    "id": 1211,
    "zipcode": 5310,
    "city": "Noville-sur-Mehaigne"
  },
  {
    "id": 1212,
    "zipcode": 5310,
    "city": "Saint-Germain"
  },
  {
    "id": 1213,
    "zipcode": 5310,
    "city": "Taviers"
  },
  {
    "id": 1214,
    "zipcode": 5310,
    "city": "Upigny"
  },
  {
    "id": 1215,
    "zipcode": 5310,
    "city": "Waret-la-Chaussée"
  },
  {
    "id": 1216,
    "zipcode": 5310,
    "city": "Eghezée"
  },
  {
    "id": 1217,
    "zipcode": 5330,
    "city": "Maillen"
  },
  {
    "id": 1218,
    "zipcode": 5330,
    "city": "Sart-Bernard"
  },
  {
    "id": 1219,
    "zipcode": 5330,
    "city": "Assesse"
  },
  {
    "id": 1220,
    "zipcode": 5332,
    "city": "Crupet"
  },
  {
    "id": 1221,
    "zipcode": 5333,
    "city": "Sorinne-la-Longue"
  },
  {
    "id": 1222,
    "zipcode": 5334,
    "city": "Florée"
  },
  {
    "id": 1223,
    "zipcode": 5336,
    "city": "Courrière"
  },
  {
    "id": 1224,
    "zipcode": 5340,
    "city": "Faulx-les-Tombes"
  },
  {
    "id": 1225,
    "zipcode": 5340,
    "city": "Haltinne"
  },
  {
    "id": 1226,
    "zipcode": 5340,
    "city": "Mozet"
  },
  {
    "id": 1227,
    "zipcode": 5340,
    "city": "Sorée"
  },
  {
    "id": 1228,
    "zipcode": 5340,
    "city": "Gesves"
  },
  {
    "id": 1229,
    "zipcode": 5350,
    "city": "Evelette"
  },
  {
    "id": 1230,
    "zipcode": 5350,
    "city": "Ohey"
  },
  {
    "id": 1231,
    "zipcode": 5351,
    "city": "Haillot"
  },
  {
    "id": 1232,
    "zipcode": 5352,
    "city": "Perwez-Haillot"
  },
  {
    "id": 1233,
    "zipcode": 5353,
    "city": "Goesnes"
  },
  {
    "id": 1234,
    "zipcode": 5354,
    "city": "Jallet"
  },
  {
    "id": 1235,
    "zipcode": 5360,
    "city": "Natoye"
  },
  {
    "id": 1236,
    "zipcode": 5360,
    "city": "Hamois"
  },
  {
    "id": 1237,
    "zipcode": 5361,
    "city": "Mohiville"
  },
  {
    "id": 1238,
    "zipcode": 5361,
    "city": "Scy"
  },
  {
    "id": 1239,
    "zipcode": 5362,
    "city": "Achet"
  },
  {
    "id": 1240,
    "zipcode": 5363,
    "city": "Emptinne"
  },
  {
    "id": 1241,
    "zipcode": 5364,
    "city": "Schaltin"
  },
  {
    "id": 1242,
    "zipcode": 5370,
    "city": "Barvaux-Condroz"
  },
  {
    "id": 1243,
    "zipcode": 5370,
    "city": "Flostoy"
  },
  {
    "id": 1244,
    "zipcode": 5370,
    "city": "Jeneffe"
  },
  {
    "id": 1245,
    "zipcode": 5370,
    "city": "Porcheresse"
  },
  {
    "id": 1246,
    "zipcode": 5370,
    "city": "Verlée"
  },
  {
    "id": 1247,
    "zipcode": 5370,
    "city": "Havelange"
  },
  {
    "id": 1248,
    "zipcode": 5372,
    "city": "Méan"
  },
  {
    "id": 1249,
    "zipcode": 5374,
    "city": "Maffe"
  },
  {
    "id": 1250,
    "zipcode": 5376,
    "city": "Miécret"
  },
  {
    "id": 1251,
    "zipcode": 5377,
    "city": "Baillonville"
  },
  {
    "id": 1252,
    "zipcode": 5377,
    "city": "Bonsin"
  },
  {
    "id": 1253,
    "zipcode": 5377,
    "city": "Heure"
  },
  {
    "id": 1254,
    "zipcode": 5377,
    "city": "Hogne"
  },
  {
    "id": 1255,
    "zipcode": 5377,
    "city": "Nettinne"
  },
  {
    "id": 1256,
    "zipcode": 5377,
    "city": "Noiseux"
  },
  {
    "id": 1257,
    "zipcode": 5377,
    "city": "Sinsin"
  },
  {
    "id": 1258,
    "zipcode": 5377,
    "city": "Waillet"
  },
  {
    "id": 1259,
    "zipcode": 5377,
    "city": "Somme-Leuze"
  },
  {
    "id": 1260,
    "zipcode": 5380,
    "city": "Bierwart"
  },
  {
    "id": 1261,
    "zipcode": 5380,
    "city": "Cortil-Wodon"
  },
  {
    "id": 1262,
    "zipcode": 5380,
    "city": "Forville"
  },
  {
    "id": 1263,
    "zipcode": 5380,
    "city": "Franc-Waret"
  },
  {
    "id": 1264,
    "zipcode": 5380,
    "city": "Hemptinne"
  },
  {
    "id": 1265,
    "zipcode": 5380,
    "city": "Hingeon"
  },
  {
    "id": 1266,
    "zipcode": 5380,
    "city": "Marchovelette"
  },
  {
    "id": 1267,
    "zipcode": 5380,
    "city": "Noville-les-Bois"
  },
  {
    "id": 1268,
    "zipcode": 5380,
    "city": "Pontillas"
  },
  {
    "id": 1269,
    "zipcode": 5380,
    "city": "Tillier"
  },
  {
    "id": 1270,
    "zipcode": 5500,
    "city": "Anseremme"
  },
  {
    "id": 1271,
    "zipcode": 5500,
    "city": "Bouvignes-sur-Meuse"
  },
  {
    "id": 1272,
    "zipcode": 5500,
    "city": "Dréhance"
  },
  {
    "id": 1273,
    "zipcode": 5500,
    "city": "Falmagne"
  },
  {
    "id": 1274,
    "zipcode": 5500,
    "city": "Falmignoul"
  },
  {
    "id": 1275,
    "zipcode": 5500,
    "city": "Furfooz"
  },
  {
    "id": 1276,
    "zipcode": 5500,
    "city": "Dinant"
  },
  {
    "id": 1277,
    "zipcode": 5501,
    "city": "Lisogne"
  },
  {
    "id": 1278,
    "zipcode": 5502,
    "city": "Thynes"
  },
  {
    "id": 1279,
    "zipcode": 5503,
    "city": "Sorinnes"
  },
  {
    "id": 1280,
    "zipcode": 5504,
    "city": "Foy-Notre-Dame"
  },
  {
    "id": 1281,
    "zipcode": 5520,
    "city": "Anthée"
  },
  {
    "id": 1282,
    "zipcode": 5520,
    "city": "Onhaye"
  },
  {
    "id": 1283,
    "zipcode": 5521,
    "city": "Serville"
  },
  {
    "id": 1284,
    "zipcode": 5522,
    "city": "Falaën"
  },
  {
    "id": 1285,
    "zipcode": 5523,
    "city": "Sommière"
  },
  {
    "id": 1286,
    "zipcode": 5523,
    "city": "Weillen"
  },
  {
    "id": 1287,
    "zipcode": 5524,
    "city": "Gérin"
  },
  {
    "id": 1288,
    "zipcode": 5530,
    "city": "Dorinne"
  },
  {
    "id": 1289,
    "zipcode": 5530,
    "city": "Durnal"
  },
  {
    "id": 1290,
    "zipcode": 5530,
    "city": "Evrehailles"
  },
  {
    "id": 1291,
    "zipcode": 5530,
    "city": "Godinne"
  },
  {
    "id": 1292,
    "zipcode": 5530,
    "city": "Houx"
  },
  {
    "id": 1293,
    "zipcode": 5530,
    "city": "Mont"
  },
  {
    "id": 1294,
    "zipcode": 5530,
    "city": "Purnode"
  },
  {
    "id": 1295,
    "zipcode": 5530,
    "city": "Spontin"
  },
  {
    "id": 1296,
    "zipcode": 5530,
    "city": "Yvoir"
  },
  {
    "id": 1297,
    "zipcode": 5537,
    "city": "Annevoie-Rouillon"
  },
  {
    "id": 1298,
    "zipcode": 5537,
    "city": "Bioul"
  },
  {
    "id": 1299,
    "zipcode": 5537,
    "city": "Denée"
  },
  {
    "id": 1300,
    "zipcode": 5537,
    "city": "Haut-le-Wastia"
  },
  {
    "id": 1301,
    "zipcode": 5537,
    "city": "Sosoye"
  },
  {
    "id": 1302,
    "zipcode": 5537,
    "city": "Warnant"
  },
  {
    "id": 1303,
    "zipcode": 5537,
    "city": "Anhée"
  },
  {
    "id": 1304,
    "zipcode": 5540,
    "city": "Hastière-Lavaux"
  },
  {
    "id": 1305,
    "zipcode": 5540,
    "city": "Hermeton-sur-Meuse"
  },
  {
    "id": 1306,
    "zipcode": 5540,
    "city": "Waulsort"
  },
  {
    "id": 1307,
    "zipcode": 5541,
    "city": "Hastière-par-Delà"
  },
  {
    "id": 1308,
    "zipcode": 5542,
    "city": "Blaimont"
  },
  {
    "id": 1309,
    "zipcode": 5543,
    "city": "Heer"
  },
  {
    "id": 1310,
    "zipcode": 5544,
    "city": "Agimont"
  },
  {
    "id": 1311,
    "zipcode": 5550,
    "city": "Alle"
  },
  {
    "id": 1312,
    "zipcode": 5550,
    "city": "Bagimont"
  },
  {
    "id": 1313,
    "zipcode": 5550,
    "city": "Bohan"
  },
  {
    "id": 1314,
    "zipcode": 5550,
    "city": "Chairière"
  },
  {
    "id": 1315,
    "zipcode": 5550,
    "city": "Laforêt"
  },
  {
    "id": 1316,
    "zipcode": 5550,
    "city": "Membre"
  },
  {
    "id": 1317,
    "zipcode": 5550,
    "city": "Mouzaive"
  },
  {
    "id": 1318,
    "zipcode": 5550,
    "city": "Nafraiture"
  },
  {
    "id": 1319,
    "zipcode": 5550,
    "city": "Orchimont"
  },
  {
    "id": 1320,
    "zipcode": 5550,
    "city": "Pussemange"
  },
  {
    "id": 1321,
    "zipcode": 5550,
    "city": "Sugny"
  },
  {
    "id": 1322,
    "zipcode": 5550,
    "city": "Vresse-sur-Semois"
  },
  {
    "id": 1323,
    "zipcode": 5555,
    "city": "Baillamont"
  },
  {
    "id": 1324,
    "zipcode": 5555,
    "city": "Bellefontaine"
  },
  {
    "id": 1325,
    "zipcode": 5555,
    "city": "Cornimont"
  },
  {
    "id": 1326,
    "zipcode": 5555,
    "city": "Graide"
  },
  {
    "id": 1327,
    "zipcode": 5555,
    "city": "Gros-Fays"
  },
  {
    "id": 1328,
    "zipcode": 5555,
    "city": "Monceau-en-Ardenne"
  },
  {
    "id": 1329,
    "zipcode": 5555,
    "city": "Naomé"
  },
  {
    "id": 1330,
    "zipcode": 5555,
    "city": "Oizy"
  },
  {
    "id": 1331,
    "zipcode": 5555,
    "city": "Petit-Fays"
  },
  {
    "id": 1332,
    "zipcode": 5555,
    "city": "Bièvre"
  },
  {
    "id": 1333,
    "zipcode": 5560,
    "city": "Ciergnon"
  },
  {
    "id": 1334,
    "zipcode": 5560,
    "city": "Finnevaux"
  },
  {
    "id": 1335,
    "zipcode": 5560,
    "city": "Hulsonniaux"
  },
  {
    "id": 1336,
    "zipcode": 5560,
    "city": "Mesnil-Eglise"
  },
  {
    "id": 1337,
    "zipcode": 5560,
    "city": "Mesnil-Saint-Blaise"
  },
  {
    "id": 1338,
    "zipcode": 5560,
    "city": "Houyet"
  },
  {
    "id": 1339,
    "zipcode": 5561,
    "city": "Celles"
  },
  {
    "id": 1340,
    "zipcode": 5562,
    "city": "Custinne"
  },
  {
    "id": 1341,
    "zipcode": 5563,
    "city": "Hour"
  },
  {
    "id": 1342,
    "zipcode": 5564,
    "city": "Wanlin"
  },
  {
    "id": 1343,
    "zipcode": 5570,
    "city": "Baronville"
  },
  {
    "id": 1344,
    "zipcode": 5570,
    "city": "Dion"
  },
  {
    "id": 1345,
    "zipcode": 5570,
    "city": "Felenne"
  },
  {
    "id": 1346,
    "zipcode": 5570,
    "city": "Feschaux"
  },
  {
    "id": 1347,
    "zipcode": 5570,
    "city": "Honnay"
  },
  {
    "id": 1348,
    "zipcode": 5570,
    "city": "Javingue"
  },
  {
    "id": 1349,
    "zipcode": 5570,
    "city": "Vonêche"
  },
  {
    "id": 1350,
    "zipcode": 5570,
    "city": "Wancennes"
  },
  {
    "id": 1351,
    "zipcode": 5570,
    "city": "Winenne"
  },
  {
    "id": 1352,
    "zipcode": 5570,
    "city": "Beauraing"
  },
  {
    "id": 1353,
    "zipcode": 5571,
    "city": "Wiesme"
  },
  {
    "id": 1354,
    "zipcode": 5572,
    "city": "Focant"
  },
  {
    "id": 1355,
    "zipcode": 5573,
    "city": "Martouzin-Neuville"
  },
  {
    "id": 1356,
    "zipcode": 5574,
    "city": "Pondrôme"
  },
  {
    "id": 1357,
    "zipcode": 5575,
    "city": "Bourseigne-Neuve"
  },
  {
    "id": 1358,
    "zipcode": 5575,
    "city": "Bourseigne-Vieille"
  },
  {
    "id": 1359,
    "zipcode": 5575,
    "city": "Houdremont"
  },
  {
    "id": 1360,
    "zipcode": 5575,
    "city": "Louette-Saint-Denis"
  },
  {
    "id": 1361,
    "zipcode": 5575,
    "city": "Louette-Saint-Pierre"
  },
  {
    "id": 1362,
    "zipcode": 5575,
    "city": "Malvoisin"
  },
  {
    "id": 1363,
    "zipcode": 5575,
    "city": "Patignies"
  },
  {
    "id": 1364,
    "zipcode": 5575,
    "city": "Rienne"
  },
  {
    "id": 1365,
    "zipcode": 5575,
    "city": "Sart-Custinne"
  },
  {
    "id": 1366,
    "zipcode": 5575,
    "city": "Vencimont"
  },
  {
    "id": 1367,
    "zipcode": 5575,
    "city": "Willerzie"
  },
  {
    "id": 1368,
    "zipcode": 5575,
    "city": "Gedinne"
  },
  {
    "id": 1369,
    "zipcode": 5576,
    "city": "Froidfontaine"
  },
  {
    "id": 1370,
    "zipcode": 5580,
    "city": "Ave-et-Auffe"
  },
  {
    "id": 1371,
    "zipcode": 5580,
    "city": "Buissonville"
  },
  {
    "id": 1372,
    "zipcode": 5580,
    "city": "Eprave"
  },
  {
    "id": 1373,
    "zipcode": 5580,
    "city": "Han-sur-Lesse"
  },
  {
    "id": 1374,
    "zipcode": 5580,
    "city": "Jemelle"
  },
  {
    "id": 1375,
    "zipcode": 5580,
    "city": "Lavaux-Sainte-Anne"
  },
  {
    "id": 1376,
    "zipcode": 5580,
    "city": "Lessive"
  },
  {
    "id": 1377,
    "zipcode": 5580,
    "city": "Mont-Gauthier"
  },
  {
    "id": 1378,
    "zipcode": 5580,
    "city": "Villers-sur-Lesse"
  },
  {
    "id": 1379,
    "zipcode": 5580,
    "city": "Wavreille"
  },
  {
    "id": 1380,
    "zipcode": 5580,
    "city": "Rochefort"
  },
  {
    "id": 1381,
    "zipcode": 5590,
    "city": "Achêne"
  },
  {
    "id": 1382,
    "zipcode": 5590,
    "city": "Braibant"
  },
  {
    "id": 1383,
    "zipcode": 5590,
    "city": "Chevetogne"
  },
  {
    "id": 1384,
    "zipcode": 5590,
    "city": "Conneux"
  },
  {
    "id": 1385,
    "zipcode": 5590,
    "city": "Haversin"
  },
  {
    "id": 1386,
    "zipcode": 5590,
    "city": "Leignon"
  },
  {
    "id": 1387,
    "zipcode": 5590,
    "city": "Pessoux"
  },
  {
    "id": 1388,
    "zipcode": 5590,
    "city": "Serinchamps"
  },
  {
    "id": 1389,
    "zipcode": 5590,
    "city": "Sovet"
  },
  {
    "id": 1390,
    "zipcode": 5590,
    "city": "Ciney"
  },
  {
    "id": 1391,
    "zipcode": 5600,
    "city": "Fagnolle"
  },
  {
    "id": 1392,
    "zipcode": 5600,
    "city": "Franchimont"
  },
  {
    "id": 1393,
    "zipcode": 5600,
    "city": "Jamagne"
  },
  {
    "id": 1394,
    "zipcode": 5600,
    "city": "Jamiolle"
  },
  {
    "id": 1395,
    "zipcode": 5600,
    "city": "Merlemont"
  },
  {
    "id": 1396,
    "zipcode": 5600,
    "city": "Neuville"
  },
  {
    "id": 1397,
    "zipcode": 5600,
    "city": "Omezée"
  },
  {
    "id": 1398,
    "zipcode": 5600,
    "city": "Roly"
  },
  {
    "id": 1399,
    "zipcode": 5600,
    "city": "Romedenne"
  },
  {
    "id": 1400,
    "zipcode": 5600,
    "city": "Samart"
  },
  {
    "id": 1401,
    "zipcode": 5600,
    "city": "Sart-en-Fagne"
  },
  {
    "id": 1402,
    "zipcode": 5600,
    "city": "Sautour"
  },
  {
    "id": 1403,
    "zipcode": 5600,
    "city": "Surice"
  },
  {
    "id": 1404,
    "zipcode": 5600,
    "city": "Villers-en-Fagne"
  },
  {
    "id": 1405,
    "zipcode": 5600,
    "city": "Villers-le-Gambon"
  },
  {
    "id": 1406,
    "zipcode": 5600,
    "city": "Vodecée"
  },
  {
    "id": 1407,
    "zipcode": 5600,
    "city": "Philippeville"
  },
  {
    "id": 1408,
    "zipcode": 5620,
    "city": "Corenne"
  },
  {
    "id": 1409,
    "zipcode": 5620,
    "city": "Flavion"
  },
  {
    "id": 1410,
    "zipcode": 5620,
    "city": "Hemptinne-lez-Florennes"
  },
  {
    "id": 1411,
    "zipcode": 5620,
    "city": "Morville"
  },
  {
    "id": 1412,
    "zipcode": 5620,
    "city": "Rosée"
  },
  {
    "id": 1413,
    "zipcode": 5620,
    "city": "Saint-Aubin"
  },
  {
    "id": 1414,
    "zipcode": 5620,
    "city": "Florennes"
  },
  {
    "id": 1415,
    "zipcode": 5621,
    "city": "Hanzinelle"
  },
  {
    "id": 1416,
    "zipcode": 5621,
    "city": "Hanzinne"
  },
  {
    "id": 1417,
    "zipcode": 5621,
    "city": "Morialmé"
  },
  {
    "id": 1418,
    "zipcode": 5621,
    "city": "Thy-le-Bauduin"
  },
  {
    "id": 1419,
    "zipcode": 5630,
    "city": "Daussois"
  },
  {
    "id": 1420,
    "zipcode": 5630,
    "city": "Senzeilles"
  },
  {
    "id": 1421,
    "zipcode": 5630,
    "city": "Silenrieux"
  },
  {
    "id": 1422,
    "zipcode": 5630,
    "city": "Soumoy"
  },
  {
    "id": 1423,
    "zipcode": 5630,
    "city": "Villers-Deux-Eglises"
  },
  {
    "id": 1424,
    "zipcode": 5630,
    "city": "Cerfontaine"
  },
  {
    "id": 1425,
    "zipcode": 5640,
    "city": "Biesme"
  },
  {
    "id": 1426,
    "zipcode": 5640,
    "city": "Biesmerée"
  },
  {
    "id": 1427,
    "zipcode": 5640,
    "city": "Graux"
  },
  {
    "id": 1428,
    "zipcode": 5640,
    "city": "Oret"
  },
  {
    "id": 1429,
    "zipcode": 5640,
    "city": "Saint-Gérard"
  },
  {
    "id": 1430,
    "zipcode": 5640,
    "city": "Mettet"
  },
  {
    "id": 1431,
    "zipcode": 5641,
    "city": "Furnaux"
  },
  {
    "id": 1432,
    "zipcode": 5644,
    "city": "Ermeton-sur-Biert"
  },
  {
    "id": 1433,
    "zipcode": 5646,
    "city": "Stave"
  },
  {
    "id": 1434,
    "zipcode": 5650,
    "city": "Castillon"
  },
  {
    "id": 1435,
    "zipcode": 5650,
    "city": "Chastrès"
  },
  {
    "id": 1436,
    "zipcode": 5650,
    "city": "Clermont"
  },
  {
    "id": 1437,
    "zipcode": 5650,
    "city": "Fontenelle"
  },
  {
    "id": 1438,
    "zipcode": 5650,
    "city": "Fraire"
  },
  {
    "id": 1439,
    "zipcode": 5650,
    "city": "Pry"
  },
  {
    "id": 1440,
    "zipcode": 5650,
    "city": "Vogenée"
  },
  {
    "id": 1441,
    "zipcode": 5650,
    "city": "Yves-Gomezée"
  },
  {
    "id": 1442,
    "zipcode": 5650,
    "city": "Walcourt"
  },
  {
    "id": 1443,
    "zipcode": 5651,
    "city": "Berzée"
  },
  {
    "id": 1444,
    "zipcode": 5651,
    "city": "Gourdinne"
  },
  {
    "id": 1445,
    "zipcode": 5651,
    "city": "Laneffe"
  },
  {
    "id": 1446,
    "zipcode": 5651,
    "city": "Rognée"
  },
  {
    "id": 1447,
    "zipcode": 5651,
    "city": "Somzée"
  },
  {
    "id": 1448,
    "zipcode": 5651,
    "city": "Tarcienne"
  },
  {
    "id": 1449,
    "zipcode": 5651,
    "city": "Thy-le-Château"
  },
  {
    "id": 1450,
    "zipcode": 5660,
    "city": "Aublain"
  },
  {
    "id": 1451,
    "zipcode": 5660,
    "city": "Boussu-en-Fagne"
  },
  {
    "id": 1452,
    "zipcode": 5660,
    "city": "Brûly"
  },
  {
    "id": 1453,
    "zipcode": 5660,
    "city": "Brûly-de-Pesche"
  },
  {
    "id": 1454,
    "zipcode": 5660,
    "city": "Cul-des-Sarts"
  },
  {
    "id": 1455,
    "zipcode": 5660,
    "city": "Dailly"
  },
  {
    "id": 1456,
    "zipcode": 5660,
    "city": "Frasnes"
  },
  {
    "id": 1457,
    "zipcode": 5660,
    "city": "Gonrieux"
  },
  {
    "id": 1458,
    "zipcode": 5660,
    "city": "Mariembourg"
  },
  {
    "id": 1459,
    "zipcode": 5660,
    "city": "Pesche"
  },
  {
    "id": 1460,
    "zipcode": 5660,
    "city": "Pétigny"
  },
  {
    "id": 1461,
    "zipcode": 5660,
    "city": "Petite-Chapelle"
  },
  {
    "id": 1462,
    "zipcode": 5660,
    "city": "Presgaux"
  },
  {
    "id": 1463,
    "zipcode": 5660,
    "city": "Couvin"
  },
  {
    "id": 1464,
    "zipcode": 5670,
    "city": "Dourbes"
  },
  {
    "id": 1465,
    "zipcode": 5670,
    "city": "Le Mesnil"
  },
  {
    "id": 1466,
    "zipcode": 5670,
    "city": "Mazée"
  },
  {
    "id": 1467,
    "zipcode": 5670,
    "city": "Nismes"
  },
  {
    "id": 1468,
    "zipcode": 5670,
    "city": "Oignies-en-Thiérache"
  },
  {
    "id": 1469,
    "zipcode": 5670,
    "city": "Olloy-Sur-Viroin"
  },
  {
    "id": 1470,
    "zipcode": 5670,
    "city": "Treignes"
  },
  {
    "id": 1471,
    "zipcode": 5670,
    "city": "Vierves-sur-Viroin"
  },
  {
    "id": 1472,
    "zipcode": 5680,
    "city": "Gimnée"
  },
  {
    "id": 1473,
    "zipcode": 5680,
    "city": "Gochenée"
  },
  {
    "id": 1474,
    "zipcode": 5680,
    "city": "Matagne-la-Grande"
  },
  {
    "id": 1475,
    "zipcode": 5680,
    "city": "Matagne-la-Petite"
  },
  {
    "id": 1476,
    "zipcode": 5680,
    "city": "Niverlée"
  },
  {
    "id": 1477,
    "zipcode": 5680,
    "city": "Romerée"
  },
  {
    "id": 1478,
    "zipcode": 5680,
    "city": "Soulme"
  },
  {
    "id": 1479,
    "zipcode": 5680,
    "city": "Vaucelles"
  },
  {
    "id": 1480,
    "zipcode": 5680,
    "city": "Vodelée"
  },
  {
    "id": 1481,
    "zipcode": 5680,
    "city": "Doische"
  },
  {
    "id": 1482,
    "zipcode": 6000,
    "city": "Charleroi"
  },
  {
    "id": 1483,
    "zipcode": 6001,
    "city": "Marcinelle"
  },
  {
    "id": 1484,
    "zipcode": 6010,
    "city": "Couillet"
  },
  {
    "id": 1485,
    "zipcode": 6020,
    "city": "Dampremy"
  },
  {
    "id": 1486,
    "zipcode": 6030,
    "city": "Goutroux"
  },
  {
    "id": 1487,
    "zipcode": 6030,
    "city": "Marchienne-au-Pont"
  },
  {
    "id": 1488,
    "zipcode": 6031,
    "city": "Monceau-sur-Sambre"
  },
  {
    "id": 1489,
    "zipcode": 6032,
    "city": "Mont-sur-Marchienne"
  },
  {
    "id": 1490,
    "zipcode": 6040,
    "city": "Jumet"
  },
  {
    "id": 1491,
    "zipcode": 6041,
    "city": "Gosselies"
  },
  {
    "id": 1492,
    "zipcode": 6042,
    "city": "Lodelinsart"
  },
  {
    "id": 1493,
    "zipcode": 6043,
    "city": "Ransart"
  },
  {
    "id": 1494,
    "zipcode": 6044,
    "city": "Roux"
  },
  {
    "id": 1495,
    "zipcode": 6060,
    "city": "Gilly"
  },
  {
    "id": 1496,
    "zipcode": 6061,
    "city": "Montignies-sur-Sambre"
  },
  {
    "id": 1497,
    "zipcode": 6110,
    "city": "Montigny-le-Tilleul"
  },
  {
    "id": 1498,
    "zipcode": 6111,
    "city": "Landelies"
  },
  {
    "id": 1499,
    "zipcode": 6120,
    "city": "Cour-sur-Heure"
  },
  {
    "id": 1500,
    "zipcode": 6120,
    "city": "Jamioulx"
  },
  {
    "id": 1501,
    "zipcode": 6120,
    "city": "Marbaix"
  },
  {
    "id": 1502,
    "zipcode": 6120,
    "city": "Nalinnes"
  },
  {
    "id": 1503,
    "zipcode": 6120,
    "city": "Ham-sur-Heure"
  },
  {
    "id": 1504,
    "zipcode": 6140,
    "city": "Fontaine-l'Évêque"
  },
  {
    "id": 1505,
    "zipcode": 6141,
    "city": "Forchies-La-Marche"
  },
  {
    "id": 1506,
    "zipcode": 6142,
    "city": "Leernes"
  },
  {
    "id": 1507,
    "zipcode": 6150,
    "city": "Anderlues"
  },
  {
    "id": 1508,
    "zipcode": 6180,
    "city": "Courcelles"
  },
  {
    "id": 1509,
    "zipcode": 6181,
    "city": "Gouy-lez-Piéton"
  },
  {
    "id": 1510,
    "zipcode": 6182,
    "city": "Souvret"
  },
  {
    "id": 1511,
    "zipcode": 6183,
    "city": "Trazegnies"
  },
  {
    "id": 1512,
    "zipcode": 6200,
    "city": "Bouffioulx"
  },
  {
    "id": 1513,
    "zipcode": 6200,
    "city": "Châtelineau"
  },
  {
    "id": 1514,
    "zipcode": 6200,
    "city": "Châtelet"
  },
  {
    "id": 1515,
    "zipcode": 6210,
    "city": "Frasnes-lez-Gosselies"
  },
  {
    "id": 1516,
    "zipcode": 6210,
    "city": "Rèves"
  },
  {
    "id": 1517,
    "zipcode": 6210,
    "city": "Villers-Perwin"
  },
  {
    "id": 1518,
    "zipcode": 6210,
    "city": "Wayaux"
  },
  {
    "id": 1519,
    "zipcode": 6211,
    "city": "Mellet"
  },
  {
    "id": 1520,
    "zipcode": 6220,
    "city": "Heppignies"
  },
  {
    "id": 1521,
    "zipcode": 6220,
    "city": "Lambusart"
  },
  {
    "id": 1522,
    "zipcode": 6220,
    "city": "Wangenies"
  },
  {
    "id": 1523,
    "zipcode": 6220,
    "city": "Fleurus"
  },
  {
    "id": 1524,
    "zipcode": 6221,
    "city": "Saint-Amand"
  },
  {
    "id": 1525,
    "zipcode": 6222,
    "city": "Brye"
  },
  {
    "id": 1526,
    "zipcode": 6223,
    "city": "Wagnelée"
  },
  {
    "id": 1527,
    "zipcode": 6224,
    "city": "Wanfercée-Baulet"
  },
  {
    "id": 1528,
    "zipcode": 6230,
    "city": "Buzet"
  },
  {
    "id": 1529,
    "zipcode": 6230,
    "city": "Obaix"
  },
  {
    "id": 1530,
    "zipcode": 6230,
    "city": "Thiméon"
  },
  {
    "id": 1531,
    "zipcode": 6230,
    "city": "Viesville"
  },
  {
    "id": 1532,
    "zipcode": 6230,
    "city": "Pont-à-Celles"
  },
  {
    "id": 1533,
    "zipcode": 6238,
    "city": "Liberchies"
  },
  {
    "id": 1534,
    "zipcode": 6238,
    "city": "Luttre"
  },
  {
    "id": 1535,
    "zipcode": 6240,
    "city": "Pironchamps"
  },
  {
    "id": 1536,
    "zipcode": 6240,
    "city": "Farciennes"
  },
  {
    "id": 1537,
    "zipcode": 6250,
    "city": "Aiseau"
  },
  {
    "id": 1538,
    "zipcode": 6250,
    "city": "Pont-de-Loup"
  },
  {
    "id": 1539,
    "zipcode": 6250,
    "city": "Presles"
  },
  {
    "id": 1540,
    "zipcode": 6250,
    "city": "Roselies"
  },
  {
    "id": 1541,
    "zipcode": 6280,
    "city": "Acoz"
  },
  {
    "id": 1542,
    "zipcode": 6280,
    "city": "Gougnies"
  },
  {
    "id": 1543,
    "zipcode": 6280,
    "city": "Joncret"
  },
  {
    "id": 1544,
    "zipcode": 6280,
    "city": "Loverval"
  },
  {
    "id": 1545,
    "zipcode": 6280,
    "city": "Villers-Poterie"
  },
  {
    "id": 1546,
    "zipcode": 6280,
    "city": "Gerpinnes"
  },
  {
    "id": 1547,
    "zipcode": 6440,
    "city": "Boussu-lez-Walcourt"
  },
  {
    "id": 1548,
    "zipcode": 6440,
    "city": "Fourbechies"
  },
  {
    "id": 1549,
    "zipcode": 6440,
    "city": "Vergnies"
  },
  {
    "id": 1550,
    "zipcode": 6440,
    "city": "Froidchapelle"
  },
  {
    "id": 1551,
    "zipcode": 6441,
    "city": "Erpion"
  },
  {
    "id": 1552,
    "zipcode": 6460,
    "city": "Bailièvre"
  },
  {
    "id": 1553,
    "zipcode": 6460,
    "city": "Robechies"
  },
  {
    "id": 1554,
    "zipcode": 6460,
    "city": "Saint-Remy"
  },
  {
    "id": 1555,
    "zipcode": 6460,
    "city": "Salles"
  },
  {
    "id": 1556,
    "zipcode": 6460,
    "city": "Villers-la-Tour"
  },
  {
    "id": 1557,
    "zipcode": 6460,
    "city": "Chimay"
  },
  {
    "id": 1558,
    "zipcode": 6461,
    "city": "Virelles"
  },
  {
    "id": 1559,
    "zipcode": 6462,
    "city": "Vaulx-lez-Chimay"
  },
  {
    "id": 1560,
    "zipcode": 6463,
    "city": "Lompret"
  },
  {
    "id": 1561,
    "zipcode": 6464,
    "city": "Baileux"
  },
  {
    "id": 1562,
    "zipcode": 6464,
    "city": "Bourlers"
  },
  {
    "id": 1563,
    "zipcode": 6464,
    "city": "Forges"
  },
  {
    "id": 1564,
    "zipcode": 6464,
    "city": "l'Escaillère"
  },
  {
    "id": 1565,
    "zipcode": 6464,
    "city": "Rièzes"
  },
  {
    "id": 1566,
    "zipcode": 6470,
    "city": "Grandrieu"
  },
  {
    "id": 1567,
    "zipcode": 6470,
    "city": "Montbliart"
  },
  {
    "id": 1568,
    "zipcode": 6470,
    "city": "Rance"
  },
  {
    "id": 1569,
    "zipcode": 6470,
    "city": "Sautin"
  },
  {
    "id": 1570,
    "zipcode": 6470,
    "city": "Sivry"
  },
  {
    "id": 1571,
    "zipcode": 6500,
    "city": "Barbençon"
  },
  {
    "id": 1572,
    "zipcode": 6500,
    "city": "Leugnies"
  },
  {
    "id": 1573,
    "zipcode": 6500,
    "city": "Leval-Chaudeville"
  },
  {
    "id": 1574,
    "zipcode": 6500,
    "city": "Renlies"
  },
  {
    "id": 1575,
    "zipcode": 6500,
    "city": "Solre-Saint-Géry"
  },
  {
    "id": 1576,
    "zipcode": 6500,
    "city": "Thirimont"
  },
  {
    "id": 1577,
    "zipcode": 6500,
    "city": "Beaumont"
  },
  {
    "id": 1578,
    "zipcode": 6511,
    "city": "Strée"
  },
  {
    "id": 1579,
    "zipcode": 6530,
    "city": "Leers-et-Fosteau"
  },
  {
    "id": 1580,
    "zipcode": 6530,
    "city": "Thuin"
  },
  {
    "id": 1581,
    "zipcode": 6531,
    "city": "Biesme-sous-Thuin"
  },
  {
    "id": 1582,
    "zipcode": 6532,
    "city": "Ragnies"
  },
  {
    "id": 1583,
    "zipcode": 6533,
    "city": "Biercée"
  },
  {
    "id": 1584,
    "zipcode": 6534,
    "city": "Gozée"
  },
  {
    "id": 1585,
    "zipcode": 6536,
    "city": "Donstiennes"
  },
  {
    "id": 1586,
    "zipcode": 6536,
    "city": "Thuillies"
  },
  {
    "id": 1587,
    "zipcode": 6540,
    "city": "Mont-Sainte-Geneviève"
  },
  {
    "id": 1588,
    "zipcode": 6540,
    "city": "Lobbes"
  },
  {
    "id": 1589,
    "zipcode": 6542,
    "city": "Sars-la-Buissière"
  },
  {
    "id": 1590,
    "zipcode": 6543,
    "city": "Bienne-lez-Happart"
  },
  {
    "id": 1591,
    "zipcode": 6560,
    "city": "Bersillies-l'Abbaye"
  },
  {
    "id": 1592,
    "zipcode": 6560,
    "city": "Grand-Reng"
  },
  {
    "id": 1593,
    "zipcode": 6560,
    "city": "Hantes-Wihéries"
  },
  {
    "id": 1594,
    "zipcode": 6560,
    "city": "Montignies-Saint-Christophe"
  },
  {
    "id": 1595,
    "zipcode": 6560,
    "city": "Solre-sur-Sambre"
  },
  {
    "id": 1596,
    "zipcode": 6560,
    "city": "Erquelinnes"
  },
  {
    "id": 1597,
    "zipcode": 6567,
    "city": "Fontaine-Valmont"
  },
  {
    "id": 1598,
    "zipcode": 6567,
    "city": "Labuissière"
  },
  {
    "id": 1599,
    "zipcode": 6567,
    "city": "Merbes-Sainte-Marie"
  },
  {
    "id": 1600,
    "zipcode": 6567,
    "city": "Merbes-le-Château"
  },
  {
    "id": 1601,
    "zipcode": 6590,
    "city": "Momignies"
  },
  {
    "id": 1602,
    "zipcode": 6591,
    "city": "Macon"
  },
  {
    "id": 1603,
    "zipcode": 6592,
    "city": "Monceau-Imbrechies"
  },
  {
    "id": 1604,
    "zipcode": 6593,
    "city": "Macquenoise"
  },
  {
    "id": 1605,
    "zipcode": 6594,
    "city": "Beauwelz"
  },
  {
    "id": 1606,
    "zipcode": 6596,
    "city": "Forge-Philippe"
  },
  {
    "id": 1607,
    "zipcode": 6596,
    "city": "Seloignes"
  },
  {
    "id": 1608,
    "zipcode": 6600,
    "city": "Longvilly"
  },
  {
    "id": 1609,
    "zipcode": 6600,
    "city": "Noville"
  },
  {
    "id": 1610,
    "zipcode": 6600,
    "city": "Villers-la-Bonne-Eau"
  },
  {
    "id": 1611,
    "zipcode": 6600,
    "city": "Wardin"
  },
  {
    "id": 1612,
    "zipcode": 6600,
    "city": "Bastogne"
  },
  {
    "id": 1613,
    "zipcode": 6630,
    "city": "Martelange"
  },
  {
    "id": 1614,
    "zipcode": 6637,
    "city": "Hollange"
  },
  {
    "id": 1615,
    "zipcode": 6637,
    "city": "Tintange"
  },
  {
    "id": 1616,
    "zipcode": 6637,
    "city": "Fauvillers"
  },
  {
    "id": 1617,
    "zipcode": 6640,
    "city": "Hompré"
  },
  {
    "id": 1618,
    "zipcode": 6640,
    "city": "Morhet"
  },
  {
    "id": 1619,
    "zipcode": 6640,
    "city": "Nives"
  },
  {
    "id": 1620,
    "zipcode": 6640,
    "city": "Sibret"
  },
  {
    "id": 1621,
    "zipcode": 6640,
    "city": "Vaux-lez-Rosières"
  },
  {
    "id": 1622,
    "zipcode": 6640,
    "city": "Vaux-sur-Sûre"
  },
  {
    "id": 1623,
    "zipcode": 6642,
    "city": "Juseret"
  },
  {
    "id": 1624,
    "zipcode": 6660,
    "city": "Nadrin"
  },
  {
    "id": 1625,
    "zipcode": 6660,
    "city": "Houffalize"
  },
  {
    "id": 1626,
    "zipcode": 6661,
    "city": "Mont"
  },
  {
    "id": 1627,
    "zipcode": 6661,
    "city": "Tailles"
  },
  {
    "id": 1628,
    "zipcode": 6662,
    "city": "Tavigny"
  },
  {
    "id": 1629,
    "zipcode": 6663,
    "city": "Mabompré"
  },
  {
    "id": 1630,
    "zipcode": 6666,
    "city": "Wibrin"
  },
  {
    "id": 1631,
    "zipcode": 6670,
    "city": "Limerlé"
  },
  {
    "id": 1632,
    "zipcode": 6670,
    "city": "Gouvy"
  },
  {
    "id": 1633,
    "zipcode": 6671,
    "city": "Bovigny"
  },
  {
    "id": 1634,
    "zipcode": 6672,
    "city": "Beho"
  },
  {
    "id": 1635,
    "zipcode": 6673,
    "city": "Cherain"
  },
  {
    "id": 1636,
    "zipcode": 6674,
    "city": "Montleban"
  },
  {
    "id": 1637,
    "zipcode": 6680,
    "city": "Amberloup"
  },
  {
    "id": 1638,
    "zipcode": 6680,
    "city": "Tillet"
  },
  {
    "id": 1639,
    "zipcode": 6681,
    "city": "Lavacherie"
  },
  {
    "id": 1640,
    "zipcode": 6686,
    "city": "Flamierge"
  },
  {
    "id": 1641,
    "zipcode": 6687,
    "city": "Bertogne"
  },
  {
    "id": 1642,
    "zipcode": 6688,
    "city": "Longchamps"
  },
  {
    "id": 1643,
    "zipcode": 6690,
    "city": "Bihain"
  },
  {
    "id": 1644,
    "zipcode": 6690,
    "city": "Vielsalm"
  },
  {
    "id": 1645,
    "zipcode": 6692,
    "city": "Petit-Thier"
  },
  {
    "id": 1646,
    "zipcode": 6698,
    "city": "Grand-Halleux"
  },
  {
    "id": 1647,
    "zipcode": 6700,
    "city": "Bonnert"
  },
  {
    "id": 1648,
    "zipcode": 6700,
    "city": "Heinsch"
  },
  {
    "id": 1649,
    "zipcode": 6700,
    "city": "Toernich"
  },
  {
    "id": 1650,
    "zipcode": 6700,
    "city": "Arlon"
  },
  {
    "id": 1651,
    "zipcode": 6704,
    "city": "Guirsch"
  },
  {
    "id": 1652,
    "zipcode": 6706,
    "city": "Autelbas"
  },
  {
    "id": 1653,
    "zipcode": 6717,
    "city": "Nobressart"
  },
  {
    "id": 1654,
    "zipcode": 6717,
    "city": "Nothomb"
  },
  {
    "id": 1655,
    "zipcode": 6717,
    "city": "Thiaumont"
  },
  {
    "id": 1656,
    "zipcode": 6717,
    "city": "Tontelange"
  },
  {
    "id": 1657,
    "zipcode": 6717,
    "city": "Attert"
  },
  {
    "id": 1658,
    "zipcode": 6720,
    "city": "Habay-la-Neuve"
  },
  {
    "id": 1659,
    "zipcode": 6720,
    "city": "Hachy"
  },
  {
    "id": 1660,
    "zipcode": 6721,
    "city": "Anlier"
  },
  {
    "id": 1661,
    "zipcode": 6723,
    "city": "Habay-la-Vieille"
  },
  {
    "id": 1662,
    "zipcode": 6724,
    "city": "Houdemont"
  },
  {
    "id": 1663,
    "zipcode": 6724,
    "city": "Rulles"
  },
  {
    "id": 1664,
    "zipcode": 6730,
    "city": "Bellefontaine"
  },
  {
    "id": 1665,
    "zipcode": 6730,
    "city": "Rossignol"
  },
  {
    "id": 1666,
    "zipcode": 6730,
    "city": "Saint-Vincent"
  },
  {
    "id": 1667,
    "zipcode": 6730,
    "city": "Tintigny"
  },
  {
    "id": 1668,
    "zipcode": 6740,
    "city": "Sainte-Marie-sur-Semois"
  },
  {
    "id": 1669,
    "zipcode": 6740,
    "city": "Villers-sur-Semois"
  },
  {
    "id": 1670,
    "zipcode": 6740,
    "city": "Etalle"
  },
  {
    "id": 1671,
    "zipcode": 6741,
    "city": "Vance"
  },
  {
    "id": 1672,
    "zipcode": 6742,
    "city": "Chantemelle"
  },
  {
    "id": 1673,
    "zipcode": 6743,
    "city": "Buzenol"
  },
  {
    "id": 1674,
    "zipcode": 6747,
    "city": "Châtillon"
  },
  {
    "id": 1675,
    "zipcode": 6747,
    "city": "Meix-le-Tige"
  },
  {
    "id": 1676,
    "zipcode": 6747,
    "city": "Saint-Léger"
  },
  {
    "id": 1677,
    "zipcode": 6750,
    "city": "Mussy-la-Ville"
  },
  {
    "id": 1678,
    "zipcode": 6750,
    "city": "Signeulx"
  },
  {
    "id": 1679,
    "zipcode": 6750,
    "city": "Musson"
  },
  {
    "id": 1680,
    "zipcode": 6760,
    "city": "Bleid"
  },
  {
    "id": 1681,
    "zipcode": 6760,
    "city": "Ethe"
  },
  {
    "id": 1682,
    "zipcode": 6760,
    "city": "Ruette"
  },
  {
    "id": 1683,
    "zipcode": 6760,
    "city": "Virton"
  },
  {
    "id": 1684,
    "zipcode": 6761,
    "city": "Latour"
  },
  {
    "id": 1685,
    "zipcode": 6762,
    "city": "Saint-Mard"
  },
  {
    "id": 1686,
    "zipcode": 6767,
    "city": "Dampicourt"
  },
  {
    "id": 1687,
    "zipcode": 6767,
    "city": "Harnoncourt"
  },
  {
    "id": 1688,
    "zipcode": 6767,
    "city": "Lamorteau"
  },
  {
    "id": 1689,
    "zipcode": 6767,
    "city": "Torgny"
  },
  {
    "id": 1690,
    "zipcode": 6769,
    "city": "Gérouville"
  },
  {
    "id": 1691,
    "zipcode": 6769,
    "city": "Robelmont"
  },
  {
    "id": 1692,
    "zipcode": 6769,
    "city": "Sommethonne"
  },
  {
    "id": 1693,
    "zipcode": 6769,
    "city": "Villers-la-Loue"
  },
  {
    "id": 1694,
    "zipcode": 6769,
    "city": "Meix-devant-Virton"
  },
  {
    "id": 1695,
    "zipcode": 6780,
    "city": "Hondelange"
  },
  {
    "id": 1696,
    "zipcode": 6780,
    "city": "Wolkrange"
  },
  {
    "id": 1697,
    "zipcode": 6780,
    "city": "Messancy"
  },
  {
    "id": 1698,
    "zipcode": 6781,
    "city": "Sélange"
  },
  {
    "id": 1699,
    "zipcode": 6782,
    "city": "Habergy"
  },
  {
    "id": 1700,
    "zipcode": 6790,
    "city": "Aubange"
  },
  {
    "id": 1701,
    "zipcode": 6791,
    "city": "Athus"
  },
  {
    "id": 1702,
    "zipcode": 6792,
    "city": "Halanzy"
  },
  {
    "id": 1703,
    "zipcode": 6792,
    "city": "Rachecourt"
  },
  {
    "id": 1704,
    "zipcode": 6800,
    "city": "Bras"
  },
  {
    "id": 1705,
    "zipcode": 6800,
    "city": "Freux"
  },
  {
    "id": 1706,
    "zipcode": 6800,
    "city": "Moircy"
  },
  {
    "id": 1707,
    "zipcode": 6800,
    "city": "Recogne"
  },
  {
    "id": 1708,
    "zipcode": 6800,
    "city": "Remagne"
  },
  {
    "id": 1709,
    "zipcode": 6800,
    "city": "Sainte-Marie-Chevigny"
  },
  {
    "id": 1710,
    "zipcode": 6800,
    "city": "Saint-Pierre"
  },
  {
    "id": 1711,
    "zipcode": 6800,
    "city": "Libramont-Chevigny"
  },
  {
    "id": 1712,
    "zipcode": 6810,
    "city": "Izel"
  },
  {
    "id": 1713,
    "zipcode": 6810,
    "city": "Jamoigne"
  },
  {
    "id": 1714,
    "zipcode": 6810,
    "city": "Chiny"
  },
  {
    "id": 1715,
    "zipcode": 6811,
    "city": "Les Bulles"
  },
  {
    "id": 1716,
    "zipcode": 6812,
    "city": "Suxy"
  },
  {
    "id": 1717,
    "zipcode": 6813,
    "city": "Termes"
  },
  {
    "id": 1718,
    "zipcode": 6820,
    "city": "Fontenoille"
  },
  {
    "id": 1719,
    "zipcode": 6820,
    "city": "Muno"
  },
  {
    "id": 1720,
    "zipcode": 6820,
    "city": "Sainte-Cécile"
  },
  {
    "id": 1721,
    "zipcode": 6820,
    "city": "Florenville"
  },
  {
    "id": 1722,
    "zipcode": 6821,
    "city": "Lacuisine"
  },
  {
    "id": 1723,
    "zipcode": 6823,
    "city": "Villers-devant-Orval"
  },
  {
    "id": 1724,
    "zipcode": 6824,
    "city": "Chassepierre"
  },
  {
    "id": 1725,
    "zipcode": 6830,
    "city": "Les Hayons"
  },
  {
    "id": 1726,
    "zipcode": 6830,
    "city": "Poupehan"
  },
  {
    "id": 1727,
    "zipcode": 6830,
    "city": "Rochehaut"
  },
  {
    "id": 1728,
    "zipcode": 6830,
    "city": "Bouillon"
  },
  {
    "id": 1729,
    "zipcode": 6831,
    "city": "Noirfontaine"
  },
  {
    "id": 1730,
    "zipcode": 6832,
    "city": "Sensenruth"
  },
  {
    "id": 1731,
    "zipcode": 6833,
    "city": "Ucimont"
  },
  {
    "id": 1732,
    "zipcode": 6833,
    "city": "Vivy"
  },
  {
    "id": 1733,
    "zipcode": 6834,
    "city": "Bellevaux"
  },
  {
    "id": 1734,
    "zipcode": 6836,
    "city": "Dohan"
  },
  {
    "id": 1735,
    "zipcode": 6838,
    "city": "Corbion"
  },
  {
    "id": 1736,
    "zipcode": 6840,
    "city": "Grandvoir"
  },
  {
    "id": 1737,
    "zipcode": 6840,
    "city": "Grapfontaine"
  },
  {
    "id": 1738,
    "zipcode": 6840,
    "city": "Hamipré"
  },
  {
    "id": 1739,
    "zipcode": 6840,
    "city": "Longlier"
  },
  {
    "id": 1740,
    "zipcode": 6840,
    "city": "Tournay"
  },
  {
    "id": 1741,
    "zipcode": 6840,
    "city": "Neufchâteau"
  },
  {
    "id": 1742,
    "zipcode": 6850,
    "city": "Carlsbourg"
  },
  {
    "id": 1743,
    "zipcode": 6850,
    "city": "Offagne"
  },
  {
    "id": 1744,
    "zipcode": 6850,
    "city": "Paliseul"
  },
  {
    "id": 1745,
    "zipcode": 6851,
    "city": "Nollevaux"
  },
  {
    "id": 1746,
    "zipcode": 6852,
    "city": "Maissin"
  },
  {
    "id": 1747,
    "zipcode": 6852,
    "city": "Opont"
  },
  {
    "id": 1748,
    "zipcode": 6853,
    "city": "Framont"
  },
  {
    "id": 1749,
    "zipcode": 6856,
    "city": "Fays-les-Veneurs"
  },
  {
    "id": 1750,
    "zipcode": 6860,
    "city": "Assenois"
  },
  {
    "id": 1751,
    "zipcode": 6860,
    "city": "Ebly"
  },
  {
    "id": 1752,
    "zipcode": 6860,
    "city": "Mellier"
  },
  {
    "id": 1753,
    "zipcode": 6860,
    "city": "Witry"
  },
  {
    "id": 1754,
    "zipcode": 6860,
    "city": "Léglise"
  },
  {
    "id": 1755,
    "zipcode": 6870,
    "city": "Arville"
  },
  {
    "id": 1756,
    "zipcode": 6870,
    "city": "Awenne"
  },
  {
    "id": 1757,
    "zipcode": 6870,
    "city": "Hatrival"
  },
  {
    "id": 1758,
    "zipcode": 6870,
    "city": "Mirwart"
  },
  {
    "id": 1759,
    "zipcode": 6870,
    "city": "Vesqueville"
  },
  {
    "id": 1760,
    "zipcode": 6870,
    "city": "Saint-Hubert"
  },
  {
    "id": 1761,
    "zipcode": 6880,
    "city": "Auby-sur-Semois"
  },
  {
    "id": 1762,
    "zipcode": 6880,
    "city": "Cugnon"
  },
  {
    "id": 1763,
    "zipcode": 6880,
    "city": "Jehonville"
  },
  {
    "id": 1764,
    "zipcode": 6880,
    "city": "Orgeo"
  },
  {
    "id": 1765,
    "zipcode": 6880,
    "city": "Bertrix"
  },
  {
    "id": 1766,
    "zipcode": 6887,
    "city": "Saint-Médard"
  },
  {
    "id": 1767,
    "zipcode": 6887,
    "city": "Straimont"
  },
  {
    "id": 1768,
    "zipcode": 6887,
    "city": "Herbeumont"
  },
  {
    "id": 1769,
    "zipcode": 6890,
    "city": "Anloy"
  },
  {
    "id": 1770,
    "zipcode": 6890,
    "city": "Ochamps"
  },
  {
    "id": 1771,
    "zipcode": 6890,
    "city": "Redu"
  },
  {
    "id": 1772,
    "zipcode": 6890,
    "city": "Smuid"
  },
  {
    "id": 1773,
    "zipcode": 6890,
    "city": "Transinne"
  },
  {
    "id": 1774,
    "zipcode": 6890,
    "city": "Villance"
  },
  {
    "id": 1775,
    "zipcode": 6890,
    "city": "Libin"
  },
  {
    "id": 1776,
    "zipcode": 6900,
    "city": "Aye"
  },
  {
    "id": 1777,
    "zipcode": 6900,
    "city": "Hargimont"
  },
  {
    "id": 1778,
    "zipcode": 6900,
    "city": "Humain"
  },
  {
    "id": 1779,
    "zipcode": 6900,
    "city": "On"
  },
  {
    "id": 1780,
    "zipcode": 6900,
    "city": "Roy"
  },
  {
    "id": 1781,
    "zipcode": 6900,
    "city": "Waha"
  },
  {
    "id": 1782,
    "zipcode": 6900,
    "city": "Marche-en-Famenne"
  },
  {
    "id": 1783,
    "zipcode": 6920,
    "city": "Sohier"
  },
  {
    "id": 1784,
    "zipcode": 6920,
    "city": "Wellin"
  },
  {
    "id": 1785,
    "zipcode": 6921,
    "city": "Chanly"
  },
  {
    "id": 1786,
    "zipcode": 6922,
    "city": "Halma"
  },
  {
    "id": 1787,
    "zipcode": 6924,
    "city": "Lomprez"
  },
  {
    "id": 1788,
    "zipcode": 6927,
    "city": "Bure"
  },
  {
    "id": 1789,
    "zipcode": 6927,
    "city": "Grupont"
  },
  {
    "id": 1790,
    "zipcode": 6927,
    "city": "Resteigne"
  },
  {
    "id": 1791,
    "zipcode": 6927,
    "city": "Tellin"
  },
  {
    "id": 1792,
    "zipcode": 6929,
    "city": "Gembes"
  },
  {
    "id": 1793,
    "zipcode": 6929,
    "city": "Haut-Fays"
  },
  {
    "id": 1794,
    "zipcode": 6929,
    "city": "Porcheresse"
  },
  {
    "id": 1795,
    "zipcode": 6929,
    "city": "Daverdisse"
  },
  {
    "id": 1796,
    "zipcode": 6940,
    "city": "Barvaux-sur-Ourthe"
  },
  {
    "id": 1797,
    "zipcode": 6940,
    "city": "Grandhan"
  },
  {
    "id": 1798,
    "zipcode": 6940,
    "city": "Septon"
  },
  {
    "id": 1799,
    "zipcode": 6940,
    "city": "Wéris"
  },
  {
    "id": 1800,
    "zipcode": 6940,
    "city": "Durbuy"
  },
  {
    "id": 1801,
    "zipcode": 6941,
    "city": "Bende"
  },
  {
    "id": 1802,
    "zipcode": 6941,
    "city": "Bomal-sur-Ourthe"
  },
  {
    "id": 1803,
    "zipcode": 6941,
    "city": "Borlon"
  },
  {
    "id": 1804,
    "zipcode": 6941,
    "city": "Heyd"
  },
  {
    "id": 1805,
    "zipcode": 6941,
    "city": "Izier"
  },
  {
    "id": 1806,
    "zipcode": 6941,
    "city": "Tohogne"
  },
  {
    "id": 1807,
    "zipcode": 6941,
    "city": "Villers-Sainte-Gertrude"
  },
  {
    "id": 1808,
    "zipcode": 6950,
    "city": "Harsin"
  },
  {
    "id": 1809,
    "zipcode": 6950,
    "city": "Nassogne"
  },
  {
    "id": 1810,
    "zipcode": 6951,
    "city": "Bande"
  },
  {
    "id": 1811,
    "zipcode": 6952,
    "city": "Grune"
  },
  {
    "id": 1812,
    "zipcode": 6953,
    "city": "Ambly"
  },
  {
    "id": 1813,
    "zipcode": 6953,
    "city": "Forrières"
  },
  {
    "id": 1814,
    "zipcode": 6953,
    "city": "Lesterny"
  },
  {
    "id": 1815,
    "zipcode": 6953,
    "city": "Masbourg"
  },
  {
    "id": 1816,
    "zipcode": 6960,
    "city": "Dochamps"
  },
  {
    "id": 1817,
    "zipcode": 6960,
    "city": "Grandménil"
  },
  {
    "id": 1818,
    "zipcode": 6960,
    "city": "Harre"
  },
  {
    "id": 1819,
    "zipcode": 6960,
    "city": "Malempré"
  },
  {
    "id": 1820,
    "zipcode": 6960,
    "city": "Odeigne"
  },
  {
    "id": 1821,
    "zipcode": 6960,
    "city": "Vaux-Chavanne"
  },
  {
    "id": 1822,
    "zipcode": 6970,
    "city": "Tenneville"
  },
  {
    "id": 1823,
    "zipcode": 6971,
    "city": "Champlon"
  },
  {
    "id": 1824,
    "zipcode": 6972,
    "city": "Erneuville"
  },
  {
    "id": 1825,
    "zipcode": 6980,
    "city": "Beausaint"
  },
  {
    "id": 1826,
    "zipcode": 6980,
    "city": "La Roche-en-Ardenne"
  },
  {
    "id": 1827,
    "zipcode": 6982,
    "city": "Samrée"
  },
  {
    "id": 1828,
    "zipcode": 6983,
    "city": "Ortho"
  },
  {
    "id": 1829,
    "zipcode": 6984,
    "city": "Hives"
  },
  {
    "id": 1830,
    "zipcode": 6986,
    "city": "Halleux"
  },
  {
    "id": 1831,
    "zipcode": 6987,
    "city": "Beffe"
  },
  {
    "id": 1832,
    "zipcode": 6987,
    "city": "Hodister"
  },
  {
    "id": 1833,
    "zipcode": 6987,
    "city": "Marcourt"
  },
  {
    "id": 1834,
    "zipcode": 6987,
    "city": "Rendeux"
  },
  {
    "id": 1835,
    "zipcode": 6990,
    "city": "Fronville"
  },
  {
    "id": 1836,
    "zipcode": 6990,
    "city": "Hampteau"
  },
  {
    "id": 1837,
    "zipcode": 6990,
    "city": "Marenne"
  },
  {
    "id": 1838,
    "zipcode": 6990,
    "city": "Hotton"
  },
  {
    "id": 1839,
    "zipcode": 6997,
    "city": "Amonines"
  },
  {
    "id": 1840,
    "zipcode": 6997,
    "city": "Mormont"
  },
  {
    "id": 1841,
    "zipcode": 6997,
    "city": "Soy"
  },
  {
    "id": 1842,
    "zipcode": 6997,
    "city": "Erezée"
  },
  {
    "id": 1843,
    "zipcode": 7000,
    "city": "Mons"
  },
  {
    "id": 1844,
    "zipcode": 7011,
    "city": "Ghlin"
  },
  {
    "id": 1845,
    "zipcode": 7012,
    "city": "Flénu"
  },
  {
    "id": 1846,
    "zipcode": 7012,
    "city": "Jemappes"
  },
  {
    "id": 1847,
    "zipcode": 7020,
    "city": "Maisières"
  },
  {
    "id": 1848,
    "zipcode": 7020,
    "city": "Nimy"
  },
  {
    "id": 1849,
    "zipcode": 7021,
    "city": "Havré"
  },
  {
    "id": 1850,
    "zipcode": 7022,
    "city": "Harmignies"
  },
  {
    "id": 1851,
    "zipcode": 7022,
    "city": "Harveng"
  },
  {
    "id": 1852,
    "zipcode": 7022,
    "city": "Hyon"
  },
  {
    "id": 1853,
    "zipcode": 7022,
    "city": "Mesvin"
  },
  {
    "id": 1854,
    "zipcode": 7022,
    "city": "Nouvelles"
  },
  {
    "id": 1855,
    "zipcode": 7024,
    "city": "Ciply"
  },
  {
    "id": 1856,
    "zipcode": 7030,
    "city": "Saint-Symphorien"
  },
  {
    "id": 1857,
    "zipcode": 7031,
    "city": "Villers-Saint-Ghislain"
  },
  {
    "id": 1858,
    "zipcode": 7032,
    "city": "Spiennes"
  },
  {
    "id": 1859,
    "zipcode": 7033,
    "city": "Cuesmes"
  },
  {
    "id": 1860,
    "zipcode": 7034,
    "city": "Obourg"
  },
  {
    "id": 1861,
    "zipcode": 7034,
    "city": "Saint-Denis"
  },
  {
    "id": 1862,
    "zipcode": 7040,
    "city": "Asquillies"
  },
  {
    "id": 1863,
    "zipcode": 7040,
    "city": "Aulnois"
  },
  {
    "id": 1864,
    "zipcode": 7040,
    "city": "Blaregnies"
  },
  {
    "id": 1865,
    "zipcode": 7040,
    "city": "Bougnies"
  },
  {
    "id": 1866,
    "zipcode": 7040,
    "city": "Genly"
  },
  {
    "id": 1867,
    "zipcode": 7040,
    "city": "Goegnies-Chaussée"
  },
  {
    "id": 1868,
    "zipcode": 7040,
    "city": "Quévy-le-Grand"
  },
  {
    "id": 1869,
    "zipcode": 7040,
    "city": "Quévy-le-Petit"
  },
  {
    "id": 1870,
    "zipcode": 7041,
    "city": "Givry"
  },
  {
    "id": 1871,
    "zipcode": 7041,
    "city": "Havay"
  },
  {
    "id": 1872,
    "zipcode": 7050,
    "city": "Erbaut"
  },
  {
    "id": 1873,
    "zipcode": 7050,
    "city": "Erbisoeul"
  },
  {
    "id": 1874,
    "zipcode": 7050,
    "city": "Herchies"
  },
  {
    "id": 1875,
    "zipcode": 7050,
    "city": "Masnuy-Saint-Jean"
  },
  {
    "id": 1876,
    "zipcode": 7050,
    "city": "Masnuy-Saint-Pierre"
  },
  {
    "id": 1877,
    "zipcode": 7050,
    "city": "Jurbise"
  },
  {
    "id": 1878,
    "zipcode": 7060,
    "city": "Horrues"
  },
  {
    "id": 1879,
    "zipcode": 7060,
    "city": "Soignies"
  },
  {
    "id": 1880,
    "zipcode": 7061,
    "city": "Casteau"
  },
  {
    "id": 1881,
    "zipcode": 7061,
    "city": "Thieusies"
  },
  {
    "id": 1882,
    "zipcode": 7062,
    "city": "Naast"
  },
  {
    "id": 1883,
    "zipcode": 7063,
    "city": "Chaussée-Notre-Dame-Louvignies"
  },
  {
    "id": 1884,
    "zipcode": 7063,
    "city": "Neufvilles"
  },
  {
    "id": 1885,
    "zipcode": 7070,
    "city": "Gottignies"
  },
  {
    "id": 1886,
    "zipcode": 7070,
    "city": "Mignault"
  },
  {
    "id": 1887,
    "zipcode": 7070,
    "city": "Thieu"
  },
  {
    "id": 1888,
    "zipcode": 7070,
    "city": "Ville-sur-Haine"
  },
  {
    "id": 1889,
    "zipcode": 7070,
    "city": "Le Roeulx"
  },
  {
    "id": 1890,
    "zipcode": 7080,
    "city": "Eugies"
  },
  {
    "id": 1891,
    "zipcode": 7080,
    "city": "La Bouverie"
  },
  {
    "id": 1892,
    "zipcode": 7080,
    "city": "Noirchain"
  },
  {
    "id": 1893,
    "zipcode": 7080,
    "city": "Sars-la-Bruyère"
  },
  {
    "id": 1894,
    "zipcode": 7080,
    "city": "Frameries"
  },
  {
    "id": 1895,
    "zipcode": 7090,
    "city": "Hennuyères"
  },
  {
    "id": 1896,
    "zipcode": 7090,
    "city": "Henripont"
  },
  {
    "id": 1897,
    "zipcode": 7090,
    "city": "Petit-Rulx-lez-Braine"
  },
  {
    "id": 1898,
    "zipcode": 7090,
    "city": "Ronquières"
  },
  {
    "id": 1899,
    "zipcode": 7090,
    "city": "Steenkerque"
  },
  {
    "id": 1900,
    "zipcode": 7090,
    "city": "Braine-le-Comte"
  },
  {
    "id": 1901,
    "zipcode": 7100,
    "city": "Haine-Saint-Paul"
  },
  {
    "id": 1902,
    "zipcode": 7100,
    "city": "Haine-Saint-Pierre"
  },
  {
    "id": 1903,
    "zipcode": 7100,
    "city": "Saint-Vaast"
  },
  {
    "id": 1904,
    "zipcode": 7100,
    "city": "Trivières"
  },
  {
    "id": 1905,
    "zipcode": 7100,
    "city": "La Louvière"
  },
  {
    "id": 1906,
    "zipcode": 7110,
    "city": "Boussoit"
  },
  {
    "id": 1907,
    "zipcode": 7110,
    "city": "Houdeng-Aimeries"
  },
  {
    "id": 1908,
    "zipcode": 7110,
    "city": "Houdeng-Goegnies"
  },
  {
    "id": 1909,
    "zipcode": 7110,
    "city": "Maurage"
  },
  {
    "id": 1910,
    "zipcode": 7110,
    "city": "Strépy-Bracquegnies"
  },
  {
    "id": 1911,
    "zipcode": 7120,
    "city": "Croix-lez-Rouveroy"
  },
  {
    "id": 1912,
    "zipcode": 7120,
    "city": "Estinnes-au-Mont"
  },
  {
    "id": 1913,
    "zipcode": 7120,
    "city": "Estinnes-au-Val"
  },
  {
    "id": 1914,
    "zipcode": 7120,
    "city": "Fauroeulx"
  },
  {
    "id": 1915,
    "zipcode": 7120,
    "city": "Haulchin"
  },
  {
    "id": 1916,
    "zipcode": 7120,
    "city": "Peissant"
  },
  {
    "id": 1917,
    "zipcode": 7120,
    "city": "Rouveroy"
  },
  {
    "id": 1918,
    "zipcode": 7120,
    "city": "Vellereille-les-Brayeux"
  },
  {
    "id": 1919,
    "zipcode": 7120,
    "city": "Vellereille-le-Sec"
  },
  {
    "id": 1920,
    "zipcode": 7130,
    "city": "Battignies"
  },
  {
    "id": 1921,
    "zipcode": 7130,
    "city": "Bray"
  },
  {
    "id": 1922,
    "zipcode": 7130,
    "city": "Binche"
  },
  {
    "id": 1923,
    "zipcode": 7131,
    "city": "Waudrez"
  },
  {
    "id": 1924,
    "zipcode": 7133,
    "city": "Buvrinnes"
  },
  {
    "id": 1925,
    "zipcode": 7134,
    "city": "Epinois"
  },
  {
    "id": 1926,
    "zipcode": 7134,
    "city": "Leval-Trahegnies"
  },
  {
    "id": 1927,
    "zipcode": 7134,
    "city": "Péronnes-lez-Binche"
  },
  {
    "id": 1928,
    "zipcode": 7134,
    "city": "Ressaix"
  },
  {
    "id": 1929,
    "zipcode": 7140,
    "city": "Morlanwelz-Mariemont"
  },
  {
    "id": 1930,
    "zipcode": 7141,
    "city": "Carnières"
  },
  {
    "id": 1931,
    "zipcode": 7141,
    "city": "Mont-Sainte-Aldegonde"
  },
  {
    "id": 1932,
    "zipcode": 7160,
    "city": "Godarville"
  },
  {
    "id": 1933,
    "zipcode": 7160,
    "city": "Piéton"
  },
  {
    "id": 1934,
    "zipcode": 7160,
    "city": "Chapelle-lez-Herlaimont"
  },
  {
    "id": 1935,
    "zipcode": 7170,
    "city": "Bellecourt"
  },
  {
    "id": 1936,
    "zipcode": 7170,
    "city": "Bois-d'Haine"
  },
  {
    "id": 1937,
    "zipcode": 7170,
    "city": "Fayt-lez-Manage"
  },
  {
    "id": 1938,
    "zipcode": 7170,
    "city": "La Hestre"
  },
  {
    "id": 1939,
    "zipcode": 7170,
    "city": "Manage"
  },
  {
    "id": 1940,
    "zipcode": 7180,
    "city": "Seneffe"
  },
  {
    "id": 1941,
    "zipcode": 7181,
    "city": "Arquennes"
  },
  {
    "id": 1942,
    "zipcode": 7181,
    "city": "Familleureux"
  },
  {
    "id": 1943,
    "zipcode": 7181,
    "city": "Feluy"
  },
  {
    "id": 1944,
    "zipcode": 7181,
    "city": "Petit-Rulx-lez-Nivelles"
  },
  {
    "id": 1945,
    "zipcode": 7190,
    "city": "Écaussinnes-d'Enghien"
  },
  {
    "id": 1946,
    "zipcode": 7190,
    "city": "Marche-lez-Écaussinnes"
  },
  {
    "id": 1947,
    "zipcode": 7191,
    "city": "Ecaussinnes-Lalaing"
  },
  {
    "id": 1948,
    "zipcode": 7300,
    "city": "Boussu"
  },
  {
    "id": 1949,
    "zipcode": 7301,
    "city": "Hornu"
  },
  {
    "id": 1950,
    "zipcode": 7320,
    "city": "Bernissart"
  },
  {
    "id": 1951,
    "zipcode": 7321,
    "city": "Blaton"
  },
  {
    "id": 1952,
    "zipcode": 7321,
    "city": "Harchies"
  },
  {
    "id": 1953,
    "zipcode": 7322,
    "city": "Pommeroeul"
  },
  {
    "id": 1954,
    "zipcode": 7322,
    "city": "Ville-Pommeroeul"
  },
  {
    "id": 1955,
    "zipcode": 7330,
    "city": "Saint-Ghislain"
  },
  {
    "id": 1956,
    "zipcode": 7331,
    "city": "Baudour"
  },
  {
    "id": 1957,
    "zipcode": 7332,
    "city": "Neufmaison"
  },
  {
    "id": 1958,
    "zipcode": 7332,
    "city": "Sirault"
  },
  {
    "id": 1959,
    "zipcode": 7333,
    "city": "Tertre"
  },
  {
    "id": 1960,
    "zipcode": 7334,
    "city": "Hautrage"
  },
  {
    "id": 1961,
    "zipcode": 7334,
    "city": "Villerot"
  },
  {
    "id": 1962,
    "zipcode": 7340,
    "city": "Pâturages"
  },
  {
    "id": 1963,
    "zipcode": 7340,
    "city": "Warquignies"
  },
  {
    "id": 1964,
    "zipcode": 7340,
    "city": "Wasmes"
  },
  {
    "id": 1965,
    "zipcode": 7340,
    "city": "Colfontaine"
  },
  {
    "id": 1966,
    "zipcode": 7350,
    "city": "Hainin"
  },
  {
    "id": 1967,
    "zipcode": 7350,
    "city": "Montrul-sur-Haine"
  },
  {
    "id": 1968,
    "zipcode": 7350,
    "city": "Thulin"
  },
  {
    "id": 1969,
    "zipcode": 7350,
    "city": "Hensies"
  },
  {
    "id": 1970,
    "zipcode": 7370,
    "city": "Blaugies"
  },
  {
    "id": 1971,
    "zipcode": 7370,
    "city": "Elouges"
  },
  {
    "id": 1972,
    "zipcode": 7370,
    "city": "Wihéries"
  },
  {
    "id": 1973,
    "zipcode": 7370,
    "city": "Dour"
  },
  {
    "id": 1974,
    "zipcode": 7380,
    "city": "Baisieux"
  },
  {
    "id": 1975,
    "zipcode": 7380,
    "city": "Quiévrain"
  },
  {
    "id": 1976,
    "zipcode": 7382,
    "city": "Audregnies"
  },
  {
    "id": 1977,
    "zipcode": 7387,
    "city": "Angre"
  },
  {
    "id": 1978,
    "zipcode": 7387,
    "city": "Angreau"
  },
  {
    "id": 1979,
    "zipcode": 7387,
    "city": "Athis"
  },
  {
    "id": 1980,
    "zipcode": 7387,
    "city": "Autreppe"
  },
  {
    "id": 1981,
    "zipcode": 7387,
    "city": "Erquennes"
  },
  {
    "id": 1982,
    "zipcode": 7387,
    "city": "Fayt-le-Franc"
  },
  {
    "id": 1983,
    "zipcode": 7387,
    "city": "Marchipont"
  },
  {
    "id": 1984,
    "zipcode": 7387,
    "city": "Montignies-sur-Roc"
  },
  {
    "id": 1985,
    "zipcode": 7387,
    "city": "Onnezies"
  },
  {
    "id": 1986,
    "zipcode": 7387,
    "city": "Roisin"
  },
  {
    "id": 1987,
    "zipcode": 7390,
    "city": "Wasmuel"
  },
  {
    "id": 1988,
    "zipcode": 7390,
    "city": "Quaregnon"
  },
  {
    "id": 1989,
    "zipcode": 7500,
    "city": "Ere"
  },
  {
    "id": 1990,
    "zipcode": 7500,
    "city": "Saint-Maur"
  },
  {
    "id": 1991,
    "zipcode": 7500,
    "city": "Tournai"
  },
  {
    "id": 1992,
    "zipcode": 7501,
    "city": "Orcq"
  },
  {
    "id": 1993,
    "zipcode": 7502,
    "city": "Esplechin"
  },
  {
    "id": 1994,
    "zipcode": 7503,
    "city": "Froyennes"
  },
  {
    "id": 1995,
    "zipcode": 7504,
    "city": "Froidmont"
  },
  {
    "id": 1996,
    "zipcode": 7506,
    "city": "Willemeau"
  },
  {
    "id": 1997,
    "zipcode": 7520,
    "city": "Ramegnies-Chin"
  },
  {
    "id": 1998,
    "zipcode": 7520,
    "city": "Templeuve"
  },
  {
    "id": 1999,
    "zipcode": 7521,
    "city": "Chercq"
  },
  {
    "id": 2000,
    "zipcode": 7522,
    "city": "Blandain"
  },
  {
    "id": 2001,
    "zipcode": 7522,
    "city": "Hertain"
  },
  {
    "id": 2002,
    "zipcode": 7522,
    "city": "Lamain"
  },
  {
    "id": 2003,
    "zipcode": 7522,
    "city": "Marquain"
  },
  {
    "id": 2004,
    "zipcode": 7530,
    "city": "Gaurain-Ramecroix"
  },
  {
    "id": 2005,
    "zipcode": 7531,
    "city": "Havinnes"
  },
  {
    "id": 2006,
    "zipcode": 7532,
    "city": "Béclers"
  },
  {
    "id": 2007,
    "zipcode": 7533,
    "city": "Thimougies"
  },
  {
    "id": 2008,
    "zipcode": 7534,
    "city": "Barry"
  },
  {
    "id": 2009,
    "zipcode": 7534,
    "city": "Maulde"
  },
  {
    "id": 2010,
    "zipcode": 7536,
    "city": "Vaulx"
  },
  {
    "id": 2011,
    "zipcode": 7538,
    "city": "Vezon"
  },
  {
    "id": 2012,
    "zipcode": 7540,
    "city": "Kain"
  },
  {
    "id": 2013,
    "zipcode": 7540,
    "city": "Melles"
  },
  {
    "id": 2014,
    "zipcode": 7540,
    "city": "Quartes"
  },
  {
    "id": 2015,
    "zipcode": 7540,
    "city": "Rumillies"
  },
  {
    "id": 2016,
    "zipcode": 7542,
    "city": "Mont-Saint-Aubert"
  },
  {
    "id": 2017,
    "zipcode": 7543,
    "city": "Mourcourt"
  },
  {
    "id": 2018,
    "zipcode": 7548,
    "city": "Warchin"
  },
  {
    "id": 2019,
    "zipcode": 7600,
    "city": "Péruwelz"
  },
  {
    "id": 2020,
    "zipcode": 7601,
    "city": "Roucourt"
  },
  {
    "id": 2021,
    "zipcode": 7602,
    "city": "Bury"
  },
  {
    "id": 2022,
    "zipcode": 7603,
    "city": "Bon-Secours"
  },
  {
    "id": 2023,
    "zipcode": 7604,
    "city": "Baugnies"
  },
  {
    "id": 2024,
    "zipcode": 7604,
    "city": "Braffe"
  },
  {
    "id": 2025,
    "zipcode": 7604,
    "city": "Brasménil"
  },
  {
    "id": 2026,
    "zipcode": 7604,
    "city": "Callenelle"
  },
  {
    "id": 2027,
    "zipcode": 7604,
    "city": "Wasmes-Audemez-Briffoeil"
  },
  {
    "id": 2028,
    "zipcode": 7608,
    "city": "Wiers"
  },
  {
    "id": 2029,
    "zipcode": 7610,
    "city": "Rumes"
  },
  {
    "id": 2030,
    "zipcode": 7611,
    "city": "La Glanerie"
  },
  {
    "id": 2031,
    "zipcode": 7618,
    "city": "Taintignies"
  },
  {
    "id": 2032,
    "zipcode": 7620,
    "city": "Bléharies"
  },
  {
    "id": 2033,
    "zipcode": 7620,
    "city": "Guignies"
  },
  {
    "id": 2034,
    "zipcode": 7620,
    "city": "Hollain"
  },
  {
    "id": 2035,
    "zipcode": 7620,
    "city": "Jollain-Merlin"
  },
  {
    "id": 2036,
    "zipcode": 7620,
    "city": "Wez-Velvain"
  },
  {
    "id": 2037,
    "zipcode": 7621,
    "city": "Lesdain"
  },
  {
    "id": 2038,
    "zipcode": 7622,
    "city": "Laplaigne"
  },
  {
    "id": 2039,
    "zipcode": 7623,
    "city": "Rongy"
  },
  {
    "id": 2040,
    "zipcode": 7624,
    "city": "Howardries"
  },
  {
    "id": 2041,
    "zipcode": 7640,
    "city": "Maubray"
  },
  {
    "id": 2042,
    "zipcode": 7640,
    "city": "Péronnes-lez-Antoing"
  },
  {
    "id": 2043,
    "zipcode": 7640,
    "city": "Antoing"
  },
  {
    "id": 2044,
    "zipcode": 7641,
    "city": "Bruyelle"
  },
  {
    "id": 2045,
    "zipcode": 7642,
    "city": "Calonne"
  },
  {
    "id": 2046,
    "zipcode": 7643,
    "city": "Fontenoy"
  },
  {
    "id": 2047,
    "zipcode": 7700,
    "city": "Luingne"
  },
  {
    "id": 2048,
    "zipcode": 7700,
    "city": "Moeskroen"
  },
  {
    "id": 2049,
    "zipcode": 7711,
    "city": "Dottenijs"
  },
  {
    "id": 2050,
    "zipcode": 7712,
    "city": "Herseaux"
  },
  {
    "id": 2051,
    "zipcode": 7730,
    "city": "Bailleul"
  },
  {
    "id": 2052,
    "zipcode": 7730,
    "city": "Estaimbourg"
  },
  {
    "id": 2053,
    "zipcode": 7730,
    "city": "Evregnies"
  },
  {
    "id": 2054,
    "zipcode": 7730,
    "city": "Leers-Nord"
  },
  {
    "id": 2055,
    "zipcode": 7730,
    "city": "Néchin"
  },
  {
    "id": 2056,
    "zipcode": 7730,
    "city": "Saint-Léger"
  },
  {
    "id": 2057,
    "zipcode": 7730,
    "city": "Estaimpuis"
  },
  {
    "id": 2058,
    "zipcode": 7740,
    "city": "Warcoing"
  },
  {
    "id": 2059,
    "zipcode": 7740,
    "city": "Pecq"
  },
  {
    "id": 2060,
    "zipcode": 7742,
    "city": "Hérinnes-lez-Pecq"
  },
  {
    "id": 2061,
    "zipcode": 7743,
    "city": "Esquelmes"
  },
  {
    "id": 2062,
    "zipcode": 7743,
    "city": "Obigies"
  },
  {
    "id": 2063,
    "zipcode": 7750,
    "city": "Amougies"
  },
  {
    "id": 2064,
    "zipcode": 7750,
    "city": "Anseroeul"
  },
  {
    "id": 2065,
    "zipcode": 7750,
    "city": "Orroir"
  },
  {
    "id": 2066,
    "zipcode": 7750,
    "city": "Russeignies"
  },
  {
    "id": 2067,
    "zipcode": 7760,
    "city": "Escanaffles"
  },
  {
    "id": 2068,
    "zipcode": 7760,
    "city": "Molenbaix"
  },
  {
    "id": 2069,
    "zipcode": 7760,
    "city": "Popuelles"
  },
  {
    "id": 2070,
    "zipcode": 7760,
    "city": "Pottes"
  },
  {
    "id": 2071,
    "zipcode": 7760,
    "city": "Velaines"
  },
  {
    "id": 2072,
    "zipcode": 7760,
    "city": "Celles"
  },
  {
    "id": 2073,
    "zipcode": 7780,
    "city": "Komen"
  },
  {
    "id": 2074,
    "zipcode": 7780,
    "city": "Komen-Waasten"
  },
  {
    "id": 2075,
    "zipcode": 7781,
    "city": "Houthem"
  },
  {
    "id": 2076,
    "zipcode": 7782,
    "city": "Ploegsteert"
  },
  {
    "id": 2077,
    "zipcode": 7783,
    "city": "Bizet"
  },
  {
    "id": 2078,
    "zipcode": 7784,
    "city": "Neerwaasten"
  },
  {
    "id": 2079,
    "zipcode": 7784,
    "city": "Waasten"
  },
  {
    "id": 2080,
    "zipcode": 7800,
    "city": "Lanquesaint"
  },
  {
    "id": 2081,
    "zipcode": 7800,
    "city": "Ath"
  },
  {
    "id": 2082,
    "zipcode": 7801,
    "city": "Irchonwelz"
  },
  {
    "id": 2083,
    "zipcode": 7802,
    "city": "Ormeignies"
  },
  {
    "id": 2084,
    "zipcode": 7803,
    "city": "Bouvignies"
  },
  {
    "id": 2085,
    "zipcode": 7804,
    "city": "Ostiches"
  },
  {
    "id": 2086,
    "zipcode": 7804,
    "city": "Rebaix"
  },
  {
    "id": 2087,
    "zipcode": 7810,
    "city": "Maffle"
  },
  {
    "id": 2088,
    "zipcode": 7811,
    "city": "Arbre"
  },
  {
    "id": 2089,
    "zipcode": 7812,
    "city": "Houtaing"
  },
  {
    "id": 2090,
    "zipcode": 7812,
    "city": "Ligne"
  },
  {
    "id": 2091,
    "zipcode": 7812,
    "city": "Mainvault"
  },
  {
    "id": 2092,
    "zipcode": 7812,
    "city": "Moulbaix"
  },
  {
    "id": 2093,
    "zipcode": 7812,
    "city": "Villers-Notre-Dame"
  },
  {
    "id": 2094,
    "zipcode": 7812,
    "city": "Villers-Saint-Amand"
  },
  {
    "id": 2095,
    "zipcode": 7822,
    "city": "Ghislenghien"
  },
  {
    "id": 2096,
    "zipcode": 7822,
    "city": "Isières"
  },
  {
    "id": 2097,
    "zipcode": 7822,
    "city": "Meslin-l'Évêque"
  },
  {
    "id": 2098,
    "zipcode": 7823,
    "city": "Gibecq"
  },
  {
    "id": 2099,
    "zipcode": 7830,
    "city": "Bassilly"
  },
  {
    "id": 2100,
    "zipcode": 7830,
    "city": "Fouleng"
  },
  {
    "id": 2101,
    "zipcode": 7830,
    "city": "Gondregnies"
  },
  {
    "id": 2102,
    "zipcode": 7830,
    "city": "Graty"
  },
  {
    "id": 2103,
    "zipcode": 7830,
    "city": "Hellebecq"
  },
  {
    "id": 2104,
    "zipcode": 7830,
    "city": "Hoves"
  },
  {
    "id": 2105,
    "zipcode": 7830,
    "city": "Thoricourt"
  },
  {
    "id": 2106,
    "zipcode": 7830,
    "city": "Silly"
  },
  {
    "id": 2107,
    "zipcode": 7850,
    "city": "Lettelingen"
  },
  {
    "id": 2108,
    "zipcode": 7850,
    "city": "Mark"
  },
  {
    "id": 2109,
    "zipcode": 7850,
    "city": "Edingen"
  },
  {
    "id": 2110,
    "zipcode": 7860,
    "city": "Lessines"
  },
  {
    "id": 2111,
    "zipcode": 7861,
    "city": "Papignies"
  },
  {
    "id": 2112,
    "zipcode": 7861,
    "city": "Wannebecq"
  },
  {
    "id": 2113,
    "zipcode": 7862,
    "city": "Ogy"
  },
  {
    "id": 2114,
    "zipcode": 7863,
    "city": "Ghoy"
  },
  {
    "id": 2115,
    "zipcode": 7864,
    "city": "Deux-Acren"
  },
  {
    "id": 2116,
    "zipcode": 7866,
    "city": "Bois-de-Lessines"
  },
  {
    "id": 2117,
    "zipcode": 7866,
    "city": "Ollignies"
  },
  {
    "id": 2118,
    "zipcode": 7870,
    "city": "Bauffe"
  },
  {
    "id": 2119,
    "zipcode": 7870,
    "city": "Cambron-Saint-Vincent"
  },
  {
    "id": 2120,
    "zipcode": 7870,
    "city": "Lombise"
  },
  {
    "id": 2121,
    "zipcode": 7870,
    "city": "Montignies-lez-Lens"
  },
  {
    "id": 2122,
    "zipcode": 7870,
    "city": "Lens"
  },
  {
    "id": 2123,
    "zipcode": 7880,
    "city": "Vloesberg"
  },
  {
    "id": 2124,
    "zipcode": 7890,
    "city": "Lahamaide"
  },
  {
    "id": 2125,
    "zipcode": 7890,
    "city": "Wodecq"
  },
  {
    "id": 2126,
    "zipcode": 7890,
    "city": "Ellezelles"
  },
  {
    "id": 2127,
    "zipcode": 7900,
    "city": "Grandmetz"
  },
  {
    "id": 2128,
    "zipcode": 7900,
    "city": "Leuze-en-Hainaut"
  },
  {
    "id": 2129,
    "zipcode": 7901,
    "city": "Thieulain"
  },
  {
    "id": 2130,
    "zipcode": 7903,
    "city": "Blicquy"
  },
  {
    "id": 2131,
    "zipcode": 7903,
    "city": "Chapelle-à-Oie"
  },
  {
    "id": 2132,
    "zipcode": 7903,
    "city": "Chapelle-à-Wattines"
  },
  {
    "id": 2133,
    "zipcode": 7904,
    "city": "Pipaix"
  },
  {
    "id": 2134,
    "zipcode": 7904,
    "city": "Tourpes"
  },
  {
    "id": 2135,
    "zipcode": 7904,
    "city": "Willaupuis"
  },
  {
    "id": 2136,
    "zipcode": 7906,
    "city": "Gallaix"
  },
  {
    "id": 2137,
    "zipcode": 7910,
    "city": "Anvaing"
  },
  {
    "id": 2138,
    "zipcode": 7910,
    "city": "Arc-Ainières"
  },
  {
    "id": 2139,
    "zipcode": 7910,
    "city": "Arc-Wattripont"
  },
  {
    "id": 2140,
    "zipcode": 7910,
    "city": "Cordes"
  },
  {
    "id": 2141,
    "zipcode": 7910,
    "city": "Ellignies-lez-Frasnes"
  },
  {
    "id": 2142,
    "zipcode": 7910,
    "city": "Forest"
  },
  {
    "id": 2143,
    "zipcode": 7910,
    "city": "Wattripont"
  },
  {
    "id": 2144,
    "zipcode": 7911,
    "city": "Buissenal"
  },
  {
    "id": 2145,
    "zipcode": 7911,
    "city": "Frasnes-lez-Buissenal"
  },
  {
    "id": 2146,
    "zipcode": 7911,
    "city": "Hacquegnies"
  },
  {
    "id": 2147,
    "zipcode": 7911,
    "city": "Herquegies"
  },
  {
    "id": 2148,
    "zipcode": 7911,
    "city": "Montrul-au-Bois"
  },
  {
    "id": 2149,
    "zipcode": 7911,
    "city": "Moustier"
  },
  {
    "id": 2150,
    "zipcode": 7911,
    "city": "Oeudeghien"
  },
  {
    "id": 2151,
    "zipcode": 7912,
    "city": "Dergneau"
  },
  {
    "id": 2152,
    "zipcode": 7912,
    "city": "Saint-Sauveur"
  },
  {
    "id": 2153,
    "zipcode": 7940,
    "city": "Cambron-Casteau"
  },
  {
    "id": 2154,
    "zipcode": 7940,
    "city": "Brugelette"
  },
  {
    "id": 2155,
    "zipcode": 7941,
    "city": "Attre"
  },
  {
    "id": 2156,
    "zipcode": 7942,
    "city": "Mévergnies-lez-Lens"
  },
  {
    "id": 2157,
    "zipcode": 7943,
    "city": "Gages"
  },
  {
    "id": 2158,
    "zipcode": 7950,
    "city": "Grosage"
  },
  {
    "id": 2159,
    "zipcode": 7950,
    "city": "Huissignies"
  },
  {
    "id": 2160,
    "zipcode": 7950,
    "city": "Ladeuze"
  },
  {
    "id": 2161,
    "zipcode": 7950,
    "city": "Tongre-Saint-Martin"
  },
  {
    "id": 2162,
    "zipcode": 7950,
    "city": "Chièvres"
  },
  {
    "id": 2163,
    "zipcode": 7951,
    "city": "Tongre-Notre-Dame"
  },
  {
    "id": 2164,
    "zipcode": 7970,
    "city": "Beloeil"
  },
  {
    "id": 2165,
    "zipcode": 7971,
    "city": "Basècles"
  },
  {
    "id": 2166,
    "zipcode": 7971,
    "city": "Ramegnies"
  },
  {
    "id": 2167,
    "zipcode": 7971,
    "city": "Thumaide"
  },
  {
    "id": 2168,
    "zipcode": 7971,
    "city": "Wadelincourt"
  },
  {
    "id": 2169,
    "zipcode": 7972,
    "city": "Aubechies"
  },
  {
    "id": 2170,
    "zipcode": 7972,
    "city": "Ellignies-Sainte-Anne"
  },
  {
    "id": 2171,
    "zipcode": 7972,
    "city": "Quevaucamps"
  },
  {
    "id": 2172,
    "zipcode": 7973,
    "city": "Grandglise"
  },
  {
    "id": 2173,
    "zipcode": 7973,
    "city": "Stambruges"
  },
  {
    "id": 2174,
    "zipcode": 8000,
    "city": "Koolkerke"
  },
  {
    "id": 2175,
    "zipcode": 8000,
    "city": "Brugge"
  },
  {
    "id": 2176,
    "zipcode": 8020,
    "city": "Hertsberge"
  },
  {
    "id": 2177,
    "zipcode": 8020,
    "city": "Ruddervoorde"
  },
  {
    "id": 2178,
    "zipcode": 8020,
    "city": "Waardamme"
  },
  {
    "id": 2179,
    "zipcode": 8020,
    "city": "Oostkamp"
  },
  {
    "id": 2180,
    "zipcode": 8200,
    "city": "Sint-Andries"
  },
  {
    "id": 2181,
    "zipcode": 8200,
    "city": "Sint-Michiels"
  },
  {
    "id": 2182,
    "zipcode": 8210,
    "city": "Loppem"
  },
  {
    "id": 2183,
    "zipcode": 8210,
    "city": "Veldegem"
  },
  {
    "id": 2184,
    "zipcode": 8210,
    "city": "Zedelgem"
  },
  {
    "id": 2185,
    "zipcode": 8211,
    "city": "Aartrijke"
  },
  {
    "id": 2186,
    "zipcode": 8300,
    "city": "Knokke"
  },
  {
    "id": 2187,
    "zipcode": 8300,
    "city": "Westkapelle"
  },
  {
    "id": 2188,
    "zipcode": 8301,
    "city": "Heist-aan-Zee"
  },
  {
    "id": 2189,
    "zipcode": 8301,
    "city": "Ramskapelle"
  },
  {
    "id": 2190,
    "zipcode": 8310,
    "city": "Assebroek"
  },
  {
    "id": 2191,
    "zipcode": 8310,
    "city": "Sint-Kruis"
  },
  {
    "id": 2192,
    "zipcode": 8340,
    "city": "Hoeke"
  },
  {
    "id": 2193,
    "zipcode": 8340,
    "city": "Lapscheure"
  },
  {
    "id": 2194,
    "zipcode": 8340,
    "city": "Moerkerke"
  },
  {
    "id": 2195,
    "zipcode": 8340,
    "city": "Oostkerke"
  },
  {
    "id": 2196,
    "zipcode": 8340,
    "city": "Sijsele"
  },
  {
    "id": 2197,
    "zipcode": 8340,
    "city": "Damme"
  },
  {
    "id": 2198,
    "zipcode": 8370,
    "city": "Uitkerke"
  },
  {
    "id": 2199,
    "zipcode": 8370,
    "city": "Blankenberge"
  },
  {
    "id": 2200,
    "zipcode": 8377,
    "city": "Houtave"
  },
  {
    "id": 2201,
    "zipcode": 8377,
    "city": "Meetkerke"
  },
  {
    "id": 2202,
    "zipcode": 8377,
    "city": "Nieuwmunster"
  },
  {
    "id": 2203,
    "zipcode": 8377,
    "city": "Zuienkerke"
  },
  {
    "id": 2204,
    "zipcode": 8380,
    "city": "Dudzele"
  },
  {
    "id": 2205,
    "zipcode": 8380,
    "city": "Lissewege"
  },
  {
    "id": 2206,
    "zipcode": 8380,
    "city": "Zeebrugge"
  },
  {
    "id": 2207,
    "zipcode": 8400,
    "city": "Stene"
  },
  {
    "id": 2208,
    "zipcode": 8400,
    "city": "Zandvoorde"
  },
  {
    "id": 2209,
    "zipcode": 8400,
    "city": "Oostende"
  },
  {
    "id": 2210,
    "zipcode": 8420,
    "city": "Klemskerke"
  },
  {
    "id": 2211,
    "zipcode": 8420,
    "city": "Wenduine"
  },
  {
    "id": 2212,
    "zipcode": 8420,
    "city": "De Haan"
  },
  {
    "id": 2213,
    "zipcode": 8421,
    "city": "Vlissegem"
  },
  {
    "id": 2214,
    "zipcode": 8430,
    "city": "Middelkerke"
  },
  {
    "id": 2215,
    "zipcode": 8431,
    "city": "Wilskerke"
  },
  {
    "id": 2216,
    "zipcode": 8432,
    "city": "Leffinge"
  },
  {
    "id": 2217,
    "zipcode": 8433,
    "city": "Mannekensvere"
  },
  {
    "id": 2218,
    "zipcode": 8433,
    "city": "Schore"
  },
  {
    "id": 2219,
    "zipcode": 8433,
    "city": "Sint-Pieters-Kapelle"
  },
  {
    "id": 2220,
    "zipcode": 8433,
    "city": "Slijpe"
  },
  {
    "id": 2221,
    "zipcode": 8434,
    "city": "Lombardsijde"
  },
  {
    "id": 2222,
    "zipcode": 8434,
    "city": "Westende"
  },
  {
    "id": 2223,
    "zipcode": 8450,
    "city": "Bredene"
  },
  {
    "id": 2224,
    "zipcode": 8460,
    "city": "Ettelgem"
  },
  {
    "id": 2225,
    "zipcode": 8460,
    "city": "Roksem"
  },
  {
    "id": 2226,
    "zipcode": 8460,
    "city": "Westkerke"
  },
  {
    "id": 2227,
    "zipcode": 8460,
    "city": "Oudenburg"
  },
  {
    "id": 2228,
    "zipcode": 8470,
    "city": "Moere"
  },
  {
    "id": 2229,
    "zipcode": 8470,
    "city": "Snaaskerke"
  },
  {
    "id": 2230,
    "zipcode": 8470,
    "city": "Zevekote"
  },
  {
    "id": 2231,
    "zipcode": 8470,
    "city": "Gistel"
  },
  {
    "id": 2232,
    "zipcode": 8480,
    "city": "Bekegem"
  },
  {
    "id": 2233,
    "zipcode": 8480,
    "city": "Eernegem"
  },
  {
    "id": 2234,
    "zipcode": 8480,
    "city": "Ichtegem"
  },
  {
    "id": 2235,
    "zipcode": 8490,
    "city": "Snellegem"
  },
  {
    "id": 2236,
    "zipcode": 8490,
    "city": "Stalhille"
  },
  {
    "id": 2237,
    "zipcode": 8490,
    "city": "Varsenare"
  },
  {
    "id": 2238,
    "zipcode": 8490,
    "city": "Zerkegem"
  },
  {
    "id": 2239,
    "zipcode": 8490,
    "city": "Jabbeke"
  },
  {
    "id": 2240,
    "zipcode": 8500,
    "city": "Kortrijk"
  },
  {
    "id": 2241,
    "zipcode": 8501,
    "city": "Bissegem"
  },
  {
    "id": 2242,
    "zipcode": 8501,
    "city": "Heule"
  },
  {
    "id": 2243,
    "zipcode": 8510,
    "city": "Bellegem"
  },
  {
    "id": 2244,
    "zipcode": 8510,
    "city": "Kooigem"
  },
  {
    "id": 2245,
    "zipcode": 8510,
    "city": "Marke"
  },
  {
    "id": 2246,
    "zipcode": 8510,
    "city": "Rollegem"
  },
  {
    "id": 2247,
    "zipcode": 8511,
    "city": "Aalbeke"
  },
  {
    "id": 2248,
    "zipcode": 8520,
    "city": "Kuurne"
  },
  {
    "id": 2249,
    "zipcode": 8530,
    "city": "Harelbeke"
  },
  {
    "id": 2250,
    "zipcode": 8531,
    "city": "Bavikhove"
  },
  {
    "id": 2251,
    "zipcode": 8531,
    "city": "Hulste"
  },
  {
    "id": 2252,
    "zipcode": 8540,
    "city": "Deerlijk"
  },
  {
    "id": 2253,
    "zipcode": 8550,
    "city": "Zwevegem"
  },
  {
    "id": 2254,
    "zipcode": 8551,
    "city": "Heestert"
  },
  {
    "id": 2255,
    "zipcode": 8552,
    "city": "Moen"
  },
  {
    "id": 2256,
    "zipcode": 8553,
    "city": "Otegem"
  },
  {
    "id": 2257,
    "zipcode": 8554,
    "city": "Sint-Denijs"
  },
  {
    "id": 2258,
    "zipcode": 8560,
    "city": "Gullegem"
  },
  {
    "id": 2259,
    "zipcode": 8560,
    "city": "Moorsele"
  },
  {
    "id": 2260,
    "zipcode": 8560,
    "city": "Wevelgem"
  },
  {
    "id": 2261,
    "zipcode": 8570,
    "city": "Gijzelbrechtegem"
  },
  {
    "id": 2262,
    "zipcode": 8570,
    "city": "Ingooigem"
  },
  {
    "id": 2263,
    "zipcode": 8570,
    "city": "Vichte"
  },
  {
    "id": 2264,
    "zipcode": 8570,
    "city": "Anzegem"
  },
  {
    "id": 2265,
    "zipcode": 8572,
    "city": "Kaster"
  },
  {
    "id": 2266,
    "zipcode": 8573,
    "city": "Tiegem"
  },
  {
    "id": 2267,
    "zipcode": 8580,
    "city": "Avelgem"
  },
  {
    "id": 2268,
    "zipcode": 8581,
    "city": "Kerkhove"
  },
  {
    "id": 2269,
    "zipcode": 8581,
    "city": "Waarmaarde"
  },
  {
    "id": 2270,
    "zipcode": 8582,
    "city": "Outrijve"
  },
  {
    "id": 2271,
    "zipcode": 8583,
    "city": "Bossuit"
  },
  {
    "id": 2272,
    "zipcode": 8587,
    "city": "Helkijn"
  },
  {
    "id": 2273,
    "zipcode": 8587,
    "city": "Spiere"
  },
  {
    "id": 2274,
    "zipcode": 8600,
    "city": "Beerst"
  },
  {
    "id": 2275,
    "zipcode": 8600,
    "city": "Driekapellen"
  },
  {
    "id": 2276,
    "zipcode": 8600,
    "city": "Esen"
  },
  {
    "id": 2277,
    "zipcode": 8600,
    "city": "Kaaskerke"
  },
  {
    "id": 2278,
    "zipcode": 8600,
    "city": "Keiem"
  },
  {
    "id": 2279,
    "zipcode": 8600,
    "city": "Lampernisse"
  },
  {
    "id": 2280,
    "zipcode": 8600,
    "city": "Leke"
  },
  {
    "id": 2281,
    "zipcode": 8600,
    "city": "Nieuwkapelle"
  },
  {
    "id": 2282,
    "zipcode": 8600,
    "city": "Oostkerke"
  },
  {
    "id": 2283,
    "zipcode": 8600,
    "city": "Oudekapelle"
  },
  {
    "id": 2284,
    "zipcode": 8600,
    "city": "Pervijze"
  },
  {
    "id": 2285,
    "zipcode": 8600,
    "city": "Sint-Jacobs-Kapelle"
  },
  {
    "id": 2286,
    "zipcode": 8600,
    "city": "Stuivekenskerke"
  },
  {
    "id": 2287,
    "zipcode": 8600,
    "city": "Vladslo"
  },
  {
    "id": 2288,
    "zipcode": 8600,
    "city": "Woumen"
  },
  {
    "id": 2289,
    "zipcode": 8600,
    "city": "Diksmuide"
  },
  {
    "id": 2290,
    "zipcode": 8610,
    "city": "Handzame"
  },
  {
    "id": 2291,
    "zipcode": 8610,
    "city": "Werken"
  },
  {
    "id": 2292,
    "zipcode": 8610,
    "city": "Zarren"
  },
  {
    "id": 2293,
    "zipcode": 8610,
    "city": "Kortemark"
  },
  {
    "id": 2294,
    "zipcode": 8620,
    "city": "Ramskapelle"
  },
  {
    "id": 2295,
    "zipcode": 8620,
    "city": "Sint-Joris"
  },
  {
    "id": 2296,
    "zipcode": 8620,
    "city": "Nieuwpoort"
  },
  {
    "id": 2297,
    "zipcode": 8630,
    "city": "Avekapelle"
  },
  {
    "id": 2298,
    "zipcode": 8630,
    "city": "Booitshoeke"
  },
  {
    "id": 2299,
    "zipcode": 8630,
    "city": "Bulskamp"
  },
  {
    "id": 2300,
    "zipcode": 8630,
    "city": "De Moeren"
  },
  {
    "id": 2301,
    "zipcode": 8630,
    "city": "Eggewaartskapelle"
  },
  {
    "id": 2302,
    "zipcode": 8630,
    "city": "Houtem"
  },
  {
    "id": 2303,
    "zipcode": 8630,
    "city": "Steenkerke"
  },
  {
    "id": 2304,
    "zipcode": 8630,
    "city": "Vinkem"
  },
  {
    "id": 2305,
    "zipcode": 8630,
    "city": "Wulveringem"
  },
  {
    "id": 2306,
    "zipcode": 8630,
    "city": "Zoutenaaie"
  },
  {
    "id": 2307,
    "zipcode": 8630,
    "city": "Veurne"
  },
  {
    "id": 2308,
    "zipcode": 8640,
    "city": "Oostvleteren"
  },
  {
    "id": 2309,
    "zipcode": 8640,
    "city": "Westvleteren"
  },
  {
    "id": 2310,
    "zipcode": 8640,
    "city": "Woesten"
  },
  {
    "id": 2311,
    "zipcode": 8647,
    "city": "Lo"
  },
  {
    "id": 2312,
    "zipcode": 8647,
    "city": "Noordschote"
  },
  {
    "id": 2313,
    "zipcode": 8647,
    "city": "Pollinkhove"
  },
  {
    "id": 2314,
    "zipcode": 8647,
    "city": "Reninge"
  },
  {
    "id": 2315,
    "zipcode": 8650,
    "city": "Klerken"
  },
  {
    "id": 2316,
    "zipcode": 8650,
    "city": "Merkem"
  },
  {
    "id": 2317,
    "zipcode": 8650,
    "city": "Houthulst"
  },
  {
    "id": 2318,
    "zipcode": 8660,
    "city": "Adinkerke"
  },
  {
    "id": 2319,
    "zipcode": 8660,
    "city": "De Panne"
  },
  {
    "id": 2320,
    "zipcode": 8670,
    "city": "Oostduinkerke"
  },
  {
    "id": 2321,
    "zipcode": 8670,
    "city": "Wulpen"
  },
  {
    "id": 2322,
    "zipcode": 8670,
    "city": "Koksijde"
  },
  {
    "id": 2323,
    "zipcode": 8680,
    "city": "Bovekerke"
  },
  {
    "id": 2324,
    "zipcode": 8680,
    "city": "Zande"
  },
  {
    "id": 2325,
    "zipcode": 8680,
    "city": "Koekelare"
  },
  {
    "id": 2326,
    "zipcode": 8690,
    "city": "Hoogstade"
  },
  {
    "id": 2327,
    "zipcode": 8690,
    "city": "Oeren"
  },
  {
    "id": 2328,
    "zipcode": 8690,
    "city": "Sint-Rijkers"
  },
  {
    "id": 2329,
    "zipcode": 8690,
    "city": "Alveringem"
  },
  {
    "id": 2330,
    "zipcode": 8691,
    "city": "Beveren-aan-de-IJzer"
  },
  {
    "id": 2331,
    "zipcode": 8691,
    "city": "Gijverinkhove"
  },
  {
    "id": 2332,
    "zipcode": 8691,
    "city": "Izenberge"
  },
  {
    "id": 2333,
    "zipcode": 8691,
    "city": "Leisele"
  },
  {
    "id": 2334,
    "zipcode": 8691,
    "city": "Stavele"
  },
  {
    "id": 2335,
    "zipcode": 8700,
    "city": "Aarsele"
  },
  {
    "id": 2336,
    "zipcode": 8700,
    "city": "Kanegem"
  },
  {
    "id": 2337,
    "zipcode": 8700,
    "city": "Schuiferskapelle"
  },
  {
    "id": 2338,
    "zipcode": 8700,
    "city": "Tielt"
  },
  {
    "id": 2339,
    "zipcode": 8710,
    "city": "Ooigem"
  },
  {
    "id": 2340,
    "zipcode": 8710,
    "city": "Sint-Baafs-Vijve"
  },
  {
    "id": 2341,
    "zipcode": 8710,
    "city": "Wielsbeke"
  },
  {
    "id": 2342,
    "zipcode": 8720,
    "city": "Markegem"
  },
  {
    "id": 2343,
    "zipcode": 8720,
    "city": "Oeselgem"
  },
  {
    "id": 2344,
    "zipcode": 8720,
    "city": "Wakken"
  },
  {
    "id": 2345,
    "zipcode": 8720,
    "city": "Dentergem"
  },
  {
    "id": 2346,
    "zipcode": 8730,
    "city": "Oedelem"
  },
  {
    "id": 2347,
    "zipcode": 8730,
    "city": "Sint-Joris"
  },
  {
    "id": 2348,
    "zipcode": 8730,
    "city": "Beernem"
  },
  {
    "id": 2349,
    "zipcode": 8740,
    "city": "Egem"
  },
  {
    "id": 2350,
    "zipcode": 8740,
    "city": "Pittem"
  },
  {
    "id": 2351,
    "zipcode": 8750,
    "city": "Zwevezele"
  },
  {
    "id": 2352,
    "zipcode": 8750,
    "city": "Wingene"
  },
  {
    "id": 2353,
    "zipcode": 8755,
    "city": "Ruiselede"
  },
  {
    "id": 2354,
    "zipcode": 8760,
    "city": "Meulebeke"
  },
  {
    "id": 2355,
    "zipcode": 8770,
    "city": "Ingelmunster"
  },
  {
    "id": 2356,
    "zipcode": 8780,
    "city": "Oostrozebeke"
  },
  {
    "id": 2357,
    "zipcode": 8790,
    "city": "Waregem"
  },
  {
    "id": 2358,
    "zipcode": 8791,
    "city": "Beveren"
  },
  {
    "id": 2359,
    "zipcode": 8792,
    "city": "Desselgem"
  },
  {
    "id": 2360,
    "zipcode": 8793,
    "city": "Sint-Eloois-Vijve"
  },
  {
    "id": 2361,
    "zipcode": 8800,
    "city": "Beveren"
  },
  {
    "id": 2362,
    "zipcode": 8800,
    "city": "Oekene"
  },
  {
    "id": 2363,
    "zipcode": 8800,
    "city": "Rumbeke"
  },
  {
    "id": 2364,
    "zipcode": 8800,
    "city": "Roeselare"
  },
  {
    "id": 2365,
    "zipcode": 8810,
    "city": "Lichtervelde"
  },
  {
    "id": 2366,
    "zipcode": 8820,
    "city": "Torhout"
  },
  {
    "id": 2367,
    "zipcode": 8830,
    "city": "Gits"
  },
  {
    "id": 2368,
    "zipcode": 8830,
    "city": "Hooglede"
  },
  {
    "id": 2369,
    "zipcode": 8840,
    "city": "Oostnieuwkerke"
  },
  {
    "id": 2370,
    "zipcode": 8840,
    "city": "Westrozebeke"
  },
  {
    "id": 2371,
    "zipcode": 8840,
    "city": "Staden"
  },
  {
    "id": 2372,
    "zipcode": 8850,
    "city": "Ardooie"
  },
  {
    "id": 2373,
    "zipcode": 8851,
    "city": "Koolskamp"
  },
  {
    "id": 2374,
    "zipcode": 8860,
    "city": "Lendelede"
  },
  {
    "id": 2375,
    "zipcode": 8870,
    "city": "Emelgem"
  },
  {
    "id": 2376,
    "zipcode": 8870,
    "city": "Kachtem"
  },
  {
    "id": 2377,
    "zipcode": 8870,
    "city": "Izegem"
  },
  {
    "id": 2378,
    "zipcode": 8880,
    "city": "Rollegem-Kapelle"
  },
  {
    "id": 2379,
    "zipcode": 8880,
    "city": "Sint-Eloois-Winkel"
  },
  {
    "id": 2380,
    "zipcode": 8880,
    "city": "Ledegem"
  },
  {
    "id": 2381,
    "zipcode": 8890,
    "city": "Dadizele"
  },
  {
    "id": 2382,
    "zipcode": 8890,
    "city": "Moorslede"
  },
  {
    "id": 2383,
    "zipcode": 8900,
    "city": "Brielen"
  },
  {
    "id": 2384,
    "zipcode": 8900,
    "city": "Dikkebus"
  },
  {
    "id": 2385,
    "zipcode": 8900,
    "city": "Sint-Jan"
  },
  {
    "id": 2386,
    "zipcode": 8900,
    "city": "Ieper"
  },
  {
    "id": 2387,
    "zipcode": 8902,
    "city": "Hollebeke"
  },
  {
    "id": 2388,
    "zipcode": 8902,
    "city": "Voormezele"
  },
  {
    "id": 2389,
    "zipcode": 8902,
    "city": "Zillebeke"
  },
  {
    "id": 2390,
    "zipcode": 8904,
    "city": "Boezinge"
  },
  {
    "id": 2391,
    "zipcode": 8904,
    "city": "Zuidschote"
  },
  {
    "id": 2392,
    "zipcode": 8906,
    "city": "Elverdinge"
  },
  {
    "id": 2393,
    "zipcode": 8908,
    "city": "Vlamertinge"
  },
  {
    "id": 2394,
    "zipcode": 8920,
    "city": "Bikschote"
  },
  {
    "id": 2395,
    "zipcode": 8920,
    "city": "Langemark"
  },
  {
    "id": 2396,
    "zipcode": 8920,
    "city": "Poelkapelle"
  },
  {
    "id": 2397,
    "zipcode": 8930,
    "city": "Lauwe"
  },
  {
    "id": 2398,
    "zipcode": 8930,
    "city": "Rekkem"
  },
  {
    "id": 2399,
    "zipcode": 8930,
    "city": "Menen"
  },
  {
    "id": 2400,
    "zipcode": 8940,
    "city": "Geluwe"
  },
  {
    "id": 2401,
    "zipcode": 8940,
    "city": "Wervik"
  },
  {
    "id": 2402,
    "zipcode": 8950,
    "city": "Nieuwkerke"
  },
  {
    "id": 2403,
    "zipcode": 8951,
    "city": "Dranouter"
  },
  {
    "id": 2404,
    "zipcode": 8952,
    "city": "Wulvergem"
  },
  {
    "id": 2405,
    "zipcode": 8953,
    "city": "Wijtschate"
  },
  {
    "id": 2406,
    "zipcode": 8954,
    "city": "Westouter"
  },
  {
    "id": 2407,
    "zipcode": 8956,
    "city": "Kemmel"
  },
  {
    "id": 2408,
    "zipcode": 8957,
    "city": "Mesen"
  },
  {
    "id": 2409,
    "zipcode": 8958,
    "city": "Loker"
  },
  {
    "id": 2410,
    "zipcode": 8970,
    "city": "Reningelst"
  },
  {
    "id": 2411,
    "zipcode": 8970,
    "city": "Poperinge"
  },
  {
    "id": 2412,
    "zipcode": 8972,
    "city": "Krombeke"
  },
  {
    "id": 2413,
    "zipcode": 8972,
    "city": "Proven"
  },
  {
    "id": 2414,
    "zipcode": 8972,
    "city": "Roesbrugge-Haringe"
  },
  {
    "id": 2415,
    "zipcode": 8978,
    "city": "Watou"
  },
  {
    "id": 2416,
    "zipcode": 8980,
    "city": "Beselare"
  },
  {
    "id": 2417,
    "zipcode": 8980,
    "city": "Geluveld"
  },
  {
    "id": 2418,
    "zipcode": 8980,
    "city": "Passendale"
  },
  {
    "id": 2419,
    "zipcode": 8980,
    "city": "Zandvoorde"
  },
  {
    "id": 2420,
    "zipcode": 8980,
    "city": "Zonnebeke"
  },
  {
    "id": 2421,
    "zipcode": 9000,
    "city": "Gent"
  },
  {
    "id": 2422,
    "zipcode": 9030,
    "city": "Mariakerke"
  },
  {
    "id": 2423,
    "zipcode": 9031,
    "city": "Drongen"
  },
  {
    "id": 2424,
    "zipcode": 9032,
    "city": "Wondelgem"
  },
  {
    "id": 2425,
    "zipcode": 9040,
    "city": "Sint-Amandsberg"
  },
  {
    "id": 2426,
    "zipcode": 9041,
    "city": "Oostakker"
  },
  {
    "id": 2427,
    "zipcode": 9042,
    "city": "Desteldonk"
  },
  {
    "id": 2428,
    "zipcode": 9042,
    "city": "Mendonk"
  },
  {
    "id": 2429,
    "zipcode": 9042,
    "city": "Sint-Kruis-Winkel"
  },
  {
    "id": 2430,
    "zipcode": 9050,
    "city": "Gentbrugge"
  },
  {
    "id": 2431,
    "zipcode": 9050,
    "city": "Ledeberg"
  },
  {
    "id": 2432,
    "zipcode": 9051,
    "city": "Afsnee"
  },
  {
    "id": 2433,
    "zipcode": 9051,
    "city": "Sint-Denijs-Westrem"
  },
  {
    "id": 2434,
    "zipcode": 9052,
    "city": "Zwijnaarde"
  },
  {
    "id": 2435,
    "zipcode": 9060,
    "city": "Zelzate"
  },
  {
    "id": 2436,
    "zipcode": 9070,
    "city": "Heusden"
  },
  {
    "id": 2437,
    "zipcode": 9070,
    "city": "Destelbergen"
  },
  {
    "id": 2438,
    "zipcode": 9080,
    "city": "Beervelde"
  },
  {
    "id": 2439,
    "zipcode": 9080,
    "city": "Zaffelare"
  },
  {
    "id": 2440,
    "zipcode": 9080,
    "city": "Zeveneken"
  },
  {
    "id": 2441,
    "zipcode": 9080,
    "city": "Lochristi"
  },
  {
    "id": 2442,
    "zipcode": 9090,
    "city": "Gontrode"
  },
  {
    "id": 2443,
    "zipcode": 9090,
    "city": "Melle"
  },
  {
    "id": 2444,
    "zipcode": 9100,
    "city": "Nieuwkerken-Waas"
  },
  {
    "id": 2445,
    "zipcode": 9100,
    "city": "Sint-Niklaas"
  },
  {
    "id": 2446,
    "zipcode": 9111,
    "city": "Belsele"
  },
  {
    "id": 2447,
    "zipcode": 9112,
    "city": "Sinaai-Waas"
  },
  {
    "id": 2448,
    "zipcode": 9120,
    "city": "Beveren-Waas"
  },
  {
    "id": 2449,
    "zipcode": 9120,
    "city": "Haasdonk"
  },
  {
    "id": 2450,
    "zipcode": 9120,
    "city": "Kallo"
  },
  {
    "id": 2451,
    "zipcode": 9120,
    "city": "Melsele"
  },
  {
    "id": 2452,
    "zipcode": 9120,
    "city": "Vrasene"
  },
  {
    "id": 2453,
    "zipcode": 9130,
    "city": "Doel"
  },
  {
    "id": 2454,
    "zipcode": 9130,
    "city": "Kallo"
  },
  {
    "id": 2455,
    "zipcode": 9130,
    "city": "Kieldrecht"
  },
  {
    "id": 2456,
    "zipcode": 9130,
    "city": "Verrebroek"
  },
  {
    "id": 2457,
    "zipcode": 9140,
    "city": "Elversele"
  },
  {
    "id": 2458,
    "zipcode": 9140,
    "city": "Steendorp"
  },
  {
    "id": 2459,
    "zipcode": 9140,
    "city": "Tielrode"
  },
  {
    "id": 2460,
    "zipcode": 9140,
    "city": "Temse"
  },
  {
    "id": 2461,
    "zipcode": 9150,
    "city": "Bazel"
  },
  {
    "id": 2462,
    "zipcode": 9150,
    "city": "Kruibeke"
  },
  {
    "id": 2463,
    "zipcode": 9150,
    "city": "Rupelmonde"
  },
  {
    "id": 2464,
    "zipcode": 9160,
    "city": "Daknam"
  },
  {
    "id": 2465,
    "zipcode": 9160,
    "city": "Eksaarde"
  },
  {
    "id": 2466,
    "zipcode": 9160,
    "city": "Lokeren"
  },
  {
    "id": 2467,
    "zipcode": 9170,
    "city": "De Klinge"
  },
  {
    "id": 2468,
    "zipcode": 9170,
    "city": "Meerdonk"
  },
  {
    "id": 2469,
    "zipcode": 9170,
    "city": "Sint-Pauwels"
  },
  {
    "id": 2470,
    "zipcode": 9170,
    "city": "Sint-Gillis-Waas"
  },
  {
    "id": 2471,
    "zipcode": 9180,
    "city": "Moerbeke-Waas"
  },
  {
    "id": 2472,
    "zipcode": 9185,
    "city": "Wachtebeke"
  },
  {
    "id": 2473,
    "zipcode": 9190,
    "city": "Kemzeke"
  },
  {
    "id": 2474,
    "zipcode": 9190,
    "city": "Stekene"
  },
  {
    "id": 2475,
    "zipcode": 9200,
    "city": "Appels"
  },
  {
    "id": 2476,
    "zipcode": 9200,
    "city": "Baasrode"
  },
  {
    "id": 2477,
    "zipcode": 9200,
    "city": "Grembergen"
  },
  {
    "id": 2478,
    "zipcode": 9200,
    "city": "Mespelare"
  },
  {
    "id": 2479,
    "zipcode": 9200,
    "city": "Oudegem"
  },
  {
    "id": 2480,
    "zipcode": 9200,
    "city": "Schoonaarde"
  },
  {
    "id": 2481,
    "zipcode": 9200,
    "city": "Sint-Gillis-Dendermonde"
  },
  {
    "id": 2482,
    "zipcode": 9200,
    "city": "Dendermonde"
  },
  {
    "id": 2483,
    "zipcode": 9220,
    "city": "Moerzeke"
  },
  {
    "id": 2484,
    "zipcode": 9220,
    "city": "Hamme"
  },
  {
    "id": 2485,
    "zipcode": 9230,
    "city": "Massemen"
  },
  {
    "id": 2486,
    "zipcode": 9230,
    "city": "Westrem"
  },
  {
    "id": 2487,
    "zipcode": 9230,
    "city": "Wetteren"
  },
  {
    "id": 2488,
    "zipcode": 9240,
    "city": "Zele"
  },
  {
    "id": 2489,
    "zipcode": 9250,
    "city": "Waasmunster"
  },
  {
    "id": 2490,
    "zipcode": 9255,
    "city": "Opdorp"
  },
  {
    "id": 2491,
    "zipcode": 9255,
    "city": "Buggenhout"
  },
  {
    "id": 2492,
    "zipcode": 9260,
    "city": "Schellebelle"
  },
  {
    "id": 2493,
    "zipcode": 9260,
    "city": "Serskamp"
  },
  {
    "id": 2494,
    "zipcode": 9260,
    "city": "Wichelen"
  },
  {
    "id": 2495,
    "zipcode": 9270,
    "city": "Kalken"
  },
  {
    "id": 2496,
    "zipcode": 9270,
    "city": "Laarne"
  },
  {
    "id": 2497,
    "zipcode": 9280,
    "city": "Denderbelle"
  },
  {
    "id": 2498,
    "zipcode": 9280,
    "city": "Wieze"
  },
  {
    "id": 2499,
    "zipcode": 9280,
    "city": "Lebbeke"
  },
  {
    "id": 2500,
    "zipcode": 9290,
    "city": "Overmere"
  },
  {
    "id": 2501,
    "zipcode": 9290,
    "city": "Uitbergen"
  },
  {
    "id": 2502,
    "zipcode": 9290,
    "city": "Berlare"
  },
  {
    "id": 2503,
    "zipcode": 9300,
    "city": "Aalst"
  },
  {
    "id": 2504,
    "zipcode": 9308,
    "city": "Gijzegem"
  },
  {
    "id": 2505,
    "zipcode": 9308,
    "city": "Hofstade"
  },
  {
    "id": 2506,
    "zipcode": 9310,
    "city": "Baardegem"
  },
  {
    "id": 2507,
    "zipcode": 9310,
    "city": "Herdersem"
  },
  {
    "id": 2508,
    "zipcode": 9310,
    "city": "Meldert"
  },
  {
    "id": 2509,
    "zipcode": 9310,
    "city": "Moorsel"
  },
  {
    "id": 2510,
    "zipcode": 9320,
    "city": "Erembodegem"
  },
  {
    "id": 2511,
    "zipcode": 9320,
    "city": "Nieuwerkerken"
  },
  {
    "id": 2512,
    "zipcode": 9340,
    "city": "Impe"
  },
  {
    "id": 2513,
    "zipcode": 9340,
    "city": "Oordegem"
  },
  {
    "id": 2514,
    "zipcode": 9340,
    "city": "Smetlede"
  },
  {
    "id": 2515,
    "zipcode": 9340,
    "city": "Wanzele"
  },
  {
    "id": 2516,
    "zipcode": 9340,
    "city": "Lede"
  },
  {
    "id": 2517,
    "zipcode": 9400,
    "city": "Appelterre-Eichem"
  },
  {
    "id": 2518,
    "zipcode": 9400,
    "city": "Denderwindeke"
  },
  {
    "id": 2519,
    "zipcode": 9400,
    "city": "Lieferinge"
  },
  {
    "id": 2520,
    "zipcode": 9400,
    "city": "Nederhasselt"
  },
  {
    "id": 2521,
    "zipcode": 9400,
    "city": "Okegem"
  },
  {
    "id": 2522,
    "zipcode": 9400,
    "city": "Voorde"
  },
  {
    "id": 2523,
    "zipcode": 9400,
    "city": "Ninove"
  },
  {
    "id": 2524,
    "zipcode": 9401,
    "city": "Pollare"
  },
  {
    "id": 2525,
    "zipcode": 9402,
    "city": "Meerbeke"
  },
  {
    "id": 2526,
    "zipcode": 9403,
    "city": "Neigem"
  },
  {
    "id": 2527,
    "zipcode": 9404,
    "city": "Aspelare"
  },
  {
    "id": 2528,
    "zipcode": 9406,
    "city": "Outer"
  },
  {
    "id": 2529,
    "zipcode": 9420,
    "city": "Aaigem"
  },
  {
    "id": 2530,
    "zipcode": 9420,
    "city": "Bambrugge"
  },
  {
    "id": 2531,
    "zipcode": 9420,
    "city": "Burst"
  },
  {
    "id": 2532,
    "zipcode": 9420,
    "city": "Erondegem"
  },
  {
    "id": 2533,
    "zipcode": 9420,
    "city": "Erpe"
  },
  {
    "id": 2534,
    "zipcode": 9420,
    "city": "Mere"
  },
  {
    "id": 2535,
    "zipcode": 9420,
    "city": "Ottergem"
  },
  {
    "id": 2536,
    "zipcode": 9420,
    "city": "Vlekkem"
  },
  {
    "id": 2537,
    "zipcode": 9450,
    "city": "Denderhoutem"
  },
  {
    "id": 2538,
    "zipcode": 9450,
    "city": "Heldergem"
  },
  {
    "id": 2539,
    "zipcode": 9450,
    "city": "Haaltert"
  },
  {
    "id": 2540,
    "zipcode": 9451,
    "city": "Kerksken"
  },
  {
    "id": 2541,
    "zipcode": 9470,
    "city": "Denderleeuw"
  },
  {
    "id": 2542,
    "zipcode": 9472,
    "city": "iddergem"
  },
  {
    "id": 2543,
    "zipcode": 9473,
    "city": "Welle"
  },
  {
    "id": 2544,
    "zipcode": 9500,
    "city": "Goeferdinge"
  },
  {
    "id": 2545,
    "zipcode": 9500,
    "city": "Moerbeke"
  },
  {
    "id": 2546,
    "zipcode": 9500,
    "city": "Nederboelare"
  },
  {
    "id": 2547,
    "zipcode": 9500,
    "city": "Onkerzele"
  },
  {
    "id": 2548,
    "zipcode": 9500,
    "city": "Ophasselt"
  },
  {
    "id": 2549,
    "zipcode": 9500,
    "city": "Overboelare"
  },
  {
    "id": 2550,
    "zipcode": 9500,
    "city": "Viane"
  },
  {
    "id": 2551,
    "zipcode": 9500,
    "city": "Zarlardinge"
  },
  {
    "id": 2552,
    "zipcode": 9500,
    "city": "Geraardsbergen"
  },
  {
    "id": 2553,
    "zipcode": 9506,
    "city": "Grimminge"
  },
  {
    "id": 2554,
    "zipcode": 9506,
    "city": "idegem"
  },
  {
    "id": 2555,
    "zipcode": 9506,
    "city": "Nieuwenhove"
  },
  {
    "id": 2556,
    "zipcode": 9506,
    "city": "Schendelbeke"
  },
  {
    "id": 2557,
    "zipcode": 9506,
    "city": "Smeerebbe-Vloerzegem"
  },
  {
    "id": 2558,
    "zipcode": 9506,
    "city": "Waarbeke"
  },
  {
    "id": 2559,
    "zipcode": 9506,
    "city": "Zandbergen"
  },
  {
    "id": 2560,
    "zipcode": 9520,
    "city": "Bavegem"
  },
  {
    "id": 2561,
    "zipcode": 9520,
    "city": "Oombergen"
  },
  {
    "id": 2562,
    "zipcode": 9520,
    "city": "Vlierzele"
  },
  {
    "id": 2563,
    "zipcode": 9520,
    "city": "Zonnegem"
  },
  {
    "id": 2564,
    "zipcode": 9520,
    "city": "Sint-Lievens-Houtem"
  },
  {
    "id": 2565,
    "zipcode": 9521,
    "city": "Letterhoutem"
  },
  {
    "id": 2566,
    "zipcode": 9550,
    "city": "Hillegem"
  },
  {
    "id": 2567,
    "zipcode": 9550,
    "city": "Sint-Antelinks"
  },
  {
    "id": 2568,
    "zipcode": 9550,
    "city": "Sint-Lievens-Esse"
  },
  {
    "id": 2569,
    "zipcode": 9550,
    "city": "Steenhuize-Wijnhuize"
  },
  {
    "id": 2570,
    "zipcode": 9550,
    "city": "Woubrechtegem"
  },
  {
    "id": 2571,
    "zipcode": 9550,
    "city": "Herzele"
  },
  {
    "id": 2572,
    "zipcode": 9551,
    "city": "Ressegem"
  },
  {
    "id": 2573,
    "zipcode": 9552,
    "city": "Borsbeke"
  },
  {
    "id": 2574,
    "zipcode": 9570,
    "city": "Deftinge"
  },
  {
    "id": 2575,
    "zipcode": 9570,
    "city": "Sint-Maria-Lierde"
  },
  {
    "id": 2576,
    "zipcode": 9571,
    "city": "Hemelveerdegem"
  },
  {
    "id": 2577,
    "zipcode": 9572,
    "city": "Sint-Martens-Lierde"
  },
  {
    "id": 2578,
    "zipcode": 9600,
    "city": "Ronse"
  },
  {
    "id": 2579,
    "zipcode": 9620,
    "city": "Elene"
  },
  {
    "id": 2580,
    "zipcode": 9620,
    "city": "Erwetegem"
  },
  {
    "id": 2581,
    "zipcode": 9620,
    "city": "Godveerdegem"
  },
  {
    "id": 2582,
    "zipcode": 9620,
    "city": "Grotenberge"
  },
  {
    "id": 2583,
    "zipcode": 9620,
    "city": "Leeuwergem"
  },
  {
    "id": 2584,
    "zipcode": 9620,
    "city": "Oombergen"
  },
  {
    "id": 2585,
    "zipcode": 9620,
    "city": "Sint-Goriks-Oudenhove"
  },
  {
    "id": 2586,
    "zipcode": 9620,
    "city": "Sint-Maria-Oudenhove"
  },
  {
    "id": 2587,
    "zipcode": 9620,
    "city": "Strijpen"
  },
  {
    "id": 2588,
    "zipcode": 9620,
    "city": "Velzeke-Ruddershove"
  },
  {
    "id": 2589,
    "zipcode": 9620,
    "city": "Zottegem"
  },
  {
    "id": 2590,
    "zipcode": 9630,
    "city": "Beerlegem"
  },
  {
    "id": 2591,
    "zipcode": 9630,
    "city": "Dikkele"
  },
  {
    "id": 2592,
    "zipcode": 9630,
    "city": "Hundelgem"
  },
  {
    "id": 2593,
    "zipcode": 9630,
    "city": "Meilegem"
  },
  {
    "id": 2594,
    "zipcode": 9630,
    "city": "Munkzwalm"
  },
  {
    "id": 2595,
    "zipcode": 9630,
    "city": "Paulatem"
  },
  {
    "id": 2596,
    "zipcode": 9630,
    "city": "Roborst"
  },
  {
    "id": 2597,
    "zipcode": 9630,
    "city": "Rozebeke"
  },
  {
    "id": 2598,
    "zipcode": 9630,
    "city": "Sint-Blasius-Boekel"
  },
  {
    "id": 2599,
    "zipcode": 9630,
    "city": "Sint-Denijs-Boekel"
  },
  {
    "id": 2600,
    "zipcode": 9630,
    "city": "Sint-Maria-Latem"
  },
  {
    "id": 2601,
    "zipcode": 9636,
    "city": "Nederzwalm-Hermelgem"
  },
  {
    "id": 2602,
    "zipcode": 9660,
    "city": "Elst"
  },
  {
    "id": 2603,
    "zipcode": 9660,
    "city": "Everbeek"
  },
  {
    "id": 2604,
    "zipcode": 9660,
    "city": "Michelbeke"
  },
  {
    "id": 2605,
    "zipcode": 9660,
    "city": "Nederbrakel"
  },
  {
    "id": 2606,
    "zipcode": 9660,
    "city": "Opbrakel"
  },
  {
    "id": 2607,
    "zipcode": 9660,
    "city": "Sint-Maria-Oudenhove"
  },
  {
    "id": 2608,
    "zipcode": 9660,
    "city": "Zegelsem"
  },
  {
    "id": 2609,
    "zipcode": 9660,
    "city": "Brakel"
  },
  {
    "id": 2610,
    "zipcode": 9661,
    "city": "Parike"
  },
  {
    "id": 2611,
    "zipcode": 9667,
    "city": "Sint-Kornelis-Horebeke"
  },
  {
    "id": 2612,
    "zipcode": 9667,
    "city": "Sint-Maria-Horebeke"
  },
  {
    "id": 2613,
    "zipcode": 9680,
    "city": "Etikhove"
  },
  {
    "id": 2614,
    "zipcode": 9680,
    "city": "Maarke-Kerkem"
  },
  {
    "id": 2615,
    "zipcode": 9681,
    "city": "Nukerke"
  },
  {
    "id": 2616,
    "zipcode": 9688,
    "city": "Schorisse"
  },
  {
    "id": 2617,
    "zipcode": 9690,
    "city": "Berchem"
  },
  {
    "id": 2618,
    "zipcode": 9690,
    "city": "Kwaremont"
  },
  {
    "id": 2619,
    "zipcode": 9690,
    "city": "Ruien"
  },
  {
    "id": 2620,
    "zipcode": 9690,
    "city": "Zulzeke"
  },
  {
    "id": 2621,
    "zipcode": 9700,
    "city": "Bevere"
  },
  {
    "id": 2622,
    "zipcode": 9700,
    "city": "Edelare"
  },
  {
    "id": 2623,
    "zipcode": 9700,
    "city": "Eine"
  },
  {
    "id": 2624,
    "zipcode": 9700,
    "city": "Ename"
  },
  {
    "id": 2625,
    "zipcode": 9700,
    "city": "Heurne"
  },
  {
    "id": 2626,
    "zipcode": 9700,
    "city": "Leupegem"
  },
  {
    "id": 2627,
    "zipcode": 9700,
    "city": "Mater"
  },
  {
    "id": 2628,
    "zipcode": 9700,
    "city": "Melden"
  },
  {
    "id": 2629,
    "zipcode": 9700,
    "city": "Mullem"
  },
  {
    "id": 2630,
    "zipcode": 9700,
    "city": "Nederename"
  },
  {
    "id": 2631,
    "zipcode": 9700,
    "city": "Ooike"
  },
  {
    "id": 2632,
    "zipcode": 9700,
    "city": "Volkegem"
  },
  {
    "id": 2633,
    "zipcode": 9700,
    "city": "Welden"
  },
  {
    "id": 2634,
    "zipcode": 9700,
    "city": "Oudenaarde"
  },
  {
    "id": 2635,
    "zipcode": 9750,
    "city": "Huise"
  },
  {
    "id": 2636,
    "zipcode": 9750,
    "city": "Ouwegem"
  },
  {
    "id": 2637,
    "zipcode": 9750,
    "city": "Zingem"
  },
  {
    "id": 2638,
    "zipcode": 9770,
    "city": "Kruishoutem"
  },
  {
    "id": 2639,
    "zipcode": 9771,
    "city": "Nokere"
  },
  {
    "id": 2640,
    "zipcode": 9772,
    "city": "Wannegem-Lede"
  },
  {
    "id": 2641,
    "zipcode": 9790,
    "city": "Elsegem"
  },
  {
    "id": 2642,
    "zipcode": 9790,
    "city": "Moregem"
  },
  {
    "id": 2643,
    "zipcode": 9790,
    "city": "Ooike"
  },
  {
    "id": 2644,
    "zipcode": 9790,
    "city": "Petegem-aan-de-Schelde"
  },
  {
    "id": 2645,
    "zipcode": 9790,
    "city": "Wortegem"
  },
  {
    "id": 2646,
    "zipcode": 9800,
    "city": "Astene"
  },
  {
    "id": 2647,
    "zipcode": 9800,
    "city": "Bachte-Maria-Leerne"
  },
  {
    "id": 2648,
    "zipcode": 9800,
    "city": "Gottem"
  },
  {
    "id": 2649,
    "zipcode": 9800,
    "city": "Grammene"
  },
  {
    "id": 2650,
    "zipcode": 9800,
    "city": "Meigem"
  },
  {
    "id": 2651,
    "zipcode": 9800,
    "city": "Petegem-aan-de-Leie"
  },
  {
    "id": 2652,
    "zipcode": 9800,
    "city": "Sint-Martens-Leerne"
  },
  {
    "id": 2653,
    "zipcode": 9800,
    "city": "Vinkt"
  },
  {
    "id": 2654,
    "zipcode": 9800,
    "city": "Wontergem"
  },
  {
    "id": 2655,
    "zipcode": 9800,
    "city": "Zeveren"
  },
  {
    "id": 2656,
    "zipcode": 9800,
    "city": "Deinze"
  },
  {
    "id": 2657,
    "zipcode": 9810,
    "city": "Eke"
  },
  {
    "id": 2658,
    "zipcode": 9810,
    "city": "Nazareth"
  },
  {
    "id": 2659,
    "zipcode": 9820,
    "city": "Bottelare"
  },
  {
    "id": 2660,
    "zipcode": 9820,
    "city": "Lemberge"
  },
  {
    "id": 2661,
    "zipcode": 9820,
    "city": "Melsen"
  },
  {
    "id": 2662,
    "zipcode": 9820,
    "city": "Merelbeke"
  },
  {
    "id": 2663,
    "zipcode": 9820,
    "city": "Munte"
  },
  {
    "id": 2664,
    "zipcode": 9820,
    "city": "Schelderode"
  },
  {
    "id": 2665,
    "zipcode": 9830,
    "city": "Sint-Martens-Latem"
  },
  {
    "id": 2666,
    "zipcode": 9831,
    "city": "Deurle"
  },
  {
    "id": 2667,
    "zipcode": 9840,
    "city": "De Pinte"
  },
  {
    "id": 2668,
    "zipcode": 9840,
    "city": "Zevergem"
  },
  {
    "id": 2669,
    "zipcode": 9850,
    "city": "Hansbeke"
  },
  {
    "id": 2670,
    "zipcode": 9850,
    "city": "Landegem"
  },
  {
    "id": 2671,
    "zipcode": 9850,
    "city": "Merendree"
  },
  {
    "id": 2672,
    "zipcode": 9850,
    "city": "Nevele"
  },
  {
    "id": 2673,
    "zipcode": 9850,
    "city": "Poesele"
  },
  {
    "id": 2674,
    "zipcode": 9850,
    "city": "Vosselare"
  },
  {
    "id": 2675,
    "zipcode": 9860,
    "city": "Balegem"
  },
  {
    "id": 2676,
    "zipcode": 9860,
    "city": "Gijzenzele"
  },
  {
    "id": 2677,
    "zipcode": 9860,
    "city": "Landskouter"
  },
  {
    "id": 2678,
    "zipcode": 9860,
    "city": "Moortsele"
  },
  {
    "id": 2679,
    "zipcode": 9860,
    "city": "Scheldewindeke"
  },
  {
    "id": 2680,
    "zipcode": 9860,
    "city": "Oosterzele"
  },
  {
    "id": 2681,
    "zipcode": 9870,
    "city": "Machelen"
  },
  {
    "id": 2682,
    "zipcode": 9870,
    "city": "Olsene"
  },
  {
    "id": 2683,
    "zipcode": 9870,
    "city": "Zulte"
  },
  {
    "id": 2684,
    "zipcode": 9880,
    "city": "Lotenhulle"
  },
  {
    "id": 2685,
    "zipcode": 9880,
    "city": "Poeke"
  },
  {
    "id": 2686,
    "zipcode": 9880,
    "city": "Aalter"
  },
  {
    "id": 2687,
    "zipcode": 9881,
    "city": "Bellem"
  },
  {
    "id": 2688,
    "zipcode": 9890,
    "city": "Asper"
  },
  {
    "id": 2689,
    "zipcode": 9890,
    "city": "Baaigem"
  },
  {
    "id": 2690,
    "zipcode": 9890,
    "city": "Dikkelvenne"
  },
  {
    "id": 2691,
    "zipcode": 9890,
    "city": "Semmerzake"
  },
  {
    "id": 2692,
    "zipcode": 9890,
    "city": "Vurste"
  },
  {
    "id": 2693,
    "zipcode": 9890,
    "city": "Gavere"
  },
  {
    "id": 2694,
    "zipcode": 9900,
    "city": "Eeklo"
  },
  {
    "id": 2695,
    "zipcode": 9910,
    "city": "Knesselare"
  },
  {
    "id": 2696,
    "zipcode": 9910,
    "city": "Ursel"
  },
  {
    "id": 2697,
    "zipcode": 9920,
    "city": "Lovendegem"
  },
  {
    "id": 2698,
    "zipcode": 9921,
    "city": "Vinderhoute"
  },
  {
    "id": 2699,
    "zipcode": 9930,
    "city": "Zomergem"
  },
  {
    "id": 2700,
    "zipcode": 9931,
    "city": "Oostwinkel"
  },
  {
    "id": 2701,
    "zipcode": 9932,
    "city": "Ronsele"
  },
  {
    "id": 2702,
    "zipcode": 9940,
    "city": "Ertvelde"
  },
  {
    "id": 2703,
    "zipcode": 9940,
    "city": "Kluizen"
  },
  {
    "id": 2704,
    "zipcode": 9940,
    "city": "Sleidinge"
  },
  {
    "id": 2705,
    "zipcode": 9940,
    "city": "Evergem"
  },
  {
    "id": 2706,
    "zipcode": 9950,
    "city": "Waarschoot"
  },
  {
    "id": 2707,
    "zipcode": 9960,
    "city": "Assenede"
  },
  {
    "id": 2708,
    "zipcode": 9961,
    "city": "Boekhoute"
  },
  {
    "id": 2709,
    "zipcode": 9968,
    "city": "Bassevelde"
  },
  {
    "id": 2710,
    "zipcode": 9968,
    "city": "Oosteeklo"
  },
  {
    "id": 2711,
    "zipcode": 9970,
    "city": "Kaprijke"
  },
  {
    "id": 2712,
    "zipcode": 9971,
    "city": "Lembeke"
  },
  {
    "id": 2713,
    "zipcode": 9980,
    "city": "Sint-Laureins"
  },
  {
    "id": 2714,
    "zipcode": 9981,
    "city": "Sint-Margriete"
  },
  {
    "id": 2715,
    "zipcode": 9982,
    "city": "Sint-Jan-in-Eremo"
  },
  {
    "id": 2716,
    "zipcode": 9988,
    "city": "Waterland-Oudeman"
  },
  {
    "id": 2717,
    "zipcode": 9988,
    "city": "Watervliet"
  },
  {
    "id": 2718,
    "zipcode": 9990,
    "city": "Maldegem"
  },
  {
    "id": 2719,
    "zipcode": 9991,
    "city": "Adegem"
  },
  {
    "id": 2720,
    "zipcode": 9992,
    "city": "Middelburg"
  }
]
